import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Input,
  Text,
  Checkbox,
  CheckboxGroup,
  Stack,
  Heading,
  Textarea,
  IconButton,
  Image,
  InputGroup,
  Icon,
  VStack,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Flex,
  Divider,
  Spacer,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  UnorderedList,
  ListItem,
  SimpleGrid,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
} from "@chakra-ui/react";
import {
  addMedicalConditions,
  addSurgeries,
  addVaccination,
  addAllergies,
} from "../../../../middleware/services/messages";

import {
  GenerateDischargeSummaryFromTranscripts,
  GenerateDoctorNotesFromTranscripts,
  GenerateDoctorChatsFromTranscripts,
  GenerateDoctorPatientHistoryNotesFromTranscripts,
  ExtractAiRecommendMedicines,
  ExtractAiRecommendROS,
  ExtractAiRecommendOrders,
  ExtractAiPatientDataForAiraNotes,
  FetchMyHealthAIData,
} from "../../../../middleware/services/visits/aicalls";
import {
  GetAIMedicineComposition,
  GetDoctorMasterData,
  updateDoctorNotes,
  updateAIRAChatNotes,
  GetDoctorNotes,
} from "../../../../middleware/services/visits/patient-overview/updatedoctornotes";
import AIPhysicalExamCard from "./notes-cards/physical-exam-card";
import AiROSCard from "./notes-cards/ros-card";
import AiComplaintInputCard from "./notes-cards/complaint-card";
import AINotesAssessment from "./notes-cards/assessment-plans";
import AIHpiNotesCard from "./notes-cards/hpi-notes-card";
import useLoader from "../../../loader/loaderstates";
import Loader from "../../../loader/loader";
import AIFeedbackFooter from "../ai-feedback";
import AICPUFeedbackFooter from "../ai-feedback/cpu-feedback";
import ChatDisplay from "./chats-view";

import { CopyIcon } from "@chakra-ui/icons"; // Or import your custom icon if required
import { FaRegSave } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";
import { CgRemove } from "react-icons/cg";
import { COLORS } from "../../../styles/colors";
import PrimaryButton from "../../../primary-button";
import moment from "moment";
import DatePicker from "../../../date-picker";
import PrimaryInput from "../../../primary-input";
import DynamicModalForTwo from "../dynamic-modal-for-two";
import MiniDropdownInput from "../../../mini-dropdown";
import DropdownInput from "../../../dropdown-input";
import PrimaryAssessmentInput from "../assessment-input";
import AIRAVitalsForm from "./notes-cards/vital-card";
import { GetPatientHealthData } from "../../../../middleware/services/visits/patient-overview";
import { getProfile } from "../../../../middleware/services/profile";
import PrimaryButtonIcon from "../../../primary-button-icon";
import DropdownInputForVitals from "../../../dropdown-input-forVitals";
import { interval } from "date-fns";
import { SaveSummaryCallLog } from "../../../../middleware/services/dischargesummarynotes";
import { uploadImageCommonFunction } from "../../../../auth";
import { useNavigate } from "react-router-dom";
// import DropdownInputForVitals from "../../../dropdown-input-forVitals/index (3)";


const TranscriptNotesCard = ({
  patientId,
  doctorId,
  appointmentId,
  showSuccessToast,
  showErrorToast,
  transcriptionText,
  transcriptionArray,
  fromStartVisit,
  dischargeFlow,
  isIPDDischarge,
  ipdInput,
  buttonClicked
}) => {
  const useGPUChatbot = !!navigator.gpu;
    const navigate = useNavigate();
  const { isLoading, showLoader, dismissLoader } = useLoader();

  
  // const useGPUChatbot = false;
  // console.log("Used transcription", transcriptionText);

  //------------------------------Doctor Profile

  const [visitDate, setVisitDate] = useState("");
  const [visitTime, setVisitTime] = useState("");

  useEffect(() => {
    console.log(ipdInput, 'ipd input data')
    console.log(isIPDDischarge, 'isIpdDISCHREFE')
    console.log(buttonClicked, 'buttonClicked')

    
  }, [isIPDDischarge])

  const fetchDoctorNotesData = async () => {
    const inputToFetch = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
      },
    };
    showLoader();
    try {
      const data = await GetDoctorNotes(inputToFetch.input);

      const doctorsassessment = data?.output?.data?.doctorsassessment || [];
      console.log(doctorsassessment);
      const visitdate = moment(
        data?.output?.data?.info?.appointmentdate
      ).format("Do MMM, YYYY");
      const formattedTime = moment(
        data?.output?.data?.info?.appointment_time,
        "HH:mm"
      ).format("hh:mm A");
      setVisitDate(visitdate);
      setVisitTime(formattedTime);
    } catch (error) {
      console.error("Error fetching Doctor Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  const [shareChatSummary, setShareChatSummary] = useState(true);
  const [shareChatHistory, setShareChatHistory] = useState(true);
  const [shareDoctorNotes, setShareDoctorNotes] = useState(true);
  const [sharePatientHistory, setSharePatientHistory] = useState(true);

  const [shareReportDoctorEmail, setShareReportDoctorEmail] = useState("");
  // useEffect(() => {
  //   getDoctorProfile();
  //   if (fromStartVisit) {
  //     fetchDoctorNotesData();
  //   }
  // }, []);

  const [dischargeDisplaySettings, setDischargeDisplaySettings] = useState(null)
  const [otherTagsArray, setOtherTagsArray] = useState(null) 
  const [allAttributesArray, setAllAttributesArray] = useState(null)
  const getDoctorProfile = async () => {
    showLoader();
    try {
      var result = await getProfile({});
      if (result && result.ProfileOutput) {
        setShareReportDoctorEmail(result.ProfileOutput?.email);
        console.log('result.dischargesettingsdata:', result.dischargesettingsdata)
        setDischargeDisplaySettings(result.dischargesettingsdata)

        // Extract and convert all attributes with value 1
        // if (result.dischargesettingsdata) {
        //   const allAttributes = extractAllAttributes(result.dischargesettingsdata);
        //   setAllAttributesArray(allAttributes);
        //   console.log('All attributes with value 1:', allAttributes);
        // }

        let tagsArray = null;
        // Extract and convert Othertags to array of strings
        if (result.dischargesettingsdata && result.dischargesettingsdata.Othertags) {
          const otherTags = result.dischargesettingsdata.Othertags;
          
          if (Array.isArray(otherTags) && otherTags.length > 0) {
            const tagNames = otherTags.map(tagObj => {
              // Extract the key name from objects like { "treatment plan": 1 }
              return Object.keys(tagObj)[0];
            }).filter(Boolean); // Remove any null/undefined values
            
            tagsArray = tagNames;
            setOtherTagsArray(tagNames);
            console.log('Converted Othertags:', tagNames); // ['treatment plan', 'social history']
          } 
          }
      
      // Return the tags array so we can use it directly
      return tagsArray;
        //   else {
        //     setOtherTagsArray(null);
        //   }
        // } else {
        //   setOtherTagsArray(null);
        // }
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } 
    // finally {
    //   dismissLoader();
    // }
  };

  // Function to extract all attributes with value 1
const extractAllAttributes = (dischargeSettings) => {
  if (!dischargeSettings) return null;
  
  const attributes = [];
  
  // List of attributes to check
  const attributeKeys = [
    'diagnosis', 'complaints', 'findings', 'investigation', 
    'medication', 'history', 'procedure', 'course', 
    'patientdetails', 'admissiondetails', 'instruction', 'followup'
  ];
  
  // Add attributes with value 1
  attributeKeys.forEach(key => {
    if (dischargeSettings[key] === 1) {
      attributes.push(key);
    }
  });
  
  // Add Othertags
  if (dischargeSettings.Othertags && Array.isArray(dischargeSettings.Othertags)) {
    dischargeSettings.Othertags.forEach(tagObj => {
      if (typeof tagObj === 'object' && tagObj !== null) {
        const keys = Object.keys(tagObj);
        if (keys.length > 0 && tagObj[keys[0]] === 1) {
          attributes.push(keys[0]);
        }
      }
    });
  }
  
  return attributes.length > 0 ? attributes : null;
};

  const shareNotesOnEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(shareReportDoctorEmail)) {
      showErrorToast("Invalid email address. Please enter a valid email.");
      return;
    }
    const inputToMail = {
      doctorid: doctorId,
      appointmentid: appointmentId,
      doctormail: shareReportDoctorEmail,
      patient_info: {
        name:
          patientHealthData?.patientinfo?.firstname +
          " " +
          patientHealthData?.patientinfo?.lastname,
        bmi: navHeaderOverviewData,
        appointementdate: visitDate,
        appointmenttime: visitTime,
      },
      patient_history: sharePatientHistory
        ? {
            medicalconditions: aiPatientMedicalConditions,
            medications: aiPatientMedications,
            surgeries: aiPatientSurgeries,
            allergies: aiPatientAllergies,
            vaccinations: aiPatientVaccinations,
            socialhistory: aiPatientSocialHistory,
          }
        : null,
      doctor_notes: shareDoctorNotes
        ? {
            chiefcomplaint: aiCc,
            hpi: aiHpiText,
            ros: aiRosText,
            physicalexam: aiPhysicalExamText,
            assessment_plan: aiAssessmentPlanArray,
            medicine: aiPrescribedMedicinesText,
            labs: aiPrescribedLabsText,
            imaging: aiPrescribedImagingText,
            procedures: aiPrescribedProceduresText,
            vitals: aiPatientVitals,
          }
        : null,
      chat_summary: shareChatSummary ? aiTranscriptSummary : null,
      chats: shareChatHistory ? aiTranscriptChats : null,
    };
    showLoader();
    try {
      // var result = await getProfile(inputToMail);
      console.log(inputToMail);
      var result = "";
      if (result) {
        showSuccessToast("Email sent!");
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  //------------------------------Patient BMI

  const [patientHealthData, setPatientHealthData] = useState(null);
  const [navHeaderOverviewData, setNavHeaderOverviewData] = useState(null);
  let overviewInfo = "";
  const [inputData, setInputData] = useState({
    patientid: patientId,
    // appointmentid: appointmentId,
    doctorid: doctorId,
  });
  const fetchPatientHealthData = async () => {
    if (fromStartVisit) {
      showLoader();
      try {
        const data = await GetPatientHealthData(inputData);
        // console.log(data);
        setPatientHealthData(data);
        if (data) {
          const {
            gender,
            dob,
            bloodtype,
            countrycode,
            mobileno,
            height,
            heightunit,
            weight,
            weightunit,
            bmi,
          } = data.patientinfo;

          // console.log(patientHealthData.patientinfo)
          // console.log(patientHealthData)

          const formattedGender = gender
            ? gender.charAt(0).toUpperCase() + gender.slice(1)
            : null;
          const dobInYears = dob ? calculateAge(dob) : null;
          const formattedBloodType = bloodtype || null;
          const formattedCountryCode = countrycode || null;
          const formattedMobileNo = mobileno || null;
          const formattedHeight =
            height && heightunit ? `${height} ${heightunit}` : null;
          const formattedWeight =
            weight && weightunit ? `${weight} ${weightunit}` : null;
          const formattedBMI = bmi || null;

          const overviewData = [
            formattedGender,
            dobInYears ? `${dobInYears} years` : null,
            formattedBloodType,
            formattedCountryCode && formattedMobileNo
              ? `(${formattedCountryCode}) ${formattedMobileNo}`
              : null,
            formattedHeight,
            formattedWeight,
            formattedBMI ? `${formattedBMI} BMI` : null,
          ]
            .filter((item) => item !== null)
            .join(", ");

          setNavHeaderOverviewData(overviewData);
          // overviewInfo =overviewData
          // console.log(overviewData)
          // console.log(overviewInfo)
        }
      } catch (error) {
        console.error("Error fetching patient health data:", error);
      } finally {
        dismissLoader();
      }
    }
  };

  /// Call fetchPatientHealthData function whenever inputData or formattedInput changes
  useEffect(() => {
    fetchPatientHealthData();
  }, [inputData]);

  function calculateAge(dob) {
    if (!dob) {
      return "";
    }

    const dobDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDifference = today.getMonth() - dobDate.getMonth();
    const dayDifference = today.getDate() - dobDate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }

  //------------------------------Saving mechanism
  const UpdateChiefComplaint = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        chiefcomplaint: data,
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Chief Complaint Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  const UpdateHpiTextBox = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        hpitext: {
          description: data,
          type: "other",
        },
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("HPI Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  const UpdatePhysicalExamTextBox = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        physicalexamtext: {
          description: data,
          type: "other",
        },
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Physical Exam Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  function transformOrdersAIArray(type, inputArray) {
    if (!Array.isArray(inputArray)) {
      throw new Error("The second argument must be an array.");
    }

    return inputArray.map((item) => {
      if (!item.name) {
        throw new Error(
          "Each object in the array must have a 'name' property."
        );
      }

      return {
        id: null,
        entitytype: type,
        ordername: item.name,
      };
    });
  }

  const AddToOrder = async (type, list) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        [type]: transformOrdersAIArray(type, list),
      },
    };
    console.log(inputToSave);
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      console.log(result);
      if (result) {
        showSuccessToast(`${type} Saved successfully.`);
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    }
  };

  const fetchExtractRecommendedOrders = async (data, type) => {
    showLoader();
    const input = {
      orders_text: data,
      order_type: type,
    };
    const response = await ExtractAiRecommendOrders(input);
    console.log("extract order response", response);
    if (response && response?.orders && response?.orders?.length > 0) {
      await AddToOrder(type, response?.orders);
    }
    dismissLoader();
  };

  const aiRecommendMedicineRef = useRef();

  const [editMedicine, setEditMedicine] = useState(null);

  const [recommendMedicinesAiResponse, setRecommendMedicinesAiResponse] =
    useState([]);

  const [
    selectedRecommendedMedicinesAiResponses,
    setSelectedRecommendedMedicinesAiResponses,
  ] = useState([]);

  const today = moment().format("DD-MM-YYYY");
  const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");
  const handleEditMedicine = (medicine) => {
    // const medicinetoedit = {
    //   id: medicine.id,
    //   medicinename: medicine.name,
    //   composition: medicine.composition,
    //   medicinetype: "Tablet",
    //   dosage: "",
    //   dosageunit: "mg",
    //   medicationstartdate: today, // SETTING DEFAULTS
    //   medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
    //   frequency: 1, // SETTING DEFAULTS
    //   morning: 1, // SETTING DEFAULTS
    //   evening: 0,
    //   night: 0,
    //   prescribedby: "",
    //   hospitalname: "",
    //   beforefood: 1, // SETTING DEFAULTS
    //   afterfood: 0,
    //   // issaved: false,
    // };
    console.log('medicine recommentded: ', medicine)
    setEditMedicine(medicine);
  };

  const [dropdownMedType, setDropdownMedType] = useState("");
  const additionalMedicineTypes = [
    "Respules",
    "Suspension",
    "Foam",
    "Suppository",
    "EA",
    "Device",
    // "Sachet",
    "Box",
    "Spray",
    "Lotion",
    "Tube",
    "Gargle",
    "Powder",
    "Soap",
    "Aerosol",
    "Shampoo",
    "Topical Cleanser",
    "Custom"
  ];
  
  const handleEditTypeChange = (value) => {
    if (additionalMedicineTypes.includes(value)) {
      setDropdownMedType(value);
      handleEditMedicineChange("medicinetype", value);
    } else {
      setDropdownMedType("");
      handleEditMedicineChange("medicinetype", value);
    }
  
    // Set default dosage units based on medicine type
    if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
      handleEditMedicineChange("dosageunit", "ml");
    } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
      handleEditMedicineChange("dosageunit", "mg");
    } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
      handleEditMedicineChange("dosageunit", "ml");
    } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
      handleEditMedicineChange("dosageunit", "grms");
    } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
      handleEditMedicineChange("dosageunit", "puffs");
    } else if (["EA", "Device", "Box"].includes(value)) {
      handleEditMedicineChange("dosageunit", "each");
    } else if (value === "Sachet") {
      handleEditMedicineChange("dosageunit", "mg");
    } else if (value === "Custom") {
      handleEditMedicineChange("dosageunit", "");
    }
  };

  const handleEditMedicineChange = (field, value) => {
    setEditMedicine((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveEditMedicine = () => {
    if (editMedicine.medicinename === "") {
      showErrorToast("Please enter medicine name to continue");
      return;
    }
    setRecommendMedicinesAiResponse((prev) =>
      prev.map((m) => (m.id === editMedicine.id ? editMedicine : m))
    );

    // console.log(selectedMedicines);
    setEditMedicine(null);
  };

  const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box

  const fetchCompositionForEdit = async (medicineName) => {
    if (!medicineName) {
      showErrorToast("Please enter medicine name first to fetch composition");
    } else {
      const inputData = {
        input: {
          name: medicineName,
        },
      };

      // console.log(inputData.input);

      try {
        // showLoader();
        // console.log(inputData);
        const result = await GetAIMedicineComposition(inputData.input);
        // console.log(result);
        if (result) {
          showSuccessToast("Fetched Medicine composition successfully");
          handleEditMedicineChange("composition", result.chemical_composition);
          setCompositionEditKey((prevKey) => prevKey + 1);
          // handleNewMedicineChange("medicinetype", result.type);
        }
      } catch (error) {
        console.error("Error Fetching Medicine composition:", error);
        showErrorToast("An error occurred while Fetching Medicine composition");
      } finally {
        // dismissLoader();
      }

      // fetchDoctorNotes();

      // console.log("Clicked");
    }
  };

  const fetchExtractRecommendedMedicines = async (data) => {
    showLoader();
    const input = {
      medicine_text: data,
    };
    const response = await ExtractAiRecommendMedicines(input);
    console.log("extract medicine response", response);
    if (response && response?.medicines && response?.medicines?.length > 0) {
      // Adding defaults to ai response

      const formattedMedicines = response?.medicines?.map(
        (medicine, index) => ({
          id: index, // Setting the id as the index of the object
          medicinename: medicine.name,
          composition: medicine.composition,
          medicinetype: "Tablet",
          dosage: medicine.strength || "",
          dosageunit: medicine.strength_unit,
          durationunit: medicine.interval_unit,
          durationvalue: medicine.interval,
          instructions: medicine.instructions,
          // dosage: "",
          // dosageunit: "mg",
          medicationstartdate: today, // Default to today
          medicationenddate: fiveDaysFromToday, // Default to 5 days from today
          frequency: medicine.consumption_frequency || "1", // Default value
          frequencytime: "", // Default value
          frequencyvalue: "", // Default value
          morning: 1, // Default value
          evening: 0, // Default value
          night: 0, // Default value
          prescribedby: "",
          hospitalname: "",
          beforefood: medicine.before_food || "1", // Default value
          afterfood: medicine.after_food || "0", // Default value
          // beforefood: , // Default value
          // afterfood: 0, // Default value
          from: medicine?.source,
          reason: medicine?.reason,
          // issaved: false, // Default value
        })
      );

      setRecommendMedicinesAiResponse(formattedMedicines);

      // setRecommendMedicinesAiResponse(response?.recommended_medicines);
      setSelectedRecommendedMedicinesAiResponses([]);

      setEditMedicine(null);
      aiRecommendMedicineRef.current.openModal();
    }

    dismissLoader();
  };

  // Toggle selection of AI responses
  const handleRecommendedMedicinesCheckboxChange = (index) => {
    setSelectedRecommendedMedicinesAiResponses((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index]
    );
  };

  const formatDate = (date) => {
    // Check if the date is already in YYYY-MM-DD format
    if (moment(date, "YYYY-MM-DD", true).isValid()) {
      return date;
    }
    // If not, assume it's in DD-MM-YYYY format and convert it to YYYY-MM-DD
    return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
  };

  const saveSelectedRecommendedMedicinesToOrder = async () => {
    // console.log(selectedRecommendedMedicinesAiResponses); // list of index

    // fetch medicine stored at those index
    const medicinesSelected = selectedRecommendedMedicinesAiResponses.map(
      (index) => recommendMedicinesAiResponse[index]
    );

    // console.log(medicinesSelected);

    const recommendedMedicinesToSave = medicinesSelected.map(
      (medicine, index) => ({
        id: null,
        isactive: 1,
        medicinename: medicine.medicinename,
        chemical_composition: medicine.composition,
        medicinetype: medicine.medicinetype,
        dosage: medicine.dosage,
        dosageunit: medicine.dosageunit,
        // startdate: moment(medicine.medicationstartdate).format("YYYY-MM-DD"),
        // enddate: moment(medicine.medicationenddate).format("YYYY-MM-DD"),
        startdate: formatDate(medicine.medicationstartdate),
        enddate: formatDate(medicine.medicationenddate),
        frequency: medicine.frequency,
        frequencytime: medicine.frequencytime,
        frequencyvalue: medicine.frequencyvalue,
        morning: medicine.morning,
        evening: medicine.evening,
        night: medicine.night,
        // prescribedby: "",
        // hospitalname: "",
        beforefood: medicine.beforefood,
        afterfood: medicine.afterfood,
      })
    );

    const inputData = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
        // medicinedetail: recommendedMedicinesToSave,
        ...(recommendedMedicinesToSave.length > 0 && {
          medicinedetail: recommendedMedicinesToSave,
        }),
      },
    };

    // console.log(inputData);
    try {
      showLoader();
      const result = await updateDoctorNotes(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Selected items saved to orders successfully");
      }
    } catch (error) {
      console.error("Error adding medicine to orders:", error);
      showErrorToast("An error occurred while adding medicine to orders");
    } finally {
      dismissLoader();
    }
  };

  const SaveIndividualAssessmentPlan = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        doctorsassessment: [
          {
            diagnosis: data.diagnosis,
            plan: data.plan,
            diagnosisid: null, // Use saved ID if it exists
          },
        ],
      },
    };
    showLoader();

    try {
      console.log("input send", inputToSave.input);
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Assessments Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  const [aiRosResponse, setAiRosResponse] = useState({});

  const aiROSReviewRef = useRef();

  const fetchExtractRos = async (data) => {
    showLoader();
    const input = {
      ros_text: data,
      ros: inputROSMasterData,
    };
    const response = await ExtractAiRecommendROS(input);
    console.log("extract order response", response);
    if (response && response?.ros) {
      setAiRosResponse(response);
      aiROSReviewRef.current.openModal();
    }
    dismissLoader();
  };

  const UpdateROSTextBox = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        rostext: {
          description: data,
          type: "other",
        },
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("ROS Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  //------------------------------Save Patient Data

  const [patientPastData, setPatientPastData] = useState(null);

  useEffect(() => {
    const fetchHealthData = async () => {
      try {
        const result = await FetchMyHealthAIData(
          {},
          patientId,
          "unavailable", // Setting patientname to "unavailable"
          "unavailable", // Setting patientgender to "unavailable"
          "unavailable" // Setting patientage to "unavailable"
        );
        setPatientPastData(result);
      } catch (error) {
        console.error("Error fetching health data:", error);
      }
    };

    if (fromStartVisit) {
      fetchHealthData();
    }
  }, [patientId]);

  function transformMedicalConditionsArray(inputArray) {
    return inputArray.map((item) => ({
      conditiontype_cd: null,
      condition_cd: null,
      nomenclatureid: null,
      conditionidentifieddate: item.date,
      condition: item.name,
      conditiontype: "other",
    }));
  }

  const addMedicalCondition = async (input_text) => {
    showLoader();

    const input = {
      type: "medical_condition",
      text: input_text,
      patient_data: patientPastData,
    };
    const response = await ExtractAiPatientDataForAiraNotes(input);
    const inputForAdd = {
      patientid: patientId,
      doctorid: doctorId,
      medicalcondition: transformMedicalConditionsArray(
        response?.medical_conditions ? response?.medical_conditions : []
      ),
    };
    try {
      const result = await addMedicalConditions(inputForAdd);
      if (result.output.result == "success") {
        showSuccessToast("Successfully Added Condition");
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in Condition:", error);
    }
    dismissLoader();
  };

  function transformProceduresArray(inputArray) {
    return inputArray.map((item) => ({
      proceduredate: item.date,
      proceduretype_cd: "1",
      procedure_cd: null,
      proceduretitle: item.name,
      nomenclatureid: null,
      hospitalid: "1",
      hospitalname: "",
      surgeonname: "",
      documenttype_cd: "",
      documentcategory_cd: "",
      documentname: "",
      documentsize: "",
      documenturl: "www.google.com",
      documents: [],
      proceduretype: "other",
    }));
  }

  const addProcedures = async (input_text) => {
    showLoader();

    const input = {
      type: "surgery",
      text: input_text,
      patient_data: patientPastData,
    };
    const response = await ExtractAiPatientDataForAiraNotes(input);
    const inputForAdd = {
      patientid: patientId,
      doctorid: doctorId,
      procedures: transformProceduresArray(
        response?.surgeries ? response?.surgeries : []
      ),
    };
    try {
      const result = await addSurgeries(inputForAdd);
      if (result.output.result == "Successfully Inserted") {
        showSuccessToast("Successfully Added Procedure");
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in Procedure:", error);
    }
    dismissLoader();
  };

  function transformToAllergyArray(inputArray) {
    return inputArray.map((item) => ({
      condition: item.name,
      condition_cd: null,
      allergytype_cd: null,
      allergyidentifieddate: item.date,
      conditiontype: "other",
      reactions: [
        {
          reaction_cd: null,
          reaction: "No reactions",
        },
      ],
      documents: [],
    }));
  }

  const addAllergicConditions = async (input_text) => {
    showLoader();

    const input = {
      type: "allergy",
      text: input_text,
      patient_data: patientPastData,
    };
    const response = await ExtractAiPatientDataForAiraNotes(input);
    const inputForAdd = {
      patientid: patientId,
      doctorid: doctorId,
      allergy: transformToAllergyArray(
        response?.allergies ? response?.allergies : []
      ),
    };
    try {
      const result = await addAllergies(inputForAdd);
      if (result.output.result == "success") {
        showSuccessToast("Successfully Added Allergies");
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in allergies:", error);
    }
    dismissLoader();
  };

  function transformToVaccineArray(inputArray) {
    return inputArray.map((item) => ({
      vaccine_cd: null,
      vaccinename: item.name,
      admindate: item.date,
      duedate: null,
    }));
  }

  const addVaccinations = async (input_text) => {
    showLoader();

    const input = {
      type: "vaccination",
      text: input_text,
      patient_data: patientPastData,
    };
    const response = await ExtractAiPatientDataForAiraNotes(input);
    const inputForAdd = {
      patientid: patientId,
      doctorid: doctorId,
      vaccination: transformToVaccineArray(
        response?.vaccinations ? response?.vaccinations : []
      ),
    };
    try {
      const result = await addVaccination(inputForAdd);
      if (result.output.result == "success") {
        showSuccessToast("Successfully Added Vaccination");
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in Vaccination:", error);
    }
    dismissLoader();
  };

  function transformVitals(inputArray) {
    // Map of vital names to their corresponding type code and unit
    const vitalMap = {
      "Body Temperature": { vitaltype_cd: 232, vitalunit: "°C" },
      "Respiratory Rate": { vitaltype_cd: 235, vitalunit: "bpm" },
      Pulse: { vitaltype_cd: 233, vitalunit: "bpm" },
      "Systolic Blood Pressure": { vitaltype_cd: 234, vitalunit: "mmHg" },
      "Diastolic Blood Pressure": { vitaltype_cd: 234, vitalunit: "mmHg" },
      "Oxygen Saturation": { vitaltype_cd: 236, vitalunit: "%" },
      "Fasting Blood Glucose": { vitaltype_cd: 0, vitalunit: "mg/dL" },
      "Postprandial Blood Glucose": { vitaltype_cd: 0, vitalunit: "mg/dL" },
    };

    // Current timestamp
    const currentTimestamp = new Date().toISOString();

    // Check if input is empty
    if (!inputArray || inputArray.length === 0) {
      return null;
    }

    // Transform the input array
    return inputArray
      .filter((item) => item.name && item.value)
      .map((item) => {
        const vitalInfo = vitalMap[item.name] || {};

        // Adjust temperature unit based on value
        let vitalunit = vitalInfo.vitalunit;
        if (item.name === "Body Temperature" && item.value) {
          const tempValue = parseFloat(item.value);
          if (!isNaN(tempValue)) {
            vitalunit = tempValue < 60 ? "°C" : "°F";
          }
        }

        return {
          vitalname: item.name,
          vitalvalue: item.value,
          vitalunit: vitalunit || null,
          vitaltype_cd: vitalInfo.vitaltype_cd || null,
          vitaladdeddate: currentTimestamp,
          createdby: null,
        };
      });
  }

  const aiVitalsReviewRef = useRef();
  const [aiVitalsResponse, setAiVitalsResponse] = useState({});

  const addVitals = async (input_text) => {
    showLoader();

    const input = {
      type: "vitals",
      text: input_text,
      patient_data: patientPastData,
    };
    const response = await ExtractAiPatientDataForAiraNotes(input);
    console.log(response);

    try {
      if (response) {
        setAiVitalsResponse(response);
        aiVitalsReviewRef.current.openModal();
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in Vitals:", error);
    }
    dismissLoader();
  };

  //------------------------------AI Feedback

  const [aiInputForFeedback, setAiInputForFeedback] = useState({});
  const [aiOutputForFeedback, setAiOutputForFeedback] = useState({});

  //--------------------------------

  const [inputHPIMasterData, setInputHPIMasterData] = useState([]);
  const [inputROSMasterData, setInputROSMasterData] = useState([]);
  const [inputPhysicalExamMasterData, setInputPhysicalExamMasterData] =
    useState([]);
  const [aiResponse, setAiResponse] = useState(null);
  const [aiDischargeResponse, setAiDischargeResponse] = useState(null);

  // Helper function to format time
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60); // Remove decimals
    return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
  };

  const fetchMasterData = async (category) => {
    showLoader();
    try {
      const inputData = { input: { type: category } };
      const data = await GetDoctorMasterData(inputData.input);
      return data;
    } catch (error) {
      console.error("Error fetching Master data:", error);
      return [];
    } finally {
      dismissLoader();
    }
  };

  // newly added useEffect
  // Add this useEffect to trigger fetchAiraGeneratedNotes when allAttributesArray is ready

  useEffect(() => {
  const fetchData = async () => {
    try {
      // First, wait for doctor profile to load and get the tags directly
      const tagsArray = await getDoctorProfile();
      // await getDoctorProfile();
      
      if (fromStartVisit) {
        await fetchDoctorNotesData();
      }

      console.log('displayin notes dischargeFlwo: ', dischargeFlow);
      await fetchAiraGeneratedNotes(tagsArray);
      // await fetchAiraGeneratedNotes();
      
      if(!isIPDDischarge) {
        await fetchChatsAndSummary();
      }
      
      if(!dischargeFlow && !isIPDDischarge) {
        await fetchPatientHistoryData();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();
}, []);
  // existing we were using
// useEffect(() => {
//   // if (otherTagsArray !== null) { // Only trigger when attributes are loaded
//     const fetchData = async () => {
//       try {
//         console.log('displayin notes dischargeFlwo: ', dischargeFlow)
//         await fetchAiraGeneratedNotes();
        
//         if(!isIPDDischarge) {
//           await fetchChatsAndSummary();
//         }
        
//         if(!dischargeFlow && !isIPDDischarge) {
//           await fetchPatientHistoryData();
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   // }
// }, []); 
// }, [allAttributesArray]); 

  // existing we can also use this
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       console.log('displayin notes dischargeFlwo: ', dischargeFlow)
  //       // Fetch all master data in parallel
  //       // const [hpiData, rosData, physicalexamData] = await Promise.all([
  //       //   fetchMasterData("hpi"),
  //       //   fetchMasterData("ros"),
  //       //   fetchMasterData("physicalexam"),
  //       // ]);

  //       // Update state with fetched data
  //       // setInputHPIMasterData(hpiData);
  //       // setInputROSMasterData(rosData);
  //       // setInputPhysicalExamMasterData(physicalexamData);

  //       // Call fetchAiraGeneratedNotes once all data is fetched
  //       // fetchAiraGeneratedNotes(hpiData, rosData, physicalexamData);
  //       fetchAiraGeneratedNotes();
  //       // if(buttonClicked !== 'IPD') {
  //         if(!isIPDDischarge) {
  //         fetchChatsAndSummary();
  //       }
  //       // if(!dischargeFlow && buttonClicked !== 'IPD') {
  //         if(!dischargeFlow && !isIPDDischarge) {
  //         fetchPatientHistoryData();
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const [aiCc, setAiCc] = useState("");
  const [aiHpiText, setAiHpiText] = useState("");
  const [aiRosText, setAiRosText] = useState("");
  const [aiPhysicalExamText, setAiPhysicalExamText] = useState("");
  const [aiPrescribedMedicinesText, setAiPrescribedMedicinesText] =
    useState("");
  const [aiPrescribedProceduresText, setAiPrescribedProceduresText] =
    useState("");
  const [aiPrescribedLabsText, setAiPrescribedLabsText] = useState("");
  const [aiPrescribedImagingText, setAiPrescribedImagingText] = useState("");
  const [aiAssessmentPlanArray, setAiAssessmentPlanArray] = useState([]);

  function transformDiagnosisPlan(data) {
    return data.map((item) => ({
      merged_diagnosis: `${item.diagnosis}: ${item.plan}`,
      diagnosis: item.diagnosis,
      plan: item.plan,
      old_diagnosis: item.diagnosis,
      old_plan: item.plan,
    }));
  }

  function formatAiraInput({
  patientHealthData,
  transcriptionText,
  currentmedications,
  investigations,
  vitals,
  doctornotes,
  imaging_reports,
  admission_date,
  discharge_date,
  consultant_doctor,
  follow_up_date
}) {
  // Patient Info
  const patientInfo = patientHealthData?.patientinfo
    ? {
        name: patientHealthData.patientinfo.firstname + " " + patientHealthData.patientinfo.lastname,
        dateOfBirth: patientHealthData.patientinfo.dob,
        age: patientHealthData.patientinfo.age || "",
        gender: patientHealthData.patientinfo.gender || ""
      }
    : {};

  // Medications
  const formattedMedications = Array.isArray(currentmedications)
    ? currentmedications.map(med => ({
        medicinename: med.medicinename || med.name || "",
        dosage: med.dosage || "",
        instructions: med.instructions || "",
        interval: med.interval || ""
      }))
    : [];

  // Investigations
  const formattedInvestigations = Array.isArray(investigations)
    ? investigations.map(inv => ({
        eventtitle: inv.eventtitle || inv.name || "",
        actualresultvalue: inv.actualresultvalue || inv.value || "",
        resultuom: inv.resultuom || inv.unit || ""
      }))
    : [];

  // Vitals
  const formattedVitals = Array.isArray(vitals)
    ? vitals.map(v => ({
        vitalname: v.vitalname || v.name || "",
        vitalvalue: v.vitalvalue || v.value || "",
        vitalunit: v.vitalunit || v.unit || ""
      }))
    : [];

  // Doctor Notes
  const formattedDoctorNotes = Array.isArray(doctornotes)
    ? doctornotes.map(note => ({
        name: note.name || "",
        notes: note.notes || ""
      }))
    : [];

  // Imaging Reports
  const formattedImagingReports = Array.isArray(imaging_reports)
    ? imaging_reports.map(report => ({
        report_info: {
          name: report.report_info?.name || "",
          type: report.report_info?.type || "",
          description: report.report_info?.description || ""
        },
        results_interpretation: {
          normal_results: report.results_interpretation?.normal_results || "",
          abnormal_results: report.results_interpretation?.abnormal_results || "",
          report_interpretation: report.results_interpretation?.report_interpretation || ""
        }
      }))
    : [];

  return {
    transcription: transcriptionText,
    has_midoc_idp: "True",
    admission_date: admission_date || "",
    discharge_date: discharge_date || "",
    consultant_doctor: consultant_doctor || "",
    follow_up_date: follow_up_date || "",
    patient_info: patientInfo,
    currentmedications: formattedMedications,
    investigations: formattedInvestigations,
    vitals: formattedVitals,
    doctornotes: formattedDoctorNotes,
    imaging_reports: formattedImagingReports
  };
}

  const fetchAiraGeneratedNotes = async (tagsArrayFromProfile = null) => {
    const inputToFetch = {
      input: {
        transcription: transcriptionText,
      },
    };  
    showLoader();
    console.log(inputToFetch);
    setAiInputForFeedback(inputToFetch);
    try {
      if(dischargeFlow) {
        const data = await GenerateDischargeSummaryFromTranscripts(inputToFetch.input);
        console.log(data, "dischargeData")
        setAiDischargeResponse(data)
      }else if(isIPDDischarge) {
        if(buttonClicked === 'IPD') {
//           const inputToFetchIPD = {
//             input: {
//               // admission details
//               admission_date: ipdInput.admission_details?.admission_date || "",
//               discharge_date: ipdInput.admission_details?.discharge_date || "",
//               consultant_doctor: ipdInput.admission_details?.doctor || "",
//               follow_up_date: ipdInput.follow_up_plan || {
//                 follow_up_date: ""
//               },
//               // patient details
//               patient_info: {
//               ...ipdInput.patient_info,
//               name: ipdInput.patient_info.name || "",
//               dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
//               gender: ipdInput.patient_info.gender || "",
//               age: ipdInput.patient_info.age || "",
//               // uhid: ipdInput.info?.patientmrn || "",
//               // consultant: ipdInput.info?.drname || "",
//               // phone: ipdInput.patient_info.phone || ""
//             },

//             // transcription
//             transcriptionText,

//             currentmedications: ipdInput.currentmedications || [],
//             investigations: ipdInput.investigations || [],
//             vitals: ipdInput.vitals || [],
//             doctornotes: ipdInput.doctornotes || [],
//             imaging_reports: ipdInput.imaging_reports || [],

//             // newly added tags
//             diagnosis: ipdInput.diagnosis || [],
//             presenting_complaints: ipdInput.presenting_complaints || {
//               chief_complaint: "",
//               complaint_date: "",
//               history_of_illness: []
//             },
//             clinical_findings: {
//               general_condition: ipdInput.clinical_findings?.chief_complaint || "",
//               vitals: ipdInput.vitals.reduce((acc, vital) => {
//                 acc[vital.vitalname] = {
//                   value: vital.vitalvalue || "",
//                   unit: vital.vitalunit || ""
//                 };
//                 return acc;
//               }, {}),
//               systemic_exam: ipdInput.clinical_findings?.physical_exam?.reduce((acc, exam) => {
//                 acc[exam.system] = exam.finding || "";
//                 return acc;
//               }, {}) || {},
//               review_of_systems: ipdInput.clinical_findings?.review_of_systems || []
//             },
//             history: {
//               medical_history: ipdInput.history?.medical_history || [],
//               surgical_history: ipdInput.history?.surgical_history || []
//             },
//             hospital_course: ipdInput.hospital_course || {
//               procedures: [],
//               vaccinations: [],
//               orders: {
//                 lab: [],
//                 imaging: []
//               }
//             },
//             instructions: ipdInput.instructions || [],
//             follow_up_plan: ipdInput.follow_up_plan || {
//               follow_up_date: "",
//               instructions: ""
//             },

//     // admission_details: {
//     //           hospital: ipdInput.admission_details?.hospital || "",
//     //           booking_id: ipdInput.admission_details?.booking_id || ""
//     //         },
//   },
// };
const inputToFetchIPD = {
  input: {
    // admission details
    admission_date: ipdInput.admission_date || "",
    discharge_date: ipdInput.discharge_date || "",
    consultant_doctor: ipdInput.consultant_doctor || "",
    follow_up_date: ipdInput.follow_up_date || "",

    // patient details
    patient_info: {
      name: ipdInput.patient_info?.name || "",
      dateOfBirth: ipdInput.patient_info?.dateOfBirth || "",
      gender: ipdInput.patient_info?.gender || "",
      age: ipdInput.patient_info?.age || "",
      phone: ipdInput.patient_info?.phone || "",
    uhid: ipdInput.patient_info?.uhid || "",
    mrn: ipdInput.patient_info?.mrn || ""
    },

    // transcription
    transcriptionText,

    currentmedications: ipdInput.currentmedications || [],
    investigations: ipdInput.investigations || [],
    vitals: ipdInput.vitals || [],
    doctornotes: ipdInput.doctornotes || [],
    imaging_reports: ipdInput.imaging_reports || [],

    // newly added tags
    diagnosis: ipdInput.diagnosis || [],
    
    presenting_complaints: {
      chief_complaint: ipdInput.presenting_complaints?.chief_complaint || "",
      complaint_date: ipdInput.presenting_complaints?.complaint_date || "",
      history_of_illness: ipdInput.presenting_complaints?.history_of_illness || []
    },
    
    clinical_findings: {
      // FIXED: Use physical_exam from clinical_findings instead of chief_complaint
      general_condition: ipdInput.presenting_complaints?.chief_complaint || "",
      
      // FIXED: Properly map vitals to object format
      vitals: (ipdInput.vitals || []).reduce((acc, vital) => {
        acc[vital.vitalname] = {
          value: vital.vitalvalue || "",
          unit: vital.vitalunit || ""
        };
        return acc;
      }, {}),
      
      // FIXED: Use description from physical_exam objects
      systemic_exam: (ipdInput.clinical_findings?.physical_exam || []).reduce((acc, exam, index) => {
        acc[exam.type || `exam_${index}`] = exam.description || "";
        return acc;
      }, {}),
      
      // FIXED: Use review_of_systems from clinical_findings
      review_of_systems: ipdInput.clinical_findings?.review_of_systems || []
    },
    
    history: {
      medical_history: ipdInput.history?.medical_history || [],
      surgical_history: ipdInput.history?.surgical_history || []
    },
    
    hospital_course: ipdInput.hospital_course || {
      procedures: [],
      vaccinations: [],
      orders: {
        lab: [],
        imaging: []
      }
    },
    
    instructions: ipdInput.instructions || [],
    attributes: tagsArrayFromProfile || otherTagsArray || [],
    // attributes: allAttributesArray,
    // diagnosisattribute: dischargeDisplaySettings.diagnosis || "",
    // findingattribute: dischargeDisplaySettings.findings || "",
    
    follow_up_plan: {
      follow_up_date: ipdInput.follow_up_plan?.follow_up_date || "",
      instructions: ipdInput.follow_up_plan?.instructions || ""
    },
  },
};  
console.log('inputToFetdhcIPD.input:', inputToFetchIPD)        
const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
console.log(data, "dischargeData for IPD")
          setAiDischargeResponse(data)
        } else if(buttonClicked === 'IPDRecord') {
          const inputToFetchIPD = {
  input: {
    // admission details
    admission_date: ipdInput.admission_date || "",
    discharge_date: ipdInput.discharge_date || "",
    consultant_doctor: ipdInput.consultant_doctor || "",
    follow_up_date: ipdInput.follow_up_date || "",

    // patient details
    patient_info: {
      name: ipdInput.patient_info?.name || "",
      dateOfBirth: ipdInput.patient_info?.dateOfBirth || "",
      gender: ipdInput.patient_info?.gender || "",
      age: ipdInput.patient_info?.age || "",
      phone: ipdInput.patient_info?.phone || "",
    uhid: ipdInput.patient_info?.uhid || "",
    mrn: ipdInput.patient_info?.mrn || ""
    },

    // transcription
    transcriptionText,

    currentmedications: ipdInput.currentmedications || [],
    investigations: ipdInput.investigations || [],
    vitals: ipdInput.vitals || [],
    doctornotes: ipdInput.doctornotes || [],
    imaging_reports: ipdInput.imaging_reports || [],

    // newly added tags
    diagnosis: ipdInput.diagnosis || [],
    
    presenting_complaints: {
      chief_complaint: ipdInput.presenting_complaints?.chief_complaint || "",
      complaint_date: ipdInput.presenting_complaints?.complaint_date || "",
      history_of_illness: ipdInput.presenting_complaints?.history_of_illness || []
    },
    
    clinical_findings: {
      // FIXED: Use physical_exam from clinical_findings instead of chief_complaint
      general_condition: ipdInput.presenting_complaints?.chief_complaint || "",
      
      // FIXED: Properly map vitals to object format
      vitals: (ipdInput.vitals || []).reduce((acc, vital) => {
        acc[vital.vitalname] = {
          value: vital.vitalvalue || "",
          unit: vital.vitalunit || ""
        };
        return acc;
      }, {}),
      
      // FIXED: Use description from physical_exam objects
      systemic_exam: (ipdInput.clinical_findings?.physical_exam || []).reduce((acc, exam, index) => {
        acc[exam.type || `exam_${index}`] = exam.description || "";
        return acc;
      }, {}),
      
      // FIXED: Use review_of_systems from clinical_findings
      review_of_systems: ipdInput.clinical_findings?.review_of_systems || []
    },
    
    history: {
      medical_history: ipdInput.history?.medical_history || [],
      surgical_history: ipdInput.history?.surgical_history || []
    },
    
    hospital_course: ipdInput.hospital_course || {
      procedures: [],
      vaccinations: [],
      orders: {
        lab: [],
        imaging: []
      }
    },
    
    instructions: ipdInput.instructions || [],
    attributes: tagsArrayFromProfile || otherTagsArray || [],
    // attributes: allAttributesArray,
    
    follow_up_plan: {
      follow_up_date: ipdInput.follow_up_plan?.follow_up_date || "",
      instructions: ipdInput.follow_up_plan?.instructions || ""
    },
  },
};
//           const inputToFetchIPD = {
//             input: {
//     // patientHealthData,
//     patient_info: {
//               ...ipdInput.patient_info,
//               name: ipdInput.patient_info.name || "",
//               dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
//               gender: ipdInput.patient_info.gender || "",
//               age: ipdInput.patient_info.age || "",
//               // uhid: ipdInput.info?.patientmrn || "",
//               // consultant: ipdInput.info?.drname || "",
//               // phone: ipdInput.patient_info.phone || ""
//             },
//             transcriptionText,
//             currentmedications: ipdInput.currentmedications || [],
//     // currentmedications: aiPatientMedications, // or your medications array
//     investigations: ipdInput.investigations || [],
//     // investigations: aiPatientResponse?.investigations || [],
//     vitals: ipdInput.vitals || [],
//     // vitals: aiPatientResponse?.patient_vitals || [],
//     doctornotes: ipdInput.doctornotes || [],
//     // doctornotes: aiPatientResponse?.doctornotes || [],
//     imaging_reports: ipdInput.imaging_reports || [],
//     // imaging_reports: aiPatientResponse?.imaging_reports || [],

//     admission_date: ipdInput.admission_details?.admission_date || "",
//     // admission_date: aiPatientResponse?.admission_date || "",
//     discharge_date: ipdInput.admission_details?.discharge_date || "",
//     // discharge_date: aiPatientResponse?.discharge_date || "",
//     consultant_doctor: ipdInput.admission_details?.doctor || "",
//     // consultant_doctor: aiPatientResponse?.consultant_doctor || "",
//     // admission_details: {
//     //           hospital: ipdInput.admission_details?.hospital || "",
//     //           booking_id: ipdInput.admission_details?.booking_id || ""
//     //         },
//     follow_up_date: ipdInput.follow_up_plan || {
//               follow_up_date: ""
//             },
//     // follow_up_date: aiPatientResponse?.follow_up_date || ""
//   },
// };
          const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
          console.log(data, "dischargeData for IPD")
          setAiDischargeResponse(data)
        }else if(buttonClicked === 'RecordOnly') {
          const inputToFetchIPD = {
            input: {
              transcription: transcriptionText,
              "has_midoc_idp": "True",
              patient_info: {
              ...ipdInput.patient_info,
              name: ipdInput.patient_info.name || "",
              dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
              gender: ipdInput.patient_info.gender || "",
              age: ipdInput.patient_info.age || "",
              uhid: ipdInput.info?.patientmrn || "",
              consultant: ipdInput.info?.drname || "",
              phone: ipdInput.patient_info.phone || ""
            },
            attributes: tagsArrayFromProfile || otherTagsArray || [],
            // attributes: allAttributesArray,
            },
          };  
          const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
          console.log(data, "dischargeData for IPD")
          setAiDischargeResponse(data)
        }
      } else {
        const data = await GenerateDoctorNotesFromTranscripts(inputToFetch.input);
        console.log(data)
        setAiResponse(data);
        setAiCc(data?.chiefcomplaint);
        setAiHpiText(data?.hpi_text);
        setAiRosText(data?.ros_text);
        setAiPhysicalExamText(data?.physical_exam_text);
        setAiPrescribedMedicinesText(data?.prescribed_medicines);
        setAiPrescribedProceduresText(data?.prescribed_procedures);
        setAiPrescribedLabsText(data?.prescribed_labs);
        setAiPrescribedImagingText(data?.prescribed_imaging);
        setAiAssessmentPlanArray(transformDiagnosisPlan(data?.assessment_plan));
        setAiOutputForFeedback(data); 
      }
      // console.log("Generated doctor notes", data);
    } catch (error) {
      console.error("Error fetching AIRA Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  // existing function
//   const fetchAiraGeneratedNotes = async (
//   ) => {
//     // if(patientId && appointmentId) {
//     //   const inputToFetch = {
//     //     input: {
//     //       patientInfo: patientHealthData,
//     //       transcription: transcriptionText,
//     //     },
//     //   };  
//     // }
//     const inputToFetch = {
//       input: {
//         transcription: transcriptionText,
//       },
//     };  
//     showLoader();
//     console.log(inputToFetch);
//     setAiInputForFeedback(inputToFetch);
//     try {
//       if(dischargeFlow) {
//         const data = await GenerateDischargeSummaryFromTranscripts(inputToFetch.input);
//         console.log(data, "dischargeData")
//         setAiDischargeResponse(data)
//       }else if(isIPDDischarge) {
//         if(buttonClicked === 'IPD') {
//           // can try this input once if not working properly
// //           const inputToFetchIPD = {
// //   input: {
// //     // Include the entire aiInputData as patientinfo
// //     patientinfo: aiInputData,
    
// //     // Also include specific sections at the root level as needed by the API
// //     patient_info: {
// //       ...aiInputData.patient_info,
// //       uhid: aiInputData.patient_info.mrn || "", // Map MRN to UHID if needed
// //       consultant: aiInputData.admission_details?.doctor || ""
// //     },
// //     currentmedications: aiInputData.currentmedications,
// //     investigations: aiInputData.investigations,
    
// //     // Use the properly formatted vitals we created earlier
// //     vitals: aiInputData.vitals,
    
// //     doctornotes: aiInputData.doctornotes,
// //     imaging_reports: aiInputData.imaging_reports,
    
// //     // Enhanced clinical_findings with proper blood pressure handling
// //     clinical_findings: {
// //       general_condition: aiInputData.presenting_complaints?.chief_complaint || "",
// //       vitals: aiInputData.vitals.reduce((acc, vital) => {
// //         // Special handling for blood pressure
// //         if (vital.vitalname === "Blood Pressure") {
// //           acc["Blood Pressure"] = {
// //             value: vital.vitalvalue,
// //             unit: vital.vitalunit
// //           };
// //         } else {
// //           acc[vital.vitalname] = {
// //             value: vital.vitalvalue,
// //             unit: vital.vitalunit
// //           };
// //         }
// //         return acc;
// //       }, {}),
// //       systemic_exam: aiInputData.clinical_findings?.physical_exam?.reduce((acc, exam) => {
// //         acc[exam.system] = exam.finding || "";
// //         return acc;
// //       }, {}) || {},
// //       review_of_systems: aiInputData.clinical_findings?.review_of_systems || []
// //     },
    
// //     // Include other required fields
// //     has_midoc_idp: "True",
    
// //     // Include the rest of the data from aiInputData if needed
// //     ...(aiInputData.transcription && { transcription: aiInputData.transcription }),
    
// //     // Optionally include other sections if the API expects them
// //     ...(aiInputData.diagnosis && { diagnosis: aiInputData.diagnosis }),
// //     ...(aiInputData.presenting_complaints && { presenting_complaints: aiInputData.presenting_complaints }),
// //     ...(aiInputData.history && { history: aiInputData.history }),
// //     ...(aiInputData.hospital_course && { hospital_course: aiInputData.hospital_course }),
// //     ...(aiInputData.instructions && { instructions: aiInputData.instructions }),
// //     ...(aiInputData.follow_up_plan && { follow_up_plan: aiInputData.follow_up_plan }),
// //     ...(aiInputData.documents && { documents: aiInputData.documents })
// //   }
// // };
//           const inputToFetchIPD = {
//           input: {
//             patient_info: {
//               ...ipdInput.patient_info,
//               name: ipdInput.patient_info.name || "",
//               dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
//               gender: ipdInput.patient_info.gender || "",
//               age: ipdInput.patient_info.age || "",
//               uhid: ipdInput.info?.patientmrn || "",
//               consultant: ipdInput.info?.drname || "",
//               phone: ipdInput.patient_info.phone || ""
//             },
//             admission_details: {
//               admission_date: ipdInput.admission_details?.admission_date || "",
//               discharge_date: ipdInput.admission_details?.discharge_date || "",
//               doctor: ipdInput.admission_details?.doctor || "",
//               hospital: ipdInput.admission_details?.hospital || "",
//               booking_id: ipdInput.admission_details?.booking_id || ""
//             },
//             diagnosis: ipdInput.diagnosis || [],
//             presenting_complaints: ipdInput.presenting_complaints || {
//               chief_complaint: "",
//               complaint_date: "",
//               history_of_illness: []
//             },
//             clinical_findings: {
//               general_condition: ipdInput.clinical_findings?.chief_complaint || "",
//               vitals: ipdInput.vitals.reduce((acc, vital) => {
//                 acc[vital.vitalname] = {
//                   value: vital.vitalvalue || "",
//                   unit: vital.vitalunit || ""
//                 };
//                 return acc;
//               }, {}),
//               systemic_exam: ipdInput.clinical_findings?.physical_exam?.reduce((acc, exam) => {
//                 acc[exam.system] = exam.finding || "";
//                 return acc;
//               }, {}) || {},
//               review_of_systems: ipdInput.clinical_findings?.review_of_systems || []
//             },
//             history: {
//               medical_history: ipdInput.history?.medical_history || [],
//               surgical_history: ipdInput.history?.surgical_history || []
//             },
//             hospital_course: ipdInput.hospital_course || {
//               procedures: [],
//               vaccinations: [],
//               orders: {
//                 lab: [],
//                 imaging: []
//               }
//             },
//             currentmedications: ipdInput.currentmedications || [],
//             investigations: ipdInput.investigations || [],
//             vitals: ipdInput.vitals || [],
//             doctornotes: ipdInput.doctornotes || [],
//             imaging_reports: ipdInput.imaging_reports || [],
//             instructions: ipdInput.instructions || [],
//             follow_up_plan: ipdInput.follow_up_plan || {
//               follow_up_date: "",
//               instructions: ""
//             },
//             documents: ipdInput.documents || [],
//             has_midoc_idp: "True"
//           },
//         };  
//           // const inputToFetchIPD = {
//           //   input: {
//           //     "patient_info": {
//           //         ...ipdInput.patient_info,
//           //         name: ipdInput.patient_info.name,
//           //         dateOfBirth: ipdInput.patient_info.dateOfBirth,
//           //         gender: ipdInput.patient_info.gender,
//           //         age: ipdInput.patient_info.age,
//           //         uhid: ipdInput.info?.patientmrn || "None",
//           //         consultant: ipdInput.info?.drname || "None"
//           //       },
//           //     "currentmedications": ipdInput.currentmedications,
//           //     "investigations": ipdInput.investigations,
//           //     "vitals": ipdInput.vitals,
//           //     "doctornotes": ipdInput.doctornotes,
//           //     "imaging_reports": ipdInput.imaging_reports,
//           //     // "clinical_findings": ipdInput.clinical_findings,
//           //     clinical_findings: {
//           //         general_condition: ipdInput.clinical_findings?.chief_complaint || "None",
//           //         vitals: ipdInput.vitals.reduce((acc, vital) => {
//           //           acc[vital.vitalname] = {
//           //             value: vital.vitalvalue,
//           //             unit: vital.vitalunit
//           //           };
//           //           return acc;
//           //         }, {}),
//           //         systemic_exam: ipdInput.clinical_findings?.physical_exam?.reduce((acc, exam) => {
//           //           acc[exam] = "Noted";
//           //           return acc;
//           //         }, {}) || {}
//           //       },
//           //     "has_midoc_idp": "True",
//           //   },
//           // };  
//           const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
//           console.log(data, "dischargeData for IPD")
//           setAiDischargeResponse(data)
//         } else if(buttonClicked === 'IPDRecord') {
//           const inputToFetchIPD = {
//           input: {
//             transcription: transcriptionText,
//             patient_info: {
//               ...ipdInput.patient_info,
//               name: ipdInput.patient_info.name || "",
//               dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
//               gender: ipdInput.patient_info.gender || "",
//               age: ipdInput.patient_info.age || "",
//               uhid: ipdInput.info?.patientmrn || "",
//               consultant: ipdInput.info?.drname || "",
//               phone: ipdInput.patient_info.phone || ""
//             },
//             admission_details: {
//               admission_date: ipdInput.admission_details?.admission_date || "",
//               discharge_date: ipdInput.admission_details?.discharge_date || "",
//               doctor: ipdInput.admission_details?.doctor || "",
//               hospital: ipdInput.admission_details?.hospital || "",
//               booking_id: ipdInput.admission_details?.booking_id || ""
//             },
//             diagnosis: ipdInput.diagnosis || [],
//             presenting_complaints: ipdInput.presenting_complaints || {
//               chief_complaint: "",
//               complaint_date: "",
//               history_of_illness: []
//             },
//             clinical_findings: {
//               general_condition: ipdInput.clinical_findings?.chief_complaint || "",
//               vitals: ipdInput.vitals.reduce((acc, vital) => {
//                 acc[vital.vitalname] = {
//                   value: vital.vitalvalue || "",
//                   unit: vital.vitalunit || ""
//                 };
//                 return acc;
//               }, {}),
//               systemic_exam: ipdInput.clinical_findings?.physical_exam?.reduce((acc, exam) => {
//                 acc[exam.system] = exam.finding || "";
//                 return acc;
//               }, {}) || {},
//               review_of_systems: ipdInput.clinical_findings?.review_of_systems || []
//             },
//             history: {
//               medical_history: ipdInput.history?.medical_history || [],
//               surgical_history: ipdInput.history?.surgical_history || []
//             },
//             hospital_course: ipdInput.hospital_course || {
//               procedures: [],
//               vaccinations: [],
//               orders: {
//                 lab: [],
//                 imaging: []
//               }
//             },
//             currentmedications: ipdInput.currentmedications || [],
//             investigations: ipdInput.investigations || [],
//             vitals: ipdInput.vitals || [],
//             doctornotes: ipdInput.doctornotes || [],
//             imaging_reports: ipdInput.imaging_reports || [],
//             instructions: ipdInput.instructions || [],
//             follow_up_plan: ipdInput.follow_up_plan || {
//               follow_up_date: "",
//               instructions: ""
//             },
//             documents: ipdInput.documents || [],
//             has_midoc_idp: "True"
//           },
//         };  
//           // const inputToFetchIPD = {
//           //   input: {
//           //     transcription: transcriptionText,
//           //     // "patientinfo": ipdInput.patient_info,
//           //     "patient_info": {
//           //         ...ipdInput.patient_info,
//           //         name: ipdInput.patient_info.name,
//           //         dateOfBirth: ipdInput.patient_info.dateOfBirth,
//           //         gender: ipdInput.patient_info.gender,
//           //         age: ipdInput.patient_info.age,
//           //         uhid: ipdInput.info?.patientmrn || "None",
//           //         consultant: ipdInput.info?.drname || "None"
//           //       },
//           //     "currentmedications": ipdInput.currentmedications,
//           //     "investigations": ipdInput.investigations,
//           //     "vitals": ipdInput.vitals,
//           //     "doctornotes": ipdInput.doctornotes,
//           //     "imaging_reports": ipdInput.imaging_reports,
//           //     // "clinical_findings": ipdInput.clinical_findings,
//           //     // clinical_findings: {
//           //     //     general_condition: ipdInput.clinical_findings?.chief_complaint || "None",
//           //     //     vitals: ipdInput.vitals.reduce((acc, vital) => {
//           //     //       acc[vital.vitalname] = {
//           //     //         value: vital.vitalvalue,
//           //     //         unit: vital.vitalunit
//           //     //       };
//           //     //       return acc;
//           //     //     }, {}),
//           //     //     systemic_exam: ipdInput.clinical_findings?.physical_exam?.reduce((acc, exam) => {
//           //     //       acc[exam] = "Noted";
//           //     //       return acc;
//           //     //     }, {}) || {}
//           //     //   },
//           //     "has_midoc_idp": "True",
//           //   },
//           // };  
//           const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
//           console.log(data, "dischargeData for IPD")
//           setAiDischargeResponse(data)
//         }else if(buttonClicked === 'RecordOnly') {
//           const inputToFetchIPD = {
//             input: {
//               transcription: transcriptionText,
//               // "patient_info": {
//               //     ...ipdInput.patient_info,
//               //     name: ipdInput.patient_info.name,
//               //     dateOfBirth: ipdInput.patient_info.dateOfBirth,
//               //     gender: ipdInput.patient_info.gender,
//               //     age: ipdInput.patient_info.age,
//               //     uhid: ipdInput.info?.patientmrn || "None",
//               //     consultant: ipdInput.info?.drname || "None"
//               //   },
//               "has_midoc_idp": "True",
//               patient_info: {
//               ...ipdInput.patient_info,
//               name: ipdInput.patient_info.name || "",
//               dateOfBirth: ipdInput.patient_info.dateOfBirth || "",
//               gender: ipdInput.patient_info.gender || "",
//               age: ipdInput.patient_info.age || "",
//               uhid: ipdInput.info?.patientmrn || "",
//               consultant: ipdInput.info?.drname || "",
//               phone: ipdInput.patient_info.phone || ""
//             },
//             },
//           };  
//           const data = await GenerateDischargeSummaryFromTranscripts(inputToFetchIPD.input);
//           console.log(data, "dischargeData for IPD")
//           setAiDischargeResponse(data)
//         }
//       } else {
//         const data = await GenerateDoctorNotesFromTranscripts(inputToFetch.input);
//         console.log(data)
//         setAiResponse(data);
//         setAiCc(data?.chiefcomplaint);
//         setAiHpiText(data?.hpi_text);
//         setAiRosText(data?.ros_text);
//         setAiPhysicalExamText(data?.physical_exam_text);
//         setAiPrescribedMedicinesText(data?.prescribed_medicines);
//         setAiPrescribedProceduresText(data?.prescribed_procedures);
//         setAiPrescribedLabsText(data?.prescribed_labs);
//         setAiPrescribedImagingText(data?.prescribed_imaging);
//         setAiAssessmentPlanArray(transformDiagnosisPlan(data?.assessment_plan));
//         setAiOutputForFeedback(data); 
//       }
//       // console.log("Generated doctor notes", data);
//     } catch (error) {
//       console.error("Error fetching AIRA Notes data:", error);
//     } finally {
//       dismissLoader();
//     }
//   };

  const [aiTranscriptChats, setAiTranscriptChats] = useState([]);

  const [aiTranscriptSummary, setAiTranscriptSummary] = useState("");

  //--------------saving chats to db

  function transformConversation(input) {
    if (!Array.isArray(input)) {
      throw new Error("Input must be an array.");
    }

    return input.map((item) => {
      if (typeof item !== "object" || item === null) {
        throw new Error("Each item in the array must be a non-null object.");
      }

      const [usertype, message] = Object.entries(item)[0] || [];
      if (!usertype || !message) {
        throw new Error(
          "Invalid object structure. Each object must have a single key-value pair."
        );
      }

      return {
        usertype,
        message,
      };
    });
  }

  const saveChatsAndSummary = async (aichats) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        chats: transformConversation(aichats),
      },
    };
    showLoader();
    // console.log(inputToSave);
    try {
      const result = await updateAIRAChatNotes(inputToSave.input);
      // console.log(result);
    } catch (error) {
      console.error("Error saving AIRA Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  //----------------ai chat call

  const fetchChatsAndSummary = async () => {
    const inputToFetch = {
      input: {
        transcription: transcriptionText,
      },
    };
    showLoader();
    // console.log(inputToFetch);
    try {
      const data = await GenerateDoctorChatsFromTranscripts(inputToFetch.input);
      setAiTranscriptChats(data?.chats);
      setAiTranscriptSummary(data?.summary);
      if (fromStartVisit) {
        // console.log("saving chats");
        const result = await saveChatsAndSummary(data?.chats);
      }
      // console.log(data);
    } catch (error) {
      console.error("Error fetching AIRA Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  const [aiPatientMedications, setAiPatientMedications] = useState("");
  const [aiPatientSurgeries, setAiPatientSurgeries] = useState("");
  const [aiPatientAllergies, setAiPatientAllergies] = useState("");
  const [aiPatientMedicalConditions, setAiPatientMedicalConditions] =
    useState("");
  const [aiPatientSocialHistory, setAiPatientSocialHistory] = useState("");
  const [aiPatientVaccinations, setAiPatientVaccinations] = useState("");
  const [aiPatientVitals, setAiPatientVitals] = useState("");
  const [aiPatientResponse, setAiPatientResponse] = useState(null);

  const fetchPatientHistoryData = async () => {
    const inputToFetch = {
      input: {
        transcription: transcriptionText,
      },
    };
    showLoader();
    // console.log(inputToFetch);
    try {
      const data = await GenerateDoctorPatientHistoryNotesFromTranscripts(
        inputToFetch.input
      );
      setAiPatientResponse(data);
      setAiPatientMedications(data?.patient_medications);
      setAiPatientSurgeries(data?.patient_surgeries);
      setAiPatientAllergies(data?.patient_allergies);
      setAiPatientMedicalConditions(data?.patient_medical_conditions);
      setAiPatientSocialHistory(data?.patient_social_history);
      setAiPatientVaccinations(data?.patient_vaccinations);
      setAiPatientVitals(data?.patient_vitals);
      // console.log("patient extracted data", data);
    } catch (error) {
      console.error("Error fetching AIRA Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  // const [selectedTab, setSelectedTab] = useState("doctor");
  const [selectedTab, setSelectedTab] = useState((dischargeFlow || isIPDDischarge) ? "discharge" : "doctor");

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  // ---------------------------------;new changes ---------------------------

  const [medicineList, setMedicineList] = useState([]);
  const [intervalOption, setIntervalOption] = useState("Days");
  
      const [intervalValue, setIntervalValue] = useState(5);
   const [suggestions, setSuggestions] = useState([]);
      const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] =
        useState(-1);
      const [boolValForSuggestions, setBoolValForSuggestions] = useState(true);
      const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
      const suggestionsMenuRef = useRef(null);

      const handleEditSelect = (suggestion, index) => {
        // handleEditMedicineChange(
        //   "medicinename",
        //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
        // );
        handleEditMedicineChange("medicinename", suggestion.productname);
        handleEditMedicineChange("inventoryid", suggestion.inventoryid);
        setSuggestions([]);
        setBoolValForSuggestions(!boolValForSuggestions);
        setShowMedicineNamesDropdown(-1);
      };

      const validationOfNumberWithOnly1Decimal = (inputValue, maxLength) => {
        // Remove all characters that are not digits or a decimal point
        let cleanedValue = inputValue.replace(/[^0-9.]/g, "");
  
        // Remove leading decimal point if present
        if (cleanedValue.startsWith(".")) {
          cleanedValue = cleanedValue.substring(1);
        }
  
        // Handle multiple decimal points
        const decimalIndex = cleanedValue.indexOf(".");
        if (decimalIndex !== -1) {
          const parts = cleanedValue.split(".");
          // Keep only the first two digits after the decimal point
          cleanedValue = parts[0] + "." + parts[1].slice(0, 2);
        }
  
        // Enforce the max length after cleaning and truncating
        if (cleanedValue.length > maxLength) {
          cleanedValue = cleanedValue.substring(0, maxLength);
        }
  
        // console.log("input", inputValue);
        // console.log("cleaned", cleanedValue);
  
        return cleanedValue;
      };

      const handleIntervalChange = (value) => {
        setIntervalOption(value);
      };

      const handleIntervalValueChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setIntervalValue(isNaN(value) ? 0 : value); // handle NaN cases if input is empty
      };


      const handleEditKeyDown = (e, index) => {
        if (e.key === "ArrowDown") {
          setFocusedItemIndex(
            (prevIndex) => (prevIndex + 1) % suggestions.length
          );
          const itemHeight =
            suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
          if (suggestionsMenuRef.current) {
            suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
          }
        } else if (e.key === "ArrowUp") {
          setFocusedItemIndex((prevIndex) =>
            prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
          );
          const itemHeight =
            suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
          if (suggestionsMenuRef.current) {
            suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
          }
        } else if (e.key === "Enter" && focusedItemIndex !== -1) {
          const selectedItem = suggestions[focusedItemIndex];
          handleEditSelect(selectedItem, index);
        }
      };

  const filterMedicineNames = (medicine) => {
    const filtered = medicineList.filter((obj) =>
      obj.productname?.toLowerCase().includes(medicine.toLowerCase())
    );
    setSuggestions(filtered);
    setBoolValForSuggestions(!boolValForSuggestions);
  };

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};


// -------------------- Editing Discharge Summary ---------------------------------
const [editableSections, setEditableSections] = useState({
  patientInfo: '',
  admissionDetails: '',
  diagnosis: '',
  presentingComplaints: '',
  clinicalFindings: '',
  history: '',
  investigations: '',
  procedures: '',
  hospitalCourse: '',
  dischargeMeds: '',
  instructions: '',
  followUpPlan: ''
});
useEffect(() => {
  if (aiDischargeResponse) {
    setEditableSections({
      patientInfo: formatPatientInfo(aiDischargeResponse.patient_info),
      admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on!= "None" ? aiDischargeResponse.admission_details.admitted_on : ''}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date!="None" ? aiDischargeResponse.admission_details.discharge_date : ""}`,
      // admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date}`,
      // diagnosis: aiDischargeResponse.diagnosis.final.join('\n'),
      diagnosis: aiDischargeResponse.diagnosis.final.filter(d => d && d !== 'None').join('\n'),
      presentingComplaints: formatComplaints(aiDischargeResponse.presenting_complaints),
      clinicalFindings: formatClinicalFindings(aiDischargeResponse.clinical_findings),
      history: formatHistory(aiDischargeResponse.history),
      investigations: formatInvestigations(aiDischargeResponse.investigations),
      procedures: formatProcedures(aiDischargeResponse.procedures),
      hospitalCourse: formatHospitalCourse(aiDischargeResponse.hospital_course),
      dischargeMeds: formatMedications(aiDischargeResponse.medications_on_discharge),
      instructions: formatInstructions(aiDischargeResponse.instructions),
      followUpPlan: formatFollowUpPlan(aiDischargeResponse.follow_up_plan)
    });
  }
}, [aiDischargeResponse]);

// const formatPatientInfo = (info) => {
//   return `Name: ${info.name== "None" ? "" : info.name}
// Age: ${info.age== "None" ? "" : info.age}
// Sex: ${info.sex== "None" ? "" : info.sex}
// UHID: ${info.uhid== "None" ? "" : info.uhid}
// Consultant: ${info.consultant== "None" ? "" : info.consultant}`;
// //   return `Name: ${info.name || ''}
// // Age: ${info.age || ''}
// // Sex: ${info.sex || ''}
// // UHID: ${info.uhid || ''}
// // Consultant: ${info.consultant || ''}`;
// };

const parsePatientInfo = (text) => {
  const lines = text?.split('\n');
  const info = {
    name: '',
    age: '',
    sex: '',
    uhid: '',
    consultant: ''
  };
  
  lines?.forEach(line => {
    if (line.includes('Name:')) info.name = line.replace('Name:', '').trim();
    if (line.includes('Age:')) info.age = line.replace('Age:', '').trim();
    if (line.includes('Sex:')) info.sex = line.replace('Sex:', '').trim();
    if (line.includes('UHID:')) info.uhid = line.replace('UHID:', '').trim();
    if (line.includes('Consultant:')) info.consultant = line.replace('Consultant:', '').trim();
  });
  
  return info;
};

// const formatComplaints = (complaints) => {
//   return complaints.map(c => `${c.description} - ${c.onset}`).join('\n');
// };
// const formatComplaints = (complaints) => {
//   const validComplaints = complaints.filter(c => c.description && c.description !== 'None');
//   return validComplaints.map(c => `${c.description} - ${c.onset || ''}`).join('\n');
// };

const parseComplaints = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split('-').map(p => p.trim());
    return {
      description: parts[0] || '',
      onset: parts[1] || ''
    };
  });
};

// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition || ''}\n\nVitals:\n`;
//   findings.vitals.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value} ${vital.unit || ''}\n`;
//   });
//   text += `\nSystemic Exam:\n`;
//   findings.systemic_examination.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding}\n`;
//   });
//   return text;
// };
// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition== "None" ? '': findings.general_condition}\n\nVitals:\n`;
//   const validVitals = findings?.vitals?.filter(vital => vital.name && vital.name !== 'None');
//   validVitals?.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value || ''} ${vital.unit || ''}\n`;
//   });
//   if (validVitals.length === 0) text += ' \n';
  
//   text += `\nSystemic Exam:\n`;
//   const validExams = findings?.systemic_examination?.filter(exam => exam.system && exam.system !== 'None');
//   validExams.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding || ''}\n`;
//   });
//   if (validExams.length === 0) text += ' \n';
  
//   return text;
// };

// newly added function
const parseClinicalFindings = (text) => {
  const lines = text?.split('\n');
  const findings = {
    general_condition: '',
    admission_vitals: [],
    discharge_vitals: [],
    systemic_examination: [],
    local_examination: []
  };

  let currentSection = '';
  
  lines?.forEach(line => {
    const trimmedLine = line.trim();
    
    if (trimmedLine.includes('General Condition:')) {
      findings.general_condition = trimmedLine.replace('General Condition:', '').trim();
    } else if (trimmedLine.includes('Admission Vitals:')) {
      currentSection = 'admission_vitals';
    } else if (trimmedLine.includes('Discharge Vitals:')) {
      currentSection = 'discharge_vitals';
    } else if (trimmedLine.includes('Systemic Examination:')) {
      currentSection = 'systemic_examination';
    } else if (trimmedLine.includes('Local Examination:')) {
      currentSection = 'local_examination';
    } else if (trimmedLine.startsWith('-') && (currentSection === 'admission_vitals' || currentSection === 'discharge_vitals')) {
      const parts = trimmedLine.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        const valueParts = parts[1].split(' ');
        const vital = {
          name: parts[0],
          value: valueParts[0],
          unit: valueParts.slice(1).join(' ') || ''
        };
        findings[currentSection].push(vital);
      }
    } else if (trimmedLine.startsWith('-') && (currentSection === 'systemic_examination' || currentSection === 'local_examination')) {
      const parts = trimmedLine.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        findings[currentSection].push({
          system: parts[0],
          finding: parts[1]
        });
      }
    }
  });

  return findings;
};
// last commented working code
// const parseClinicalFindings = (text) => {
//   const lines = text?.split('\n');
//   const findings = {
//     general_condition: '',
//     vitals: [],
//     systemic_examination: []
//   };

//   let currentSection = '';
  
//   lines?.forEach(line => {
//     if (line.includes('General Condition:')) {
//       findings.general_condition = line.replace('General Condition:', '').trim();
//     } else if (line.includes('Vitals:')) {
//       currentSection = 'vitals';
//     } else if (line.includes('Systemic Exam:')) {
//       currentSection = 'systemic';
//     } else if (line.startsWith('-') && currentSection === 'vitals') {
//       const parts = line.replace('-', '').split(':').map(p => p.trim());
//       if (parts.length >= 2) {
//         const valueParts = parts[1].split(' ');
//         findings.vitals.push({
//           name: parts[0],
//           value: valueParts[0],
//           unit: valueParts.slice(1).join(' ') || ''
//         });
//       }
//     } else if (line.startsWith('-') && currentSection === 'systemic') {
//       const parts = line.replace('-', '').split(':').map(p => p.trim());
//       if (parts.length >= 2) {
//         findings.systemic_examination.push({
//           system: parts[0],
//           finding: parts[1]
//         });
//       }
//     }
//   });

//   return findings;
// };

// const formatHospitalCourse = (course) => {
//   let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   course.interventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes}\n`;
//   });
//   return text;
// };
// const formatHospitalCourse = (course) => {
//   // let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   let text = `Summary: ${course.summary== "None" ? '': course.summary}\n\nInterventions:\n`;
//   const validInterventions = course.interventions.filter(int => int.name && int.name !== 'None');
//   validInterventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes || ''}\n`;
//   });
//   if (validInterventions.length === 0) text += ' \n';
//   return text;
// };

const parseHospitalCourse = (text) => {
  const lines = text?.split('\n');
  const course = {
    summary: '',
    interventions: []
  };

  let currentSection = '';
  
  lines?.forEach(line => {
    if (line.includes('Summary:')) {
      course.summary = line.replace('Summary:', '').trim();
    } else if (line.includes('Interventions:')) {
      currentSection = 'interventions';
    } else if (line.startsWith('-') && currentSection === 'interventions') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        course.interventions.push({
          name: parts[0],
          notes: parts[1]
        });
      }
    }
  });

  return course;
};

// const formatMedications = (meds) => {
//   return meds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency} ${med.route}`
//   ).join('\n');
// };
// const formatMedications = (meds) => {
//   const validMeds = meds.filter(med => med.name && med.name !== 'None');
//   return validMeds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency || ''} ${med.route || ''}`
//   ).join('\n');
// };

const parseMedications = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(' ');
    return {
      name: parts[0] || '',
      dose: parts[1] || '',
      frequency: parts.slice(2, -1).join(' ') || '',
      route: parts[parts.length - 1] || ''
    };
  });
};

// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   return text;
// };
// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
  
//   // If no items in either section, just show headers
//   if (text === 'To Do:\n\nNot To Do:\n') {
//     // return 'To Do:\n- \nNot To Do:\n- ';
//     return 'To Do:\n \nNot To Do:\n ';
//   }
  
//   return text;
// };

const parseInstructions = (text) => {
  const lines = text?.split('\n');
  const instructions = {
    to_do: [],
    not_to_do: []
  };

  let currentSection = '';
  
  lines?.forEach(line => {
    if (line.includes('To Do:')) {
      currentSection = 'to_do';
    } else if (line.includes('Not To Do:')) {
      currentSection = 'not_to_do';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'to_do') {
        instructions.to_do.push(item);
      } else if (currentSection === 'not_to_do') {
        instructions.not_to_do.push(item);
      }
    }
  });

  return instructions;
};

// const formatFollowUpPlan = (plan) => {
//   return `Follow up after: ${plan.follow_up_after_days && plan.follow_up_after_days == "None" ? '' : plan.follow_up_after_days + "Days"} 
// Location: ${plan.location== "None" ? '': plan.location}
// Doctor: ${plan.doctor== "None" ? '': plan.doctor}
// Contact: ${plan.contact== "None" ? '': plan.contact}`;
// // Location: ${plan.location || ''}
// // Doctor: ${plan.doctor || ''}
// // Contact: ${plan.contact || ''}`;
// };

const parseFollowUpPlan = (text) => {
  const lines = text?.split('\n');
  const plan = {
    follow_up_after_days: '',
    doctor: '',
    location: '',
    contact: ''
  };

  lines?.forEach(line => {
    if (line.includes('Follow up after:')) {
      plan.follow_up_after_days = line.replace('Follow up after:', '').replace('days', '').trim();
    } else if (line.includes('Location:')) {
      plan.location = line.replace('Location:', '').trim();
    } else if (line.includes('Doctor:')) {
      plan.doctor = line.replace('Doctor:', '').trim();
    } else if (line.includes('Contact:')) {
      plan.contact = line.replace('Contact:', '').trim();
    }
  });

  return plan;
};


// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   history.personal_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Medical History:\n';
//   history.past_medical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Surgical History:\n';
//   history.past_surgical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nChronic Medications:\n';
//   history.chronic_medications.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   return text;
// };
// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   const personalItems = history.personal_history.filter(item => item && item !== 'None');
//   personalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (personalItems.length === 0) text += ' \n';
//   // if (personalItems.length === 0) text += '- \n';
  
//   text += '\nPast Medical History:\n';
//   const medicalItems = history.past_medical_history.filter(item => item && item !== 'None');
//   medicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medicalItems.length === 0) text += ' \n';
//   // if (medicalItems.length === 0) text += '- \n';
  
//   text += '\nPast Surgical History:\n';
//   const surgicalItems = history.past_surgical_history.filter(item => item && item !== 'None');
//   surgicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (surgicalItems.length === 0) text += ' \n';
//   // if (surgicalItems.length === 0) text += '- \n';
  
//   text += '\nChronic Medications:\n';
//   const medItems = history.chronic_medications.filter(item => item && item !== 'None');
//   medItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medItems.length === 0) text += ' \n';
//   // if (medItems.length === 0) text += '- \n';
  
//   return text;
// };
const parseHistory = (text) => {
  const lines = text?.split('\n');
  const history = {
    personal_history: [],
    past_medical_history: [],
    past_surgical_history: [],
    chronic_medications: []
  };

  let currentSection = '';
  
  lines?.forEach(line => {
    if (line.includes('Personal History:')) {
      currentSection = 'personal';
    } else if (line.includes('Past Medical History:')) {
      currentSection = 'medical';
    } else if (line.includes('Past Surgical History:')) {
      currentSection = 'surgical';
    } else if (line.includes('Chronic Medications:')) {
      currentSection = 'meds';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'personal') {
        history.personal_history.push(item);
      } else if (currentSection === 'medical') {
        history.past_medical_history.push(item);
      } else if (currentSection === 'surgical') {
        history.past_surgical_history.push(item);
      } else if (currentSection === 'meds') {
        history.chronic_medications.push(item);
      }
    }
  });

  return history;
};

// const formatInvestigations = (investigations) => {
//   return investigations.map(inv => 
//     `${inv.name}: ${inv.value} ${inv.unit || ''}`
//   ).join('\n');
// };
// const formatInvestigations = (investigations) => {
//   const validInvestigations = investigations.filter(inv => inv.name && inv.name !== 'None');
//   return validInvestigations.map(inv => 
//     `${inv.name}: ${inv.value || ''} ${inv.unit || ''}`
//   ).join('\n');
// };

const parseInvestigations = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(':').map(p => p.trim());
    if (parts.length >= 2) {
      const valueParts = parts[1].split(' ');
      return {
        name: parts[0],
        value: valueParts[0],
        unit: valueParts.slice(1).join(' ') || ''
      };
    }
    return { name: '', value: '', unit: '' };
  });
};

// const formatProcedures = (procedures) => {
//   return procedures.map(proc => 
//     `${proc.name} - ${proc.date || ''}\n${proc.details || ''}`
//   ).join('\n\n');
// };
// const formatProcedures = (procedures) => {
//   const validProcedures = procedures.filter(proc => proc.name && proc.name !== 'None');
//   return validProcedures.map(proc => 
//     `${proc.name}${proc.date ? ` - ${proc.date}` : ''}${proc.details ? `\n${proc.details}` : ''}`
//   ).join('\n\n');
// };

const parseProcedures = (text) => {
  const procedureBlocks = text.split('\n\n');
  return procedureBlocks.filter(block => block.trim()).map(block => {
    const lines = block?.split('\n');
    const firstLineParts = lines[0].split('-').map(p => p.trim());
    return {
      name: firstLineParts[0] || '',
      date: firstLineParts.length > 1 ? firstLineParts[1] : '',
      details: lines.slice(1).join('\n') || ''
    };
  });
};

const [updatedDownloadData, setUpdatedDownloadData] = useState(null);
const [downloadSummaryId, setDownloadSummaryId] = useState(null);
const [dischargeSummary, setDischargeSummary] = useState(null);
const [docUrl, setDocUrl] = useState("");

const handleSaveAll = async () => {
  // Here you would process all the editableSections and save them
  // For example:
  showLoader();

  // Process custom attributes
  const customAttributes = {};
  if (aiDischargeResponse?.custom_attributes) {
    Object.keys(aiDischargeResponse.custom_attributes).forEach(key => {
      // Use the value from editableSections if user modified it, otherwise use AI response
      customAttributes[key] = editableSections[key] !== undefined ? 
        editableSections[key] : 
        formatValue(aiDischargeResponse.custom_attributes[key]);
    });
  }

  const updatedDischargeResponse = {
    ...aiDischargeResponse,
    patient_info: parsePatientInfo(editableSections.patientInfo),
    admission_details: {
      admitted_on: editableSections.admissionDetails.match(/Admitted:\s*(.*)/)?.[1] || "",
      discharge_date: editableSections.admissionDetails.match(/Discharged:\s*(.*)/)?.[1] || ""
    },
    diagnosis: {
      ...aiDischargeResponse?.diagnosis,
      final: editableSections.diagnosis.split('\n')
    },
    presenting_complaints: parseComplaints(editableSections.presentingComplaints),
    // clinical_findings: parseClinicalFindings(editableSections.clinicalFindings),
    clinical_findings: {
      ...aiDischargeResponse?.clinical_findings, // Preserve the original clinical_findings structure
      ...parseClinicalFindings(editableSections.clinicalFindings) // Merge with parsed findings
    },
    // history: parseHistory(editableSections.history),
    history: {
      ...aiDischargeResponse?.history, // Preserve original history structure
      ...parseHistory(editableSections.history) // Merge with parsed history
    },
    investigations: parseInvestigations(editableSections.investigations),
    procedures: parseProcedures(editableSections.procedures),
    // hospital_course: parseHospitalCourse(editableSections.hospitalCourse),
    hospital_course: {
      ...aiDischargeResponse?.hospital_course, // Preserve original hospital_course structure
      ...parseHospitalCourse(editableSections.hospitalCourse) // Merge with parsed hospital course
    },
    medications_on_discharge: parseMedications(editableSections.dischargeMeds),
    // instructions: parseInstructions(editableSections.instructions),
    // follow_up_plan: parseFollowUpPlan(editableSections.followUpPlan)
    instructions: {
      ...aiDischargeResponse?.instructions, // Preserve original instructions structure
      ...parseInstructions(editableSections.instructions) // Merge with parsed instructions
    },
    follow_up_plan: {
      ...aiDischargeResponse?.follow_up_plan, // Preserve original follow_up_plan structure
      ...parseFollowUpPlan(editableSections.followUpPlan) // Merge with parsed follow up plan
    },
     // Add custom attributes
    custom_attributes: customAttributes
  };
  setUpdatedDownloadData(updatedDischargeResponse);

  // console.log("Saving all data:", updatedDischargeResponse);
  const input = {
    'issingledocument': 1,
    'aiinput': updatedDischargeResponse,
  }
  if (isIPDDischarge) {
    input.appointmentid = appointmentId; 
    input.patientid = patientId;      
  }
  console.log("Saving all data:", input);

  try{
    const result = await SaveSummaryCallLog(input);
    if(result && result.output.result === 'Success') {
      setDownloadSummaryId(result.output.id);
      showSuccessToast("Discharge Summary Saved successfully");

      // await downloadSummary(result.output.id);
      await downloadSummary(result.output.id, false);
    }
  } catch (error) {
    console.error("API Error:", error);
  }
  dismissLoader();

};

// ------------------ Download functionality for Discharge Summary -------------------
// const downloadSummary = async () => {
//   try {
//     // Format the discharge summary data for PDF
//     const formatSection = (title, content) => {
//       if (!content) return '';
//       return `<h3>${title}</h3><p>${content.replace(/\n/g, "<br>")}</p>`;
//     };

//     let content = `<html>
//       <head>
//         <meta charset='utf-8'>
//         <style>
//           body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
//           h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
//           h3 { font-size: 16px; font-weight: bold; margin-top: 15px; }
//           p { font-size: 14px; margin-left: 10px; }
//           .section { margin-bottom: 20px; }
//           table { width: 100%; border-collapse: collapse; margin: 10px 0; }
//           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//           th { background-color: #f2f2f2; }
//         </style>
//       </head>
//       <body>
//         <h1>Patient Discharge Summary Report</h1>`;

//     // Patient Information
//     content += formatSection('Patient Information', 
//       `Name: ${aiDischargeResponse.patient_info.name}<br>
//       Age: ${aiDischargeResponse.patient_info.age || 'N/A'}<br>
//       Sex: ${aiDischargeResponse.patient_info.sex}<br>
//       UHID: ${aiDischargeResponse.patient_info.uhid}<br>
//       Consultant: ${aiDischargeResponse.patient_info.consultant}`);

//     // Admission Details
//     content += formatSection('Admission Details',
//       `Admitted: ${aiDischargeResponse.admission_details.admitted_on}<br>
//       Discharged: ${aiDischargeResponse.admission_details.discharge_date}`);

//     // Diagnosis
//     content += formatSection('Diagnosis', 
//       aiDischargeResponse.diagnosis.final.join('<br>'));

//     // Presenting Complaints
//     if (aiDischargeResponse.presenting_complaints?.length > 0) {
//       const complaints = aiDischargeResponse.presenting_complaints.map(c => 
//         `${c.description} (onset: ${c.onset})`).join('<br>');
//       content += formatSection('Presenting Complaints', complaints);
//     }

//     // Clinical Findings
//     if (aiDischargeResponse.clinical_findings) {
//       let findings = `General Condition: ${aiDischargeResponse.clinical_findings.general_condition}<br><br>`;
      
//       findings += '<strong>Vitals:</strong><br>';
//       findings += aiDischargeResponse.clinical_findings.vitals.map(v => 
//         `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>');
      
//       if (aiDischargeResponse.clinical_findings.systemic_examination?.length > 0) {
//         findings += '<br><br><strong>Systemic Examination:</strong><br>';
//         findings += aiDischargeResponse.clinical_findings.systemic_examination.map(e => 
//           `${e.system}: ${e.finding}`).join('<br>');
//       }
      
//       content += formatSection('Clinical Findings', findings);
//     }

//     // History
//     if (aiDischargeResponse.history) {
//       let historyText = '';
//       if (aiDischargeResponse.history.personal_history?.length > 0) {
//         historyText += '<strong>Personal History:</strong><br>';
//         historyText += aiDischargeResponse.history.personal_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (aiDischargeResponse.history.past_medical_history?.length > 0) {
//         historyText += '<strong>Past Medical History:</strong><br>';
//         historyText += aiDischargeResponse.history.past_medical_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (aiDischargeResponse.history.past_surgical_history?.length > 0) {
//         historyText += '<strong>Past Surgical History:</strong><br>';
//         historyText += aiDischargeResponse.history.past_surgical_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (aiDischargeResponse.history.chronic_medications?.length > 0) {
//         historyText += '<strong>Chronic Medications:</strong><br>';
//         historyText += aiDischargeResponse.history.chronic_medications
//           .filter(h => h !== 'None')
//           .join('<br>');
//       }
      
//       content += formatSection('History', historyText);
//     }

//     // Investigations
//     if (aiDischargeResponse.investigations?.length > 0) {
//       const investigations = aiDischargeResponse.investigations.map(i => 
//         `${i.name}: ${i.value} ${i.unit || ''}`).join('<br>');
//       content += formatSection('Investigations', investigations);
//     }

//     // Procedures
//     if (aiDischargeResponse.procedures?.length > 0) {
//       const procedures = aiDischargeResponse.procedures.map(p => 
//         `${p.name}${p.date ? ` (${p.date})` : ''}${p.details ? `<br>${p.details}` : ''}`)
//         .join('<br><br>');
//       content += formatSection('Procedures', procedures);
//     }

//     // Hospital Course
//     if (aiDischargeResponse.hospital_course) {
//       let courseText = aiDischargeResponse.hospital_course.summary;
//       if (aiDischargeResponse.hospital_course.interventions?.length > 0) {
//         courseText += '<br><br><strong>Interventions:</strong><br>';
//         courseText += aiDischargeResponse.hospital_course.interventions.map(i => 
//           `${i.name}: ${i.notes}`).join('<br>');
//       }
//       content += formatSection('Hospital Course', courseText);
//     }

//     // Discharge Medications
//     if (aiDischargeResponse.medications_on_discharge?.length > 0) {
//       const medsTable = `
//         <table>
//           <thead>
//             <tr>
//               <th>Medication</th>
//               <th>Dose</th>
//               <th>Frequency</th>
//               <th>Route</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${aiDischargeResponse.medications_on_discharge.map(med => `
//               <tr>
//                 <td>${med.name}</td>
//                 <td>${med.dose || 'N/A'}</td>
//                 <td>${med.frequency}</td>
//                 <td>${med.route}</td>
//               </tr>
//             `).join('')}
//           </tbody>
//         </table>`;
//       content += `<div class="section"><h3>Discharge Medications</h3>${medsTable}</div>`;
//     }

//     // Instructions
//     if (aiDischargeResponse.instructions) {
//       let instructionsText = '';
//       if (aiDischargeResponse.instructions.to_do?.length > 0) {
//         instructionsText += '<strong>To Do:</strong><br>';
//         instructionsText += aiDischargeResponse.instructions.to_do.join('<br>') + '<br><br>';
//       }
//       if (aiDischargeResponse.instructions.not_to_do?.length > 0) {
//         instructionsText += '<strong>Not To Do:</strong><br>';
//         instructionsText += aiDischargeResponse.instructions.not_to_do.join('<br>');
//       }
//       content += formatSection('Instructions', instructionsText);
//     }

//     // Follow Up Plan
//     if (aiDischargeResponse.follow_up_plan) {
//       const followUp = `
//         Follow up after: ${aiDischargeResponse.follow_up_plan.follow_up_after_days || 'N/A'} days<br>
//         Location: ${aiDischargeResponse.follow_up_plan.location || 'N/A'}<br>
//         Doctor: ${aiDischargeResponse.follow_up_plan.doctor || 'N/A'}<br>
//         Contact: ${aiDischargeResponse.follow_up_plan.contact || 'N/A'}`;
//       content += formatSection('Follow Up Plan', followUp);
//     }

//     content += `</body></html>`;

    
//     // // Create PDF options
//     // const options = {
//     //   margin: 10,
//     //   filename: 'discharge-summary.pdf',
//     //   image: { type: 'jpeg', quality: 0.98 },
//     //   html2canvas: { scale: 2 },
//     //   jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
//     // };

//     // // Generate PDF
//     // const pdfBlob = await html2pdf().set(options).from(content).toPdf().get('pdf').then((pdf) => {
//     //   return pdf.output('blob');
//     // });

//     // // Create download link for PDF
//     // const pdfUrl = URL.createObjectURL(pdfBlob);
//     // const a = document.createElement('a');
//     // a.href = pdfUrl;
//     // a.download = 'discharge-summary.pdf';
//     // document.body.appendChild(a);
//     // a.click();
//     // document.body.removeChild(a);
//     // URL.revokeObjectURL(pdfUrl);

//     // // Upload the PDF file if needed
//     // if (dischargeSummary && dischargeSummary == 1) {
//     //   const file = new File([pdfBlob], 'discharge-summary.pdf', { type: 'application/pdf' });
      
//     //   const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.pdf');
//     //   const documenturl = uploadResponse.name;
//     //   if (uploadResponse) {
//     //     setDocUrl(documenturl);
//     //   } else {
//     //     setDocUrl('');
//     //   }

//     // Create and trigger download
//     const encodedContent = encodeURIComponent(content);
//     const a = document.createElement("a");
//     a.href = "data:application/msword;charset=utf-8," + encodedContent;
//     a.download = "discharge-summary.doc";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);

//     // Upload the .doc file if needed
//     if (dischargeSummary && dischargeSummary == 1) {
//       const blob = new Blob([content], { type: 'application/msword' });
//       const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });
      
//       const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
//       const documenturl = uploadResponse.name;
//       if (uploadResponse) {
//         setDocUrl(documenturl);
//       } else {
//         setDocUrl('');
//       }
      
//       const handleDownloadSummary = async () => { 
//         showLoader();
//         const input = {
//           'id': downloadSummaryId,
//           'downloadedpdf': docUrl && docUrl != "" ? docUrl : documenturl,
//           'type': 'update',
//         }
//         try {
//           alert('if hit')
//           const result = await SaveSummaryCallLog(input);
//           if (result && result.output.result === 'Success') {
//             showSuccessToast("PDF downloaded successfully");
//           }
//         } catch (error) {
//           console.error("API Error:", error);
//         }
//         dismissLoader();
//       };

//       await handleDownloadSummary();
//     }

//     // navigate("/home");
//   } catch (error) {
//     console.error("Error in downloadSummary:", error);
//     showErrorToast("Failed to download the document");
//   }
// };

const downloadSummary = async (summaryId = null, shouldDownloadFile = true) => {
  try {
    const idToUse = summaryId || downloadSummaryId;

// Get audiourl from localStorage (set by CPU-transcription.js)
    const dischargeAudioUrl = localStorage.getItem("dischargeAudioUrl");
    console.log('dischargeAudioUrl: ', dischargeAudioUrl)

    // Helper function to format sections
    const formatSection = (title, content) => {
      if (!content) return '';
      return `<h3>${title}</h3><p>${content.replace(/\n/g, "<br>")}</p>`;
    };

    // Parse custom attributes
    const customAttributes = {};
    if (aiDischargeResponse?.custom_attributes) {
      Object.keys(aiDischargeResponse.custom_attributes).forEach(key => {
        // Use the value from editableSections if user modified it, otherwise use AI response
        customAttributes[key] = editableSections[key] !== undefined ? 
          editableSections[key] : 
          formatValue(aiDischargeResponse.custom_attributes[key]);
      });
    }

    // Parse the editable sections back to structured data
    const parsedData = {
      patient_info: parsePatientInfo(editableSections.patientInfo),
      admission_details: {
        admitted_on: editableSections.admissionDetails.match(/Admitted:\s*(.*)/)?.[1] || "",
        discharge_date: editableSections.admissionDetails.match(/Discharged:\s*(.*)/)?.[1] || ""
      },
      diagnosis: {
        final: editableSections.diagnosis.split('\n').filter(line => line.trim())
      },
      presenting_complaints: parseComplaints(editableSections.presentingComplaints),
      clinical_findings: parseClinicalFindings(editableSections.clinicalFindings),
      history: parseHistory(editableSections.history),
      investigations: parseInvestigations(editableSections.investigations),
      procedures: parseProcedures(editableSections.procedures),
      hospital_course: parseHospitalCourse(editableSections.hospitalCourse),
      medications_on_discharge: parseMedications(editableSections.dischargeMeds),
      instructions: parseInstructions(editableSections.instructions),
      follow_up_plan: parseFollowUpPlan(editableSections.followUpPlan)
    };

    let content = `<html>
      <head>
        <meta charset='utf-8'>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
          h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
          h3 { font-size: 16px; font-weight: bold; margin-top: 15px; }
          p { font-size: 14px; margin-left: 10px; }
          .section { margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; margin: 10px 0; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
        </style>
      </head>
      <body>
        <h1>Patient Discharge Summary Report</h1>`;

    // Patient Information
    content += formatSection('Patient Information', editableSections.patientInfo);

    // Admission Details
    content += formatSection('Admission Details', editableSections.admissionDetails);

    // Diagnosis
    content += formatSection('Diagnosis', editableSections.diagnosis);

    // Presenting Complaints
    if (parsedData.presenting_complaints?.length > 0) {
      const complaints = parsedData.presenting_complaints.map(c => 
        `${c.description} (onset: ${c.onset})`).join('<br>');
      content += formatSection('Presenting Complaints', complaints);
    }

    // existing
    // Clinical Findings
    // if (parsedData.clinical_findings) {
    //   let findings = `General Condition: ${parsedData.clinical_findings.general_condition}<br><br>`;
      
    //   findings += '<strong>Vitals:</strong><br>';
    //   findings += parsedData.clinical_findings.vitals.map(v => 
    //     `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>');
      
    //   if (parsedData.clinical_findings.systemic_examination?.length > 0) {
    //     findings += '<br><br><strong>Systemic Examination:</strong><br>';
    //     findings += parsedData.clinical_findings.systemic_examination.map(e => 
    //       `${e.system}: ${e.finding}`).join('<br>');
    //   }
      
    //   content += formatSection('Clinical Findings', findings);
    // }

    // newly added
    // Clinical Findings - FIXED THIS SECTION
    if (parsedData.clinical_findings) {
      let findings = `General Condition: ${parsedData.clinical_findings.general_condition || 'N/A'}<br><br>`;
      
      // Admission Vitals
      if (parsedData.clinical_findings.admission_vitals?.length > 0) {
        findings += '<strong>Admission Vitals:</strong><br>';
        findings += parsedData.clinical_findings.admission_vitals.map(v => 
          `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>') + '<br><br>';
      }
      
      // Discharge Vitals
      if (parsedData.clinical_findings.discharge_vitals?.length > 0) {
        findings += '<strong>Discharge Vitals:</strong><br>';
        findings += parsedData.clinical_findings.discharge_vitals.map(v => 
          `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>') + '<br><br>';
      }
      
      // Systemic Examination
      if (parsedData.clinical_findings.systemic_examination?.length > 0) {
        findings += '<strong>Systemic Examination:</strong><br>';
        findings += parsedData.clinical_findings.systemic_examination.map(e => 
          `${e.system}: ${e.finding}`).join('<br>') + '<br><br>';
      }
      
      // Local Examination
      if (parsedData.clinical_findings.local_examination?.length > 0) {
        findings += '<strong>Local Examination:</strong><br>';
        findings += parsedData.clinical_findings.local_examination.map(e => 
          `${e.system}: ${e.finding}`).join('<br>');
      }
      
      content += formatSection('Clinical Findings', findings);
    }

    // History
    if (parsedData.history) {
      let historyText = '';
      if (parsedData.history.personal_history?.length > 0) {
        historyText += '<strong>Personal History:</strong><br>';
        historyText += parsedData.history.personal_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.past_medical_history?.length > 0) {
        historyText += '<strong>Past Medical History:</strong><br>';
        historyText += parsedData.history.past_medical_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.past_surgical_history?.length > 0) {
        historyText += '<strong>Past Surgical History:</strong><br>';
        historyText += parsedData.history.past_surgical_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.chronic_medications?.length > 0) {
        historyText += '<strong>Chronic Medications:</strong><br>';
        historyText += parsedData.history.chronic_medications
          .filter(h => h !== 'None')
          .join('<br>');
      }
      
      content += formatSection('History', historyText);
    }

    // Investigations
    if (parsedData.investigations?.length > 0) {
      const investigations = parsedData.investigations.map(i => 
        `${i.name}: ${i.value} ${i.unit || ''}`).join('<br>');
      content += formatSection('Investigations', investigations);
    }

    // Procedures
    if (parsedData.procedures?.length > 0) {
      const procedures = parsedData.procedures.map(p => 
        `${p.name}${p.date ? ` (${p.date})` : ''}${p.details ? `<br>${p.details}` : ''}`)
        .join('<br><br>');
      content += formatSection('Procedures', procedures);
    }

    // Hospital Course
    if (parsedData.hospital_course) {
      let courseText = parsedData.hospital_course.summary;
      if (parsedData.hospital_course.interventions?.length > 0) {
        courseText += '<br><br><strong>Interventions:</strong><br>';
        courseText += parsedData.hospital_course.interventions.map(i => 
          `${i.name}: ${i.notes}`).join('<br>');
      }
      content += formatSection('Hospital Course', courseText);
    }

    // Discharge Medications
    if (parsedData.medications_on_discharge?.length > 0) {
      const medsTable = `
        <table>
          <thead>
            <tr>
              <th>Medication</th>
              <th>Dose</th>
              <th>Frequency</th>
              <th>Route</th>
            </tr>
          </thead>
          <tbody>
            ${parsedData.medications_on_discharge.map(med => `
              <tr>
                <td>${med.name}</td>
                <td>${med.dose || 'N/A'}</td>
                <td>${med.frequency}</td>
                <td>${med.route}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>`;
      content += `<div class="section"><h3>Discharge Medications</h3>${medsTable}</div>`;
    }

    // Instructions
    if (parsedData.instructions) {
      let instructionsText = '';
      if (parsedData.instructions.to_do?.length > 0) {
        instructionsText += '<strong>To Do:</strong><br>';
        instructionsText += parsedData.instructions.to_do.join('<br>') + '<br><br>';
      }
      if (parsedData.instructions.not_to_do?.length > 0) {
        instructionsText += '<strong>Not To Do:</strong><br>';
        instructionsText += parsedData.instructions.not_to_do.join('<br>');
      }
      content += formatSection('Instructions', instructionsText);
    }

    // Follow Up Plan
    if (parsedData.follow_up_plan) {
      const followUp = `
        Follow up after: ${parsedData.follow_up_plan.follow_up_after_days || 'N/A'} days<br>
        Location: ${parsedData.follow_up_plan.location || 'N/A'}<br>
        Doctor: ${parsedData.follow_up_plan.doctor || 'N/A'}<br>
        Contact: ${parsedData.follow_up_plan.contact || 'N/A'}`;
      content += formatSection('Follow Up Plan', followUp);
    }

    // Custom Attributes Section
    if (parsedData.custom_attributes && Object.keys(parsedData.custom_attributes).length > 0) {
      let customAttributesText = '';
      Object.entries(parsedData.custom_attributes).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          const formattedKey = formatAttributeKey(key);
          customAttributesText += `<strong>${formattedKey}:</strong><br>${value.replace(/\n/g, '<br>')}<br><br>`;
        }
      });
      
      if (customAttributesText.trim() !== '') {
        content += `<div class="section"><h3>Additional Information</h3><p>${customAttributesText}</p></div>`;
      }
    }

    content += `</body></html>`;

    // Create and trigger download
    if (shouldDownloadFile) {
    const encodedContent = encodeURIComponent(content);
    const a = document.createElement("a");
    a.href = "data:application/msword;charset=utf-8," + encodedContent;
    a.download = "discharge-summary.doc";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // existing
    // if(isIPDDischarge) {
    //   navigate('/ipdpatients')
    // } else {
    //   navigate('/home');
    // }
  }
    // const getDischargeSetting = localStorage.getItem('saveDischarge');



    // Upload the .doc file if needed
    // if (dischargeSummary && dischargeSummary == 1) {
    //   const blob = new Blob([content], { type: 'application/msword' });
    //   const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });
      
    //   const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
    //   const documenturl = uploadResponse.name;
    //   if (uploadResponse) {
    //     setDocUrl(documenturl);
    //   } else {
    //     setDocUrl('');
    //   }
      
    //   const handleDownloadSummary = async () => { 
    //     showLoader();
    //     const input = {
    //       'id': downloadSummaryId,
    //       'downloadedpdf': docUrl && docUrl != "" ? docUrl : documenturl,
    //       'type': 'update',
    //     }
    //     try {
    //       alert('hit')
    //       const result = await SaveSummaryCallLog(input);
    //       if (result && result.output.result === 'Success') {
    //         showSuccessToast("PDF downloaded successfully");
    //       }
    //     } catch (error) {
    //       console.error("API Error:", error);
    //     }
    //     dismissLoader();
    //   };

    //   await handleDownloadSummary();
    // }
    // if (dischargeSummary && dischargeSummary == 1) {
    // if(getDischargeSetting == 1) {
      try {
        showLoader();
        
        // First upload the document
        const blob = new Blob([content], { type: 'application/msword' });
        const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });
        
        const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
        
        if (!uploadResponse || !uploadResponse.name) {
          throw new Error("Failed to upload document");
        }
        
        const documenturl = uploadResponse.name;
        setDocUrl(documenturl);

        // Then make the API call to save the summary
        const input = {
          // 'id': downloadSummaryId,
          'id': idToUse,
          'downloadedpdf': documenturl,
          'type': 'update',
          // ADD audiourl if available
          ...(dischargeAudioUrl && { audiourl: dischargeAudioUrl })
        };

        const result = await SaveSummaryCallLog(input);
        
        if (result && result.output && result.output.result === 'Success') {
          // showSuccessToast("Document downloaded and saved successfully");
          if (shouldDownloadFile) {
            showSuccessToast("Document downloaded and saved successfully");
          } else {
            showSuccessToast("Document saved successfully");
          }
          if(dischargeAudioUrl) {
            localStorage.removeItem("dischargeAudioUrl");
          }
        } else {
          throw new Error(result?.output?.message || "Failed to save summary");
        }
      } catch (error) {
        console.error("API Error:", error);
        // showErrorToast(error.message || "Failed to complete download process");
        if (shouldDownloadFile) {
          showErrorToast(error.message || "Failed to complete download process");
        } else {
          showErrorToast(error.message || "Failed to save document");
        }
      } finally {
        dismissLoader();
      }
    // }

     // Navigation happens regardless of whether file was downloaded or not
    if(isIPDDischarge) {
      navigate('/ipdpatients')
    } else {
      navigate('/home');
    }

  } catch (error) {
    console.error("Error in downloadSummary:", error);
    showErrorToast("Failed to download the document");
  }
};

// const downloadSummary = async () => {
//   try {
//     // Create a temporary div to hold our content
//     const tempDiv = document.createElement('div');
//     tempDiv.style.position = 'absolute';
//     tempDiv.style.left = '-9999px';
//     tempDiv.style.width = '210mm'; // A4 width
//     tempDiv.style.padding = '20px';
//     tempDiv.style.fontFamily = 'Arial, sans-serif';
    
//     // Build the HTML content
//     tempDiv.innerHTML = `
//       <h1 style="text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px;">
//         Patient Discharge Summary Report
//       </h1>
//       ${generateDischargeSummaryHTML(aiDischargeResponse)}
//     `;
    
//     document.body.appendChild(tempDiv);

//     // Convert to canvas then to PDF
//     const canvas = await html2canvas(tempDiv, {
//       scale: 2, // Higher quality
//       logging: false,
//       useCORS: true,
//       allowTaint: true
//     });

//     // Remove the temporary div
//     document.body.removeChild(tempDiv);

//     // Create PDF
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const imgData = canvas.toDataURL('image/png');
//     const imgWidth = 210; // A4 width in mm
//     const pageHeight = 295; // A4 height in mm
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     // Add new pages if content is longer than one page
//     while (heightLeft >= 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     // Download the PDF
//     const pdfBlob = pdf.output('blob');
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     const a = document.createElement('a');
//     a.href = pdfUrl;
//     a.download = 'discharge-summary.pdf';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(pdfUrl);

//     // Upload the PDF file if needed
//     if (dischargeSummary && dischargeSummary == 1) {
//       const file = new File([pdfBlob], 'discharge-summary.pdf', { type: 'application/pdf' });
      
//       const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.pdf');
//       const documenturl = uploadResponse.name;
//       if (uploadResponse) {
//         setDocUrl(documenturl);
//       } else {
//         setDocUrl('');
//       }
      
//       const handleDownloadSummary = async () => { 
//         showLoader();
//         const input = {
//           'id': downloadSummaryId,
//           'downloadedpdf': docUrl && docUrl != "" ? docUrl : documenturl,
//           'type': 'update',
//         }
//         try {
//           const result = await SaveSummaryCallLog(input);
//           if (result && result.output.result === 'Success') {
//             showSuccessToast("PDF downloaded successfully");
//           }
//         } catch (error) {
//           console.error("API Error:", error);
//         }
//         dismissLoader();
//       };

//       await handleDownloadSummary();
//     }

//     navigate("/home");
//   } catch (error) {
//     console.error("Error in downloadSummary:", error);
//     showErrorToast("Failed to generate PDF");
//   }
// };

// // Helper function to generate HTML for all sections
// const generateDischargeSummaryHTML = (data) => {
//   const formatSection = (title, content) => {
//     if (!content) return '';
//     return `
//       <div style="margin-bottom: 15px;">
//         <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 5px;">
//           ${title}
//         </h3>
//         <div style="font-size: 14px; margin-left: 10px;">
//           ${content.replace(/\n/g, "<br>")}
//         </div>
//       </div>
//     `;
//   };

//   const formatTable = (headers, rows) => {
//     return `
//       <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
//         <thead>
//           <tr>
//             ${headers.map(h => `<th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #f2f2f2;">${h}</th>`).join('')}
//           </tr>
//         </thead>
//         <tbody>
//           ${rows.map(row => `
//             <tr>
//               ${row.map(cell => `<td style="border: 1px solid #ddd; padding: 8px; text-align: left;">${cell}</td>`).join('')}
//             </tr>
//           `).join('')}
//         </tbody>
//       </table>
//     `;
//   };

//   let html = '';
  
//   // Patient Information
//   html += formatSection('Patient Information', 
//     `Name: ${data.patient_info.name}<br>
//     Age: ${data.patient_info.age || 'N/A'}<br>
//     Sex: ${data.patient_info.sex}<br>
//     UHID: ${data.patient_info.uhid}<br>
//     Consultant: ${data.patient_info.consultant}`);

//   // Admission Details
//   html += formatSection('Admission Details',
//     `Admitted: ${data.admission_details.admitted_on}<br>
//     Discharged: ${data.admission_details.discharge_date}`);

//   // Diagnosis
//   html += formatSection('Diagnosis', 
//     data.diagnosis.final.join('<br>'));

//   // Presenting Complaints
//   if (data.presenting_complaints?.length > 0) {
//     const complaints = data.presenting_complaints.map(c => 
//       `${c.description} (onset: ${c.onset})`).join('<br>');
//     html += formatSection('Presenting Complaints', complaints);
//   }

//   // Clinical Findings
//   if (data.clinical_findings) {
//     let findings = `General Condition: ${data.clinical_findings.general_condition}<br><br>`;
    
//     findings += '<strong>Vitals:</strong><br>';
//     findings += data.clinical_findings.vitals.map(v => 
//       `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>');
    
//     if (data.clinical_findings.systemic_examination?.length > 0) {
//       findings += '<br><br><strong>Systemic Examination:</strong><br>';
//       findings += data.clinical_findings.systemic_examination.map(e => 
//         `${e.system}: ${e.finding}`).join('<br>');
//     }
    
//     html += formatSection('Clinical Findings', findings);
//   }

//   // History
//   if (data.history) {
//     let historyText = '';
//     if (data.history.personal_history?.length > 0) {
//       historyText += '<strong>Personal History:</strong><br>';
//       historyText += data.history.personal_history
//         .filter(h => h !== 'None')
//         .join('<br>') + '<br><br>';
//     }
    
//     if (data.history.past_medical_history?.length > 0) {
//       historyText += '<strong>Past Medical History:</strong><br>';
//       historyText += data.history.past_medical_history
//         .filter(h => h !== 'None')
//         .join('<br>') + '<br><br>';
//     }
    
//     if (data.history.past_surgical_history?.length > 0) {
//       historyText += '<strong>Past Surgical History:</strong><br>';
//       historyText += data.history.past_surgical_history
//         .filter(h => h !== 'None')
//         .join('<br>') + '<br><br>';
//     }
    
//     if (data.history.chronic_medications?.length > 0) {
//       historyText += '<strong>Chronic Medications:</strong><br>';
//       historyText += data.history.chronic_medications
//         .filter(h => h !== 'None')
//         .join('<br>');
//     }
    
//     html += formatSection('History', historyText);
//   }

//   // Investigations
//   if (data.investigations?.length > 0) {
//     const investigations = data.investigations.map(i => 
//       `${i.name}: ${i.value} ${i.unit || ''}`).join('<br>');
//     html += formatSection('Investigations', investigations);
//   }

//   // Procedures
//   if (data.procedures?.length > 0) {
//     const procedures = data.procedures.map(p => 
//       `${p.name}${p.date ? ` (${p.date})` : ''}${p.details ? `<br>${p.details}` : ''}`)
//       .join('<br><br>');
//     html += formatSection('Procedures', procedures);
//   }

//   // Hospital Course
//   if (data.hospital_course) {
//     let courseText = data.hospital_course.summary;
//     if (data.hospital_course.interventions?.length > 0) {
//       courseText += '<br><br><strong>Interventions:</strong><br>';
//       courseText += data.hospital_course.interventions.map(i => 
//         `${i.name}: ${i.notes}`).join('<br>');
//     }
//     html += formatSection('Hospital Course', courseText);
//   }

//   // Discharge Medications
//   if (data.medications_on_discharge?.length > 0) {
//     const medsTable = formatTable(
//       ['Medication', 'Dose', 'Frequency', 'Route'],
//       data.medications_on_discharge.map(med => [
//         med.name,
//         med.dose || 'N/A',
//         med.frequency,
//         med.route
//       ])
//     );
//     html += `<div style="margin-bottom: 20px;">
//       <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 5px;">
//         Discharge Medications
//       </h3>
//       ${medsTable}
//     </div>`;
//   }

//   // Instructions
//   if (data.instructions) {
//     let instructionsText = '';
//     if (data.instructions.to_do?.length > 0) {
//       instructionsText += '<strong>To Do:</strong><br>';
//       instructionsText += data.instructions.to_do.join('<br>') + '<br><br>';
//     }
//     if (data.instructions.not_to_do?.length > 0) {
//       instructionsText += '<strong>Not To Do:</strong><br>';
//       instructionsText += data.instructions.not_to_do.join('<br>');
//     }
//     html += formatSection('Instructions', instructionsText);
//   }

//   // Follow Up Plan
//   if (data.follow_up_plan) {
//     const followUp = `
//       Follow up after: ${data.follow_up_plan.follow_up_after_days || 'N/A'} days<br>
//       Location: ${data.follow_up_plan.location || 'N/A'}<br>
//       Doctor: ${data.follow_up_plan.doctor || 'N/A'}<br>
//       Contact: ${data.follow_up_plan.contact || 'N/A'}`;
//     html += formatSection('Follow Up Plan', followUp);
//   }

//   return html;
// };

// ------------------------ Generate text ---------------------

// Generate initial presenting complaints text
  const generatePresentingComplaintsText = (complaints, gender, age) => {
    if (!complaints || complaints.length === 0) return '';
    
    // const patientText = `A ${age || ''}-year-old ${gender || 'patient'}`;
    const patientText = `A ${age== "None" ? "-" : age}-year-old ${gender== "None" ? "-" : gender}`;
    const complaintItems = complaints.map(c => 
      `${c.description.toLowerCase()}${c.onset!="None" ? ` (since ${c.onset})` : ''}`
    );
    
    if (complaintItems.length === 1) {
      return `${patientText} presented with ${complaintItems[0]}.`;
    }
    
    const lastItem = complaintItems.pop();
    return `${patientText} presented with ${complaintItems.join(', ')} and ${lastItem}.`;
  };

  // Initialize editable text when data loads
  useEffect(() => {
    if (aiDischargeResponse?.presenting_complaints?.length > 0) {
      const generatedText = generatePresentingComplaintsText(
        aiDischargeResponse.presenting_complaints,
        aiDischargeResponse.patient_info?.sex,
        aiDischargeResponse.patient_info?.age
      );
      setEditableSections(prev => ({
        ...prev,
        presentingComplaints: generatedText
      }));
    }
  }, [aiDischargeResponse]);

  // ---------------------------------------------new formatting functions --------------------------

  // Format Patient Information
  // existing (use this)
// const formatPatientInfo = (patientInfo) => {
//   console.log('patientINFOR: ', patientInfo)
//   if (!patientInfo) return "";
  
//   const formatValue = (value) => value === "None" ? "" : value || "";
//   console.log('formatValue: ', formatValue)
  
//   return `Name: ${formatValue(patientInfo.name)}
// Age: ${formatValue(patientInfo.age)}
// Sex: ${formatValue(patientInfo.sex)}
// Mobile: ${formatValue(patientInfo.phone)}
// UHID: ${formatValue(patientInfo.uhid)}
// Mrn: ${formatValue(patientInfo.mrn)}
// Registration No: ${formatValue(patientInfo.registration_no)}
// Panel: ${formatValue(patientInfo.panel_name)}
// Consultant: ${formatValue(patientInfo.consultant)}`;
// };
const formatPatientInfo = (patientInfo) => {
  if (!patientInfo) return "";

  const pick = (...keys) => {
    for (const k of keys) {
      const v = patientInfo[k];
      if (v !== undefined && v !== null) {
        const s = String(v).trim();
        if (s && s.toLowerCase() !== "none") return s;
      }
    }
    return "";
  };

  const name = pick("name", "full_name", "fullname", "patientname", "firstname", "first_name");
  const age = pick("age", "patientage", "patient_age", "dob", "dateOfBirth");
  const gender = pick("sex", "gender");
  const mobile = pick("phone", "mobile_no", "mobileno", "mobile", "contact");
  const uhid = pick("uhid", "uhid_no", "patientmrn", "mrn", "mrn_no");
  const mrn = pick("mrn", "registrationno", "registration_no");
  const registration_no = pick("registration_no", "registrationno", "reg_no");
  const panel_name = pick("panel_name", "panel");
  const consultant = pick("consultant", "consultant_doctor", "drname", "doctor");

  const lines = [];
  if (name) lines.push(`Name: ${name}`);
  if (age) lines.push(`Age: ${age}`);
  if (gender) lines.push(`Sex: ${gender}`);
  if (mobile) lines.push(`Mobile: ${mobile}`);
  if (uhid) lines.push(`UHID: ${uhid}`);
  if (mrn) lines.push(`MRN: ${mrn}`);
  if (registration_no) lines.push(`Registration No: ${registration_no}`);
  if (panel_name) lines.push(`Panel: ${panel_name}`);
  if (consultant) lines.push(`Consultant: ${consultant}`);

  return lines.join("\n");
};

// Format Admission Details
const formatAdmissionDetails = (admissionDetails) => {
  if (!admissionDetails) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  return `Admitted On: ${formatValue(admissionDetails.admitted_on)}
Discharge Date: ${formatValue(admissionDetails.discharge_date)}`;
};

// Format Diagnosis
const formatDiagnosis = (diagnosis) => {
  if (!diagnosis) return "";
  let result = "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  if (diagnosis.provisional && diagnosis.provisional !== "None") {
    result += `Provisional Diagnosis: ${formatValue(diagnosis.provisional)}\n`;
  }
  if (diagnosis.final && diagnosis.final.length > 0) {
    const validDiagnosis = diagnosis.final.filter(dx => dx !== "None");
    if (validDiagnosis.length > 0) {
      result += "Final Diagnosis:\n";
      validDiagnosis.forEach((dx, index) => {
        result += `${index + 1}. ${dx}\n`;
      });
    }
  }
  return result || "";
};

// Format Presenting Complaints
const formatComplaints = (complaints) => {
  if (!complaints || !Array.isArray(complaints)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validComplaints = complaints.filter(complaint => 
    complaint.description !== "None" || complaint.onset !== "None"
  );
  
  if (validComplaints.length === 0) return "";
  
  return validComplaints.map(complaint => 
    `${formatValue(complaint.description)}${complaint.onset !== "None" ? ` - Onset: ${formatValue(complaint.onset)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n');
};

// Format Clinical Findings
const formatClinicalFindings = (clinicalFindings) => {
  if (!clinicalFindings) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // General Condition
  if (clinicalFindings.general_condition && clinicalFindings.general_condition !== "None") {
    result += `General Condition: ${formatValue(clinicalFindings.general_condition)}\n\n`;
  }
  
  // Admission Vitals - filter out "None" values
  if (clinicalFindings.admission_vitals && clinicalFindings.admission_vitals.length > 0) {
    const validVitals = clinicalFindings.admission_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Admission Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Discharge Vitals - filter out "None" values
  if (clinicalFindings.discharge_vitals && clinicalFindings.discharge_vitals.length > 0) {
    const validVitals = clinicalFindings.discharge_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Discharge Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Systemic Examination - filter out "None" values
  if (clinicalFindings.systemic_examination && clinicalFindings.systemic_examination.length > 0) {
    const validExams = clinicalFindings.systemic_examination.filter(exam => 
      exam.finding !== "None" && exam.system !== "None"
    );
    if (validExams.length > 0) {
      result += "Systemic Examination:\n";
      validExams.forEach(exam => {
        result += `- ${formatValue(exam.system)}: ${formatValue(exam.finding)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format History
const formatHistory = (history) => {
  if (!history) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Personal History
  if (history.personal_history && history.personal_history.length > 0) {
    const validHistory = history.personal_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Personal History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Medical History
  if (history.past_medical_history && history.past_medical_history.length > 0) {
    const validHistory = history.past_medical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Medical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Surgical History
  if (history.past_surgical_history && history.past_surgical_history.length > 0) {
    const validHistory = history.past_surgical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Surgical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Chronic Medications
  if (history.chronic_medications && history.chronic_medications.length > 0) {
    const validMeds = history.chronic_medications.filter(med => med !== "None");
    if (validMeds.length > 0) {
      result += "Chronic Medications:\n";
      validMeds.forEach(med => {
        result += `- ${med}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Investigations
const formatInvestigations = (investigations) => {
  if (!investigations || !Array.isArray(investigations)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validInvestigations = investigations.filter(inv => 
    inv.value !== "None" && inv.name !== "None"
  );
  
  if (validInvestigations.length === 0) return "";
  
  return validInvestigations.map(inv => 
    `${formatValue(inv.name)}: ${formatValue(inv.value)} ${formatValue(inv.unit)}`
  ).join('\n');
};

// Format Procedures
const formatProcedures = (procedures) => {
  if (!procedures || !Array.isArray(procedures)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validProcedures = procedures.filter(proc => 
    proc.name !== "None" && proc.name !== ""
  );
  
  if (validProcedures.length === 0) return "";
  
  return validProcedures.map(proc => 
    `${formatValue(proc.name)}${proc.date && proc.date !== "None" ? ` - ${formatValue(proc.date)}` : ''}${proc.details && proc.details !== "None" ? `\n${formatValue(proc.details)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n\n');
};

// Format Hospital Course
const formatHospitalCourse = (hospitalCourse) => {
  if (!hospitalCourse) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Summary
  if (hospitalCourse.summary && hospitalCourse.summary !== "None") {
    result += `Summary: ${formatValue(hospitalCourse.summary)}\n\n`;
  }
  
  // Interventions
  if (hospitalCourse.interventions && hospitalCourse.interventions.length > 0) {
    const validInterventions = hospitalCourse.interventions.filter(intervention => 
      intervention.name !== "None" && intervention.notes !== "None"
    );
    if (validInterventions.length > 0) {
      result += "Interventions:\n";
      validInterventions.forEach(intervention => {
        result += `- ${formatValue(intervention.name)}: ${formatValue(intervention.notes)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Medications
const formatMedications = (medications) => {
  if (!medications || !Array.isArray(medications)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validMedications = medications.filter(med => 
    med.name !== "None" && med.name !== ""
  );
  
  if (validMedications.length === 0) return "";
  
  return validMedications.map(med => {
    const parts = [
      formatValue(med.name),
      formatValue(med.dose),
      formatValue(med.frequency),
      formatValue(med.route),
      med.duration && med.duration !== "None" ? `for ${formatValue(med.duration)}` : "",
      med.timing && med.timing !== "None" ? `(${formatValue(med.timing)})` : ""
    ].filter(part => part !== "").join(' ');
    
    return parts.trim();
  }).filter(line => line.trim() !== '').join('\n');
};

// Format Instructions
const formatInstructions = (instructions) => {
  if (!instructions) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // To Do
  if (instructions.to_do && instructions.to_do.length > 0) {
    const validToDo = instructions.to_do.filter(item => item !== "None");
    if (validToDo.length > 0) {
      result += "To Do:\n";
      validToDo.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Not To Do
  if (instructions.not_to_do && instructions.not_to_do.length > 0) {
    const validNotToDo = instructions.not_to_do.filter(item => item !== "None");
    if (validNotToDo.length > 0) {
      result += "Not To Do:\n";
      validNotToDo.forEach(item => {
        result += `- ${item}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Follow Up Plan
const formatFollowUpPlan = (followUpPlan) => {
  if (!followUpPlan) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const parts = [
    followUpPlan.follow_up_after_days && followUpPlan.follow_up_after_days !== "None" ? `Follow up after: ${formatValue(followUpPlan.follow_up_after_days)} days` : "",
    followUpPlan.doctor && followUpPlan.doctor !== "None" ? `Doctor: ${formatValue(followUpPlan.doctor)}` : "",
    followUpPlan.location && followUpPlan.location !== "None" ? `Location: ${formatValue(followUpPlan.location)}` : "",
    followUpPlan.contact && followUpPlan.contact !== "None" ? `Contact: ${formatValue(followUpPlan.contact)}` : "",
    followUpPlan.emergency_contacts && followUpPlan.emergency_contacts.length > 0 && followUpPlan.emergency_contacts.some(contact => contact !== "None") 
      ? `Emergency Contacts: ${followUpPlan.emergency_contacts.filter(contact => contact !== "None").join(', ')}` 
      : ""
  ].filter(part => part !== "").join('\n');
  
  return parts.trim();
};

// Add this function to format custom attributes
const formatCustomAttributes = (customAttributes) => {
  if (!customAttributes || typeof customAttributes !== 'object') return "";
  
  const formatValue = (value) => value === "None" || value === "N/A" ? "" : value || "";
  
  let result = "";
  
  Object.entries(customAttributes).forEach(([key, value]) => {
    const formattedKey = key.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    
    const formattedValue = formatValue(value);
    
    if (formattedValue) {
      result += `${formattedKey}: ${formattedValue}\n`;
    }
  });
  
  return result.trim();
};

// Add this function to get individual custom attribute sections
const getCustomAttributeSections = (customAttributes) => {
  if (!customAttributes || typeof customAttributes !== 'object') return {};
  
  const sections = {};
  
  Object.entries(customAttributes).forEach(([key, value]) => {
    const formattedKey = key.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    
    sections[key] = formatValue(value);
  });
  
  return sections;
};

// Helper function to format values
// const formatValue = (value) => value === "None" || value === "N/A" ? "" : value || "";

// Helper function to format values - show empty string instead of hiding
const formatValue = (value) => {
  if (value === "None" || value === "N/A" || value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

// Helper function to format key names
const formatAttributeKey = (key) => {
  return key.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};

  // Add these formatting functions at the top of your component

// // Format Patient Information
// const formatPatientInfo = (patientInfo) => {
//   if (!patientInfo) return "";
//   return `Name: ${patientInfo.name || "N/A"}
// Age: ${patientInfo.age || "N/A"}
// Sex: ${patientInfo.sex || "N/A"}
// Mobile: ${patientInfo.mobile_no || "N/A"}
// UHID: ${patientInfo.uhid || "N/A"}
// Registration No: ${patientInfo.registration_no || "N/A"}
// Panel: ${patientInfo.panel_name || "N/A"}
// Consultant: ${patientInfo.consultant || "N/A"}`;
// };

// // Format Admission Details
// const formatAdmissionDetails = (admissionDetails) => {
//   if (!admissionDetails) return "";
//   return `Admitted On: ${admissionDetails.admitted_on || "N/A"}
// Discharge Date: ${admissionDetails.discharge_date || "N/A"}`;
// };

// // Format Diagnosis
// const formatDiagnosis = (diagnosis) => {
//   if (!diagnosis) return "";
//   let result = "";
//   if (diagnosis.provisional && diagnosis.provisional !== "None") {
//     result += `Provisional Diagnosis: ${diagnosis.provisional}\n`;
//   }
//   if (diagnosis.final && diagnosis.final.length > 0) {
//     result += "Final Diagnosis:\n";
//     diagnosis.final.forEach((dx, index) => {
//       result += `${index + 1}. ${dx}\n`;
//     });
//   }
//   return result || "No diagnosis available";
// };

// // Format Presenting Complaints
// const formatComplaints = (complaints) => {
//   if (!complaints || !Array.isArray(complaints)) return "";
//   return complaints.map(complaint => 
//     `${complaint.description || "N/A"} - Onset: ${complaint.onset || "N/A"}`
//   ).join('\n') || "No presenting complaints";
// };

// // Format Clinical Findings
// const formatClinicalFindings = (clinicalFindings) => {
//   if (!clinicalFindings) return "";
  
//   let result = `General Condition: ${clinicalFindings.general_condition || "N/A"}\n\n`;
  
//   // Admission Vitals
//   if (clinicalFindings.admission_vitals && clinicalFindings.admission_vitals.length > 0) {
//     result += "Admission Vitals:\n";
//     clinicalFindings.admission_vitals.forEach(vital => {
//       result += `- ${vital.name}: ${vital.value} ${vital.unit}\n`;
//     });
//     result += "\n";
//   }
  
//   // Discharge Vitals
//   if (clinicalFindings.discharge_vitals && clinicalFindings.discharge_vitals.length > 0) {
//     result += "Discharge Vitals:\n";
//     clinicalFindings.discharge_vitals.forEach(vital => {
//       result += `- ${vital.name}: ${vital.value} ${vital.unit}\n`;
//     });
//     result += "\n";
//   }
  
//   // Systemic Examination
//   if (clinicalFindings.systemic_examination && clinicalFindings.systemic_examination.length > 0) {
//     result += "Systemic Examination:\n";
//     clinicalFindings.systemic_examination.forEach(exam => {
//       result += `- ${exam.system || "N/A"}: ${exam.finding || "N/A"}\n`;
//     });
//   }
  
//   return result || "No clinical findings available";
// };

// // Format History
// const formatHistory = (history) => {
//   if (!history) return "";
  
//   let result = "";
  
//   // Personal History
//   if (history.personal_history && history.personal_history.length > 0) {
//     result += "Personal History:\n";
//     history.personal_history.forEach(item => {
//       if (item !== "None") result += `- ${item}\n`;
//     });
//     result += "\n";
//   }
  
//   // Past Medical History
//   if (history.past_medical_history && history.past_medical_history.length > 0) {
//     result += "Past Medical History:\n";
//     history.past_medical_history.forEach(item => {
//       if (item !== "None") result += `- ${item}\n`;
//     });
//     result += "\n";
//   }
  
//   // Past Surgical History
//   if (history.past_surgical_history && history.past_surgical_history.length > 0) {
//     result += "Past Surgical History:\n";
//     history.past_surgical_history.forEach(item => {
//       if (item !== "None") result += `- ${item}\n`;
//     });
//     result += "\n";
//   }
  
//   // Chronic Medications
//   if (history.chronic_medications && history.chronic_medications.length > 0) {
//     result += "Chronic Medications:\n";
//     history.chronic_medications.forEach(med => {
//       result += `- ${med}\n`;
//     });
//   }
  
//   return result || "No history available";
// };

// // Format Investigations
// const formatInvestigations = (investigations) => {
//   if (!investigations || !Array.isArray(investigations)) return "";
//   return investigations.map(inv => 
//     `${inv.name || "N/A"}: ${inv.value || "N/A"} ${inv.unit || ""}`
//   ).join('\n') || "No investigations available";
// };

// // Format Procedures
// const formatProcedures = (procedures) => {
//   if (!procedures || !Array.isArray(procedures)) return "";
//   return procedures.map(proc => 
//     `${proc.name || "N/A"} - ${proc.date || "N/A"}\n${proc.details || ""}`
//   ).join('\n\n') || "No procedures performed";
// };

// // Format Hospital Course
// const formatHospitalCourse = (hospitalCourse) => {
//   if (!hospitalCourse) return "";
  
//   let result = `Summary: ${hospitalCourse.summary || "N/A"}\n\n`;
  
//   if (hospitalCourse.interventions && hospitalCourse.interventions.length > 0) {
//     result += "Interventions:\n";
//     hospitalCourse.interventions.forEach(intervention => {
//       result += `- ${intervention.name || "N/A"}: ${intervention.notes || "N/A"}\n`;
//     });
//   }
  
//   return result || "No hospital course available";
// };

// // Format Medications
// const formatMedications = (medications) => {
//   if (!medications || !Array.isArray(medications)) return "";
//   return medications.map(med => 
//     `${med.name || "N/A"} ${med.dose || ""} ${med.frequency || ""} ${med.route || ""} ${med.duration ? `for ${med.duration}` : ""} ${med.timing ? `(${med.timing})` : ""}`
//   ).join('\n') || "No medications prescribed";
// };

// // Format Instructions
// const formatInstructions = (instructions) => {
//   if (!instructions) return "";
  
//   let result = "";
  
//   if (instructions.to_do && instructions.to_do.length > 0) {
//     result += "To Do:\n";
//     instructions.to_do.forEach(item => {
//       if (item !== "None") result += `- ${item}\n`;
//     });
//     result += "\n";
//   }
  
//   if (instructions.not_to_do && instructions.not_to_do.length > 0) {
//     result += "Not To Do:\n";
//     instructions.not_to_do.forEach(item => {
//       if (item !== "None") result += `- ${item}\n`;
//     });
//   }
  
//   return result || "No instructions provided";
// };

// // Format Follow Up Plan
// const formatFollowUpPlan = (followUpPlan) => {
//   if (!followUpPlan) return "";
  
//   return `Follow up after: ${followUpPlan.follow_up_after_days || "N/A"} days
// Doctor: ${followUpPlan.doctor || "N/A"}
// Location: ${followUpPlan.location || "N/A"}
// Contact: ${followUpPlan.contact || "N/A"}
// ${followUpPlan.emergency_contacts && followUpPlan.emergency_contacts.length > 0 ? 
//   `Emergency Contacts: ${followUpPlan.emergency_contacts.join(', ')}` : ""}`;
// };

  return (
    // <>
    //   {isLoading && (
    //     <Box
    //       position="absolute"
    //       top="0"
    //       left="0"
    //       width="100%"
    //       height="100%"
    //       display="flex"
    //       alignItems="center"
    //       justifyContent="center"
    //       zIndex="10"
    //       bg="rgba(255, 255, 255, 0.8)"
    //     >
    //       <Loader miniLoader={true} />
    //     </Box>
    //   )}
    //   {/* DISPLAY TRANSCRIPTION CODE  */}
    //   {aiResponse && (
    //     <Box display="flex" justifyContent="center" alignItems="center">
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         Conversation History
    //       </Text>
    //     </Box>
    //   )}
    //   {aiResponse && (
    //     <Box
    //       mx="auto"
    //       mt={"1rem"}
    //       width="75%"
    //       h="240px"
    //       overflowY="auto"
    //       border="1px"
    //       borderRadius="lg"
    //       p={2}
    //     >
    //       {/* {transcriptionArray.map((chunk, index) => (
    //         <Box
    //           key={index}
    //           w="full"
    //           bg="white"
    //           // boxShadow="md"
    //           borderRadius="lg"
    //           p={4}
    //           mb={2}
    //           // Apply neon blue border only to the last card
    //           border={
    //             index === transcriptionArray.length - 1
    //               ? "2px solid #00FFFF"
    //               : "1px"
    //           }
    //           borderColor={
    //             index === transcriptionArray.length - 1 ? "#00FFFF" : "gray.200"
    //           }
    //           boxShadow={
    //             index === transcriptionArray.length - 1
    //               ? "0 0 8px #00FFFF"
    //               : "md"
    //           } // Neon glow
    //         >
    //           <Flex>
    //             {chunk.timestamp && chunk.timestamp.length === 2 ? (
    //               <Text fontWeight="bold" color="gray.500" w="150px">
    //                 {formatTime(chunk.timestamp[0])} -{" "}
    //                 {formatTime(chunk.timestamp[1])}
    //               </Text>
    //             ) : (
    //               <Text fontWeight="bold" color="gray.500" w="120px">
    //                 No timestamp
    //               </Text>
    //             )}
    //             <Text
    //               ml={4}
    //               textAlign="left"
    //               whiteSpace="normal" // Allows wrapping of long text
    //               wordBreak="break-word" // Breaks words if necessary
    //             >
    //               {chunk.text || "No text available"}
    //             </Text>
    //           </Flex>
    //         </Box>
    //       ))} */}
    //       <Text
    //         textAlign="left"
    //         fontSize="16px"
    //         whiteSpace="normal"
    //         wordBreak="break-word"
    //       >
    //         {transcriptionText}
    //       </Text>
    //     </Box>
    //   )}

    //   <ChatDisplay chatMessages={mychats} />

    //   {aiResponse && (
    //     <Box
    //       mx="auto"
    //       borderBottom="8px solid"
    //       borderColor="gray.500"
    //       width="75%"
    //       mt="2rem"
    //     />
    //   )}

    //   {/* AIRA AI NOTES CODE  */}

    //   {/* <div>Notes</div> */}
    //   {aiResponse && (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       mt="1rem"
    //     >
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         Chief Complaint
    //       </Text>
    //     </Box>
    //   )}
    //   <Box width={"75%"} mx="auto" mt="1rem">
    //     {aiResponse && aiResponse?.chiefcomplaint && (
    //       <AiComplaintInputCard
    //         patientId={patientId}
    //         doctorId={doctorId}
    //         appointmentId={appointmentId}
    //         showSuccessToast={showSuccessToast}
    //         showErrorToast={showErrorToast}
    //         AiChiefComplaint={aiResponse?.chiefcomplaint}
    //       />
    //     )}
    //   </Box>
    //   {/* <Divider w={"50%"} h={"0.3rem"} /> */}

    //   {aiResponse && (
    //     <Box
    //       mx="auto"
    //       borderBottom="8px solid"
    //       borderColor="gray.500"
    //       width="75%"
    //       mt="1rem"
    //     />
    //   )}

    //   {aiResponse && (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       mt="1rem"
    //     >
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         ROS
    //       </Text>
    //     </Box>
    //   )}
    //   <Box width={"75%"} mx="auto" mt="1rem">
    //     {aiResponse && aiResponse?.ros && (
    //       <AiROSCard
    //         patientId={patientId}
    //         doctorId={doctorId}
    //         appointmentId={appointmentId}
    //         showSuccessToast={showSuccessToast}
    //         showErrorToast={showErrorToast}
    //         aiResponseROS={aiResponse?.ros}
    //       />
    //     )}
    //   </Box>

    //   {aiResponse && (
    //     <Box
    //       mx="auto"
    //       borderBottom="8px solid"
    //       borderColor="gray.500"
    //       width="75%"
    //       mt="1rem"
    //     />
    //   )}

    //   {aiResponse && (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       mt="1rem"
    //     >
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         HPI
    //       </Text>
    //     </Box>
    //   )}
    //   <Box width={"75%"} mx="auto" mt="1rem" height={"auto"}>
    //     {aiResponse && aiResponse?.hpitext && (
    //       <AIHpiNotesCard
    //         patientId={patientId}
    //         doctorId={doctorId}
    //         appointmentId={appointmentId}
    //         showSuccessToast={showSuccessToast}
    //         showErrorToast={showErrorToast}
    //         AiHpi={aiResponse?.hpitext}
    //       />
    //     )}
    //   </Box>

    //   {aiResponse && (
    //     <Box
    //       mx="auto"
    //       borderBottom="8px solid"
    //       borderColor="gray.500"
    //       width="75%"
    //       mt="1rem"
    //     />
    //   )}
    //   {/* {aiResponse && (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       mt="1rem"
    //     >
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         Physical Exam
    //       </Text>
    //     </Box>
    //   )}
    //   <Box width={"75%"} mx="auto" mt="1rem">
    //     {aiResponse && aiResponse?.physical_exam && (
    //       <AIPhysicalExamCard
    //         patientId={patientId}
    //         doctorId={doctorId}
    //         appointmentId={appointmentId}
    //         showSuccessToast={showSuccessToast}
    //         showErrorToast={showErrorToast}
    //         aiResponsePhysicalExam={aiResponse?.physical_exam}
    //       />
    //     )}
    //   </Box> */}

    //   {/* {aiResponse && (
    //     <Box
    //       mx="auto"
    //       borderBottom="8px solid"
    //       borderColor="gray.500"
    //       width="75%"
    //       mt="1rem"
    //     />
    //   )} */}
    //   {aiResponse && (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       mt="1rem"
    //     >
    //       <Text
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontSize="2xl"
    //         fontWeight="bold"
    //         // color="teal.500"
    //       >
    //         Doctor Assessment
    //       </Text>
    //     </Box>
    //   )}
    //   <Box width={"75%"} mx="auto" mt="1rem">
    //     {aiResponse && aiResponse?.assessment_plan && (
    //       <AINotesAssessment
    //         patientId={patientId}
    //         doctorId={doctorId}
    //         appointmentId={appointmentId}
    //         showSuccessToast={showSuccessToast}
    //         showErrorToast={showErrorToast}
    //         AiDoctorAssessment={aiResponse?.assessment_plan}
    //       />
    //     )}
    //   </Box>

    //   {aiResponse &&
    //     (useGPUChatbot ? (
    //       <AIFeedbackFooter
    //         disclaimer={
    //           "AIRA strives to be as accurate as possible, but occasional errors may occur. Please verify its responses to ensure the information meets your needs. Your discretion will ensure the best experience."
    //         }
    //         doctorId={doctorId}
    //         patientId={patientId}
    //         appointmentId={appointmentId}
    //         aiInput={aiInputForFeedback}
    //         aiOutput={aiOutputForFeedback}
    //         featureType={"AIRA Transcription Notes"}
    //       />
    //     ) : (
    //       <AICPUFeedbackFooter
    //         disclaimer={
    //           "AIRA strives to be as accurate as possible, but occasional errors may occur. Please verify its responses to ensure the information meets your needs. Your discretion will ensure the best experience."
    //         }
    //         doctorId={doctorId}
    //         patientId={patientId}
    //         appointmentId={appointmentId}
    //         aiInput={aiInputForFeedback}
    //         aiOutput={aiOutputForFeedback}
    //         featureType={"AIRA Transcription Notes"}
    //       />
    //     ))}
    // </>
    <>
      {isLoading && (
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="10"
          bg="rgba(255, 255, 255, 0.8)"
        >
          <Loader miniLoader={true} />
        </Box>
      )}

      <Flex height="86vh" overflowY={"hidden"} top="0" left="0">
        {/* Left Box: Conversation History and Chats */}
        {/* {buttonClicked !== 'IPD' && ( */}
        {!isIPDDischarge && (
          <>
          <Box width="50vw" p={4} overflowY="auto">
            <Text fontSize="2xl" fontWeight="bold" mb={4}>
              Conversation History
            </Text>
            {fromStartVisit && patientHealthData && (
              <Box display="flex" gap="0.5rem" alignItems="center">
                {patientHealthData?.patientinfo?.patientimage ? (
                  <Image
                    borderRadius="full"
                    w="2.75rem"
                    h="2.75rem"
                    src={
                      patientHealthData?.patientinfo?.imagepath +
                      patientHealthData?.patientinfo?.patientimage
                    }
                  />
                ) : (
                  <Image
                    borderRadius="full"
                    w="2.75rem"
                    h="2.75rem"
                    src="/assets/imgs/no-image.png"
                  />
                )}
                <Box>
                  <Text fontSize="1rem" fontWeight="600" color="black">
                    {patientHealthData?.patientinfo?.firstname +
                      " " +
                      patientHealthData?.patientinfo?.lastname}
                  </Text>
                  {(
                    patientHealthData.patientinfo.uniqueid
                      ? "#" + patientHealthData.patientinfo.uniqueid
                      : ""
                  ) ? (
                    <Box display="flex" gap="0.25rem" alignItems="center">
                      {/* <Image src="/assets/svgs/home-calendar.svg" /> */}
                      <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                        {patientHealthData.patientinfo.uniqueid
                          ? "#" + patientHealthData.patientinfo.uniqueid
                          : ""}{" "}
                        {navHeaderOverviewData}
                      </Text>
                    </Box>
                  ) : null}
                </Box>
              </Box>
            )}
            <Box
              bg="white"
              p={3}
              mb={4}
              borderRadius="md"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.200"
              // height= {dischargeFlow && '100%'}
              height='auto'
              mt="1rem"
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="lg" fontWeight="semibold" mb={2} color="gray.800">
                  Chat Summary
                </Text>
                <IconButton
                  aria-label="Copy Chat Summary"
                  icon={<CopyIcon />}
                  onClick={() => copyToClipboard(aiTranscriptSummary)}
                  variant="ghost"
                />
              </Flex>
              <Text
                fontSize="sm"
                color="gray.600"
                // height={"120px"}
                overflowY={"auto"}
              >
                {aiTranscriptSummary ||
                  "No summary available yet. Start a conversation to see a summary here."}
              </Text>
            </Box>
            {!dischargeFlow && (
              <ChatDisplay chatMessages={aiTranscriptChats} />
            )}
          </Box>
        {/* Divider */}
        <Divider orientation="vertical" />
        </>
        )}
        {/* Right Box: Notes and AI Content */}
        <Box
          // width="100vw"
          width={isIPDDischarge ? '100vw' : '50vw'}
          // width={buttonClicked !== 'IPD' ? '50vw' : '100vw'}
          // p={4}
          p={isIPDDischarge ? 0 : 4}
          // p={buttonClicked !== 'IPD' ? 4 : 0}
          overflowY="scroll"
          sx={{
            "::-webkit-scrollbar": {
              display: "none", // Hide scrollbar
            },
            msOverflowStyle: "none", // For Internet Explorer
            scrollbarWidth: "none", // For Firefox
          }}
        >

          {/* Only IPD Data */}
         {(isIPDDischarge && buttonClicked === 'IPD') && (
  <>
    <Tabs>
      <TabList height={"3rem"} borderBottom={"1px solid gray"}>
        <Tab
          onClick={() => handleTabChange("discharge")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Discharge Summary
        </Tab>
        <Tab
          onClick={() => handleTabChange("share")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Share Details
        </Tab>
      </TabList>

      <TabPanels
        height="calc(77vh - 2.5rem)"
        overflowY="auto"
        mt="2rem"
        sx={{
          "::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        {/* Discharge Summary Tab */}
        <TabPanel p={{ base: "0" }}>
          <Flex w='100%' gap='1rem'>
            {/* Patient Information */}
            <Box w='100%' mb={4}>
              <Flex justifyContent="space-between" alignItems="center">
                <Heading as="h4" size="md">Patient Information</Heading>
                <Spacer />
                <IconButton
                  aria-label="Copy Patient Info"
                  icon={<CopyIcon />}
                  onClick={() => copyToClipboard(formatPatientInfo(aiDischargeResponse?.patient_info))}
                  variant="ghost"
                />
                <IconButton
                  aria-label="Clear Patient Info"
                  icon={<CgRemove />}
                  onClick={() => setEditableSections(prev => ({
                    ...prev,
                    patientInfo: formatPatientInfo({
                      name: "",
                      age: "",
                      sex: "",
                      // mobile_no: "",
                      phone: "",
                      uhid: "",
                      mrn: "",
                      registration_no: "",
                      panel_name: "",
                      consultant: ""
                    })
                  }))}
                  variant="ghost"
                />
              </Flex>
              <Textarea
                value={editableSections.patientInfo || formatPatientInfo(aiDischargeResponse?.patient_info)}
                onChange={(e) => setEditableSections(prev => ({
                  ...prev,
                  patientInfo: e.target.value
                }))}
                resize="none"
                h='100px'
                placeholder="Enter patient information..."
              />
            </Box>

            {/* Admission Details */}
            <Box w='100%' mb={4}>
              <Flex justifyContent="space-between" alignItems="center">
                <Heading as="h4" size="md">Admission Details</Heading>
                <Spacer />
                <IconButton
                  aria-label="Copy Admission Details"
                  icon={<CopyIcon />}
                  onClick={() => copyToClipboard(formatAdmissionDetails(aiDischargeResponse?.admission_details))}
                  variant="ghost"
                />
                <IconButton
                  aria-label="Clear Admission Details"
                  icon={<CgRemove />}
                  onClick={() => setEditableSections(prev => ({
                    ...prev,
                    admissionDetails: "Admitted: \nDischarged: "
                  }))}
                  variant="ghost"
                />
              </Flex>
              <Textarea
                value={editableSections.admissionDetails || formatAdmissionDetails(aiDischargeResponse?.admission_details)}
                onChange={(e) => setEditableSections(prev => ({
                  ...prev,
                  admissionDetails: e.target.value
                }))}
                resize="none"
                h='100px'
                placeholder="Admitted: [date]\nDischarged: [date]"
              />
            </Box>
          </Flex>

          {/* Diagnosis */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
          <Box mt={8} mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Diagnosis</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Diagnosis"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatDiagnosis(aiDischargeResponse?.diagnosis))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Diagnosis"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  diagnosis: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.diagnosis || formatDiagnosis(aiDischargeResponse?.diagnosis)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                diagnosis: e.target.value
              }))}
              resize="none"
              h='100px'
              placeholder="Enter one diagnosis per line..."
            />
          </Box>
          {/* )} */}

          {/* Presenting Complaints */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.complaints == 1 && ( */}
            <Box my={4}>
              <Flex justifyContent="space-between" alignItems="center">
                <Heading as="h4" size="md">Presenting Complaints</Heading>
                <Spacer />
                <IconButton
                  aria-label="Copy Presenting Complaints"
                  icon={<CopyIcon />}
                  onClick={() => copyToClipboard(formatComplaints(aiDischargeResponse?.presenting_complaints))}
                  variant="ghost"
                />
                <IconButton
                  aria-label="Clear Presenting Complaints"
                  icon={<CgRemove />}
                  onClick={() => setEditableSections(prev => ({
                    ...prev,
                    presentingComplaints: ""
                  }))}
                  variant="ghost"
                />
              </Flex>
              <Textarea
                value={editableSections.presentingComplaints || formatComplaints(aiDischargeResponse?.presenting_complaints)}
                onChange={(e) => setEditableSections(prev => ({
                  ...prev,
                  presentingComplaints: e.target.value
                }))}
                resize="none"
                h='100px'
                placeholder="Description - Onset (one per line)"
              />
            </Box>
          {/* )} */}

          {/* Clinical Findings */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.findings == 1 && ( */}
          <Box my={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Clinical Findings</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Clinical Findings"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatClinicalFindings(aiDischargeResponse?.clinical_findings))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Clinical Findings"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  clinicalFindings: "General Condition: \nVitals:\n- \nSystemic Exam:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.clinicalFindings || formatClinicalFindings(aiDischargeResponse?.clinical_findings)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                clinicalFindings: e.target.value
              }))}
              resize="none"
              h='200px'
              placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
            />
          </Box>
          {/* )} */}

          {/* History */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.history == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">History</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy History"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHistory(aiDischargeResponse?.history))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear History"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  history: "Personal History:\n- \nPast Medical History:\n- \nPast Surgical History:\n- \nChronic Medications:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.history || formatHistory(aiDischargeResponse?.history)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                history: e.target.value
              }))}
              resize="none"
              h='150px'
              placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
            />
          </Box>
          {/* )} */}

          {/* Investigations */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.investigation == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Investigations</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Investigations"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInvestigations(aiDischargeResponse?.investigations))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Investigations"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  investigations: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.investigations || formatInvestigations(aiDischargeResponse?.investigations)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                investigations: e.target.value
              }))}
              resize="none"
              h='100px'
              placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
            />
          </Box>
          {/* )} */}

          {/* Procedures */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.procedure == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Procedures</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Procedures"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatProcedures(aiDischargeResponse?.procedures))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Procedures"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  procedures: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.procedures || formatProcedures(aiDischargeResponse?.procedures)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                procedures: e.target.value
              }))}
              resize="none"
              h='100px'
              placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
            />
          </Box>
          {/* )} */}

          {/* Hospital Course */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.course == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Hospital Course</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Hospital Course"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHospitalCourse(aiDischargeResponse?.hospital_course))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Hospital Course"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  hospitalCourse: "Summary: \nInterventions:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.hospitalCourse || formatHospitalCourse(aiDischargeResponse?.hospital_course)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                hospitalCourse: e.target.value
              }))}
              resize="none"
              h='120px'
              placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
            />
          </Box>
          {/* )} */}

          {/* Discharge Medications */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.medication == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Discharge Medications</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Discharge Medications"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatMedications(aiDischargeResponse?.medications_on_discharge))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Discharge Medications"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  dischargeMeds: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.dischargeMeds || formatMedications(aiDischargeResponse?.medications_on_discharge)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                dischargeMeds: e.target.value
              }))}
              resize="none"
              h='120px'
              placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
            />
          </Box>
          {/* )} */}

          {/* Instructions */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.instruction == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Instructions</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Instructions"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInstructions(aiDischargeResponse?.instructions))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Instructions"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  instructions: "To Do:\n- \nNot To Do:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.instructions || formatInstructions(aiDischargeResponse?.instructions)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                instructions: e.target.value
              }))}
              resize="none"
              h='120px'
              placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
            />
          </Box>
          {/* )} */}

          {/* Follow Up Plan */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.followup == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Follow Up Plan</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Follow Up Plan"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatFollowUpPlan(aiDischargeResponse?.follow_up_plan))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Follow Up Plan"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  followUpPlan: "Follow up after:  days\nLocation: \nDoctor: \nContact: "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.followUpPlan || formatFollowUpPlan(aiDischargeResponse?.follow_up_plan)}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                followUpPlan: e.target.value
              }))}
              resize="none"
              h='100px'
              placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
            />
          </Box>
          {/* )} */}

          {/* Dynamic Custom Attributes Section */}
{aiDischargeResponse?.custom_attributes && Object.keys(aiDischargeResponse.custom_attributes).length > 0 && (
  <Box mb={4}>
    <Heading as="h4" size="md" mb={4} color="gray.600">
      {/* Additional Information */}
      Dynamic Attributes
    </Heading>
    
    {Object.entries(aiDischargeResponse.custom_attributes).map(([key, value]) => {
      const formattedKey = formatAttributeKey(key);
      const formattedValue = formatValue(value);
      
      return (
        <Box key={key} mb={4}>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading as="h5" size="sm">{formattedKey}</Heading>
            <Spacer />
            <IconButton
              aria-label={`Copy ${formattedKey}`}
              icon={<CopyIcon />}
              onClick={() => copyToClipboard(formattedValue)}
              variant="ghost"
              size="sm"
            />
            <IconButton
              aria-label={`Clear ${formattedKey}`}
              icon={<CgRemove />}
              onClick={() => setEditableSections(prev => ({
                ...prev,
                [key]: ""
              }))}
              variant="ghost"
              size="sm"
            />
          </Flex>
          <Textarea
            value={editableSections[key] !== undefined ? editableSections[key] : formattedValue}
            onChange={(e) => setEditableSections(prev => ({
              ...prev,
              [key]: e.target.value
            }))}
            resize="none"
            h='100px'
            placeholder={`Enter ${formattedKey.toLowerCase()}...`}
          />
        </Box>
      );
    })}
  </Box>
)}

          <Text fontWeight="bold" color="black" fontSize="sm">
            AIRA strives to be as accurate as possible, but occasional
            errors may occur. Please verify its responses to ensure the
            information meets your needs.
          </Text>
        </TabPanel>

        {/* Share Details Tab */}
        <TabPanel p={{ base: "0" }}>
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Email Information</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Email"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(shareReportDoctorEmail)}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Email"
                icon={<CgRemove />}
                onClick={() => setShareReportDoctorEmail("")}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={shareReportDoctorEmail}
              onChange={(e) => setShareReportDoctorEmail(e.target.value)} 
              resize="none"
            />
            <Heading as="h4" size="md" mt={6}>Details:</Heading>
            <Stack spacing={2} mt={2}>
              <Checkbox
                isChecked={shareChatSummary}
                onChange={(e) => setShareChatSummary(e.target.checked)}
              >
                Share chat summary
              </Checkbox>
              <Checkbox
                isChecked={shareChatHistory}
                onChange={(e) => setShareChatHistory(e.target.checked)}
              >
                Share chat history
              </Checkbox>
              <Checkbox
                isChecked={shareDoctorNotes}
                onChange={(e) => setShareDoctorNotes(e.target.checked)}
              >
                Share Discharge Summary Notes
              </Checkbox>
            </Stack>
            <Button
              className="primary-button-icon" 
              onClick={shareNotesOnEmail}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mr:'1rem',
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Share</Text>
            </Button>
            <Button
              className="primary-button-icon" 
              // onClick={downloadSummary}
              onClick={() => downloadSummary(null, true)}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Download</Text>
            </Button>
          </Box>
        </TabPanel>
      </TabPanels>

      {/* Save All Button */}
      {selectedTab === 'discharge' && (
        <Box mt={6} textAlign="end" pos='sticky' bottom='0' w='100%'>
          <PrimaryButton 
            btnStyle={{w: '25%', mr: '0.5rem'}} 
            buttonText='Save All' 
            onClick={handleSaveAll}  
          />
        </Box>
      )}
    </Tabs>
  </>
)}

          {/* REcord & IPD */}
          {(isIPDDischarge && buttonClicked === 'IPDRecord') && (
  <>
    <Tabs>
      <TabList height={"3rem"} borderBottom={"1px solid gray"}>
        <Tab
          onClick={() => handleTabChange("discharge")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Discharge Summary
        </Tab>
        <Tab
          onClick={() => handleTabChange("share")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Share Details
        </Tab>
      </TabList>

      <TabPanels
        height="calc(77vh - 2.5rem)"
        overflowY="auto"
        mt="2rem"
        sx={{
          "::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        {/* Discharge Summary Tab */}
        <TabPanel p={{ base: "0" }}>
          {/* Patient Information */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Patient Information</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Patient Info"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatPatientInfo(aiDischargeResponse?.patient_info))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Patient Info"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  patientInfo: formatPatientInfo({
                    name: "",
                    age: "",
                    sex: "",
                    uhid: "",
                    consultant: ""
                  })
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.patientInfo}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                patientInfo: e.target.value
              }))}
              resize="none"
              placeholder="Enter patient information..."
            />
          </Box>

          {/* Admission Details */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Admission Details</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Admission Details"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(aiDischargeResponse?.admission_details)}
                // onClick={() => copyToClipboard(formatAdmissionDetails(aiDischargeResponse?.admission_details))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Admission Details"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  admissionDetails: "Admitted: \nDischarged: "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              height='3rem'
              value={editableSections.admissionDetails}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                admissionDetails: e.target.value
              }))}
              resize="none"
              placeholder="Admitted: [date]\nDischarged: [date]"
            />
          </Box>

          {/* Diagnosis */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Diagnosis</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Diagnosis"
                icon={<CopyIcon />}
                // onClick={() => copyToClipboard(formatDiagnosis(aiDischargeResponse?.diagnosis))}
                onClick={() => copyToClipboard(aiDischargeResponse?.diagnosis)}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Diagnosis"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  diagnosis: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.diagnosis}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                diagnosis: e.target.value
              }))}
              resize="none"
              placeholder="Enter one diagnosis per line..."
            />
          </Box>
          {/* )} */}

          {/* Presenting Complaints */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.complaints == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Presenting Complaints</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Presenting Complaints"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatComplaints(aiDischargeResponse?.presenting_complaints))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Presenting Complaints"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  presentingComplaints: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.presentingComplaints}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                presentingComplaints: e.target.value
              }))}
              resize="none"
              placeholder="Description - Onset (one per line)"
            />
          </Box>
          {/* )} */}

          {/* Clinical Findings */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.findings == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Clinical Findings</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Clinical Findings"
                icon={<CopyIcon />}
                // onClick={() => copyToClipboard(formatClinicalFindings(aiDischargeResponse?.clinical_findings))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Clinical Findings"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  clinicalFindings: "General Condition: \nVitals:\n- \nSystemic Exam:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.clinicalFindings}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                clinicalFindings: e.target.value
              }))}
              resize="none"
              placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
            />
          </Box>
          {/* )} */}

          {/* History */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.history == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">History</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy History"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHistory(aiDischargeResponse?.history))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear History"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  history: "Personal History:\n- \nPast Medical History:\n- \nPast Surgical History:\n- \nChronic Medications:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.history}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                history: e.target.value
              }))}
              resize="none"
              placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
            />
          </Box>
          {/* )} */}

          {/* Investigations */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.investigation == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Investigations</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Investigations"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInvestigations(aiDischargeResponse?.investigations))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Investigations"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  investigations: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.investigations}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                investigations: e.target.value
              }))}
              resize="none"
              placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
            />
          </Box>
          {/* )} */}

          {/* Procedures */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.procedure == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Procedures</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Procedures"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatProcedures(aiDischargeResponse?.procedures))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Procedures"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  procedures: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.procedures}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                procedures: e.target.value
              }))}
              resize="none"
              placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
            />
          </Box>
          {/* )} */}

          {/* Hospital Course */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.course == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Hospital Course</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Hospital Course"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHospitalCourse(aiDischargeResponse?.hospital_course))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Hospital Course"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  hospitalCourse: "Summary: \nInterventions:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.hospitalCourse}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                hospitalCourse: e.target.value
              }))}
              resize="none"
              placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
            />
          </Box>
          {/* )} */}

          {/* Discharge Medications */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.medication == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Discharge Medications</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Discharge Medications"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatMedications(aiDischargeResponse?.medications_on_discharge))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Discharge Medications"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  dischargeMeds: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.dischargeMeds}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                dischargeMeds: e.target.value
              }))}
              resize="none"
              placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
            />
          </Box>
          {/* )} */}

          {/* Instructions */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.instruction == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Instructions</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Instructions"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInstructions(aiDischargeResponse?.instructions))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Instructions"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  instructions: "To Do:\n- \nNot To Do:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.instructions}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                instructions: e.target.value
              }))}
              resize="none"
              placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
            />
          </Box>
          {/* )} */}

          {/* Follow Up Plan */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.followup == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Follow Up Plan</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Follow Up Plan"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatFollowUpPlan(aiDischargeResponse?.follow_up_plan))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Follow Up Plan"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  followUpPlan: "Follow up after:  days\nLocation: \nDoctor: \nContact: "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.followUpPlan}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                followUpPlan: e.target.value
              }))}
              resize="none"
              placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
            />
          </Box>
          {/* )} */}

          {/* Dynamic Custom Attributes Section */}
{aiDischargeResponse?.custom_attributes && Object.keys(aiDischargeResponse.custom_attributes).length > 0 && (
  <Box mb={4}>
    <Heading as="h4" size="md" mb={4} color="gray.600">
      {/* Additional Information */}
      Dynamic Attributes
    </Heading>
    
    {Object.entries(aiDischargeResponse.custom_attributes).map(([key, value]) => {
      const formattedKey = formatAttributeKey(key);
      const formattedValue = formatValue(value);
      
      return (
        <Box key={key} mb={4}>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading as="h5" size="sm">{formattedKey}</Heading>
            <Spacer />
            <IconButton
              aria-label={`Copy ${formattedKey}`}
              icon={<CopyIcon />}
              onClick={() => copyToClipboard(formattedValue)}
              variant="ghost"
              size="sm"
            />
            <IconButton
              aria-label={`Clear ${formattedKey}`}
              icon={<CgRemove />}
              onClick={() => setEditableSections(prev => ({
                ...prev,
                [key]: ""
              }))}
              variant="ghost"
              size="sm"
            />
          </Flex>
          <Textarea
            value={editableSections[key] !== undefined ? editableSections[key] : formattedValue}
            onChange={(e) => setEditableSections(prev => ({
              ...prev,
              [key]: e.target.value
            }))}
            resize="none"
            h='100px'
            placeholder={`Enter ${formattedKey.toLowerCase()}...`}
          />
        </Box>
      );
    })}
  </Box>
)}

          <Text fontWeight="bold" color="black" fontSize="sm">
            AIRA strives to be as accurate as possible, but occasional
            errors may occur. Please verify its responses to ensure the
            information meets your needs.
          </Text>
        </TabPanel>

        {/* Share Details Tab */}
        <TabPanel p={{ base: "0" }}>
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Email Information</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Email"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(shareReportDoctorEmail)}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Email"
                icon={<CgRemove />}
                onClick={() => setShareReportDoctorEmail("")}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={shareReportDoctorEmail}
              onChange={(e) => setShareReportDoctorEmail(e.target.value)} 
              resize="none"
            />
            <Heading as="h4" size="md" mt={6}>Details:</Heading>
            <Stack spacing={2} mt={2}>
              <Checkbox
                isChecked={shareChatSummary}
                onChange={(e) => setShareChatSummary(e.target.checked)}
              >
                Share chat summary
              </Checkbox>
              <Checkbox
                isChecked={shareChatHistory}
                onChange={(e) => setShareChatHistory(e.target.checked)}
              >
                Share chat history
              </Checkbox>
              <Checkbox
                isChecked={shareDoctorNotes}
                onChange={(e) => setShareDoctorNotes(e.target.checked)}
              >
                Share Discharge Summary Notes
              </Checkbox>
            </Stack>
            <Button
              className="primary-button-icon" 
              onClick={shareNotesOnEmail}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mr:'1rem',
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Share</Text>
            </Button>
            <Button
              className="primary-button-icon" 
              // onClick={downloadSummary}
              onClick={() => downloadSummary(null, true)}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Download</Text>
            </Button>
          </Box>
        </TabPanel>
      </TabPanels>

      {/* Save All Button */}
      {selectedTab === 'discharge' && (
        <Box mt={6} textAlign="end" pos='sticky' bottom='0' w='100%'>
          <PrimaryButton 
            btnStyle={{w: '25%', mr: '0.5rem'}} 
            buttonText='Save All' 
            onClick={handleSaveAll}  
          />
        </Box>
      )}
    </Tabs>
  </>
)}


          {/* REcord */}
          {(isIPDDischarge && buttonClicked === 'RecordOnly') && (
  <>
    <Tabs>
      <TabList height={"3rem"} borderBottom={"1px solid gray"}>
        <Tab
          onClick={() => handleTabChange("discharge")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Discharge Summary
        </Tab>
        <Tab
          onClick={() => handleTabChange("share")}
          _selected={{ color: "black", borderBottom: "2px solid black" }}
          fontSize={{ base: "12px", lg: "initial" }}
        >
          Share Details
        </Tab>
      </TabList>

      <TabPanels
        height="calc(77vh - 2.5rem)"
        overflowY="auto"
        mt="2rem"
        sx={{
          "::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        {/* Discharge Summary Tab */}
        <TabPanel p={{ base: "0" }}>
          {/* Patient Information */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Patient Information</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Patient Info"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatPatientInfo(aiDischargeResponse?.patient_info))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Patient Info"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  patientInfo: formatPatientInfo({
                    name: "",
                    age: "",
                    sex: "",
                    uhid: "",
                    consultant: ""
                  })
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.patientInfo}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                patientInfo: e.target.value
              }))}
              resize="none"
              placeholder="Enter patient information..."
            />
          </Box>

          {/* Admission Details */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Admission Details</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Admission Details"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(aiDischargeResponse?.admission_details)}
                // onClick={() => copyToClipboard(formatAdmissionDetails(aiDischargeResponse?.admission_details))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Admission Details"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  admissionDetails: "Admitted: \nDischarged: "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              height='3rem'
              value={editableSections.admissionDetails}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                admissionDetails: e.target.value
              }))}
              resize="none"
              placeholder="Admitted: [date]\nDischarged: [date]"
            />
          </Box>

          {/* Diagnosis */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Diagnosis</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Diagnosis"
                icon={<CopyIcon />}
                // onClick={() => copyToClipboard(formatDiagnosis(aiDischargeResponse?.diagnosis))}
                onClick={() => copyToClipboard(aiDischargeResponse?.diagnosis)}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Diagnosis"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  diagnosis: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.diagnosis}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                diagnosis: e.target.value
              }))}
              resize="none"
              placeholder="Enter one diagnosis per line..."
            />
          </Box>
          {/* )} */}

          {/* Presenting Complaints */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.complaints == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Presenting Complaints</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Presenting Complaints"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatComplaints(aiDischargeResponse?.presenting_complaints))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Presenting Complaints"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  presentingComplaints: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.presentingComplaints}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                presentingComplaints: e.target.value
              }))}
              resize="none"
              placeholder="Description - Onset (one per line)"
            />
          </Box>
          {/* )} */}

          {/* Clinical Findings */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.findings == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Clinical Findings</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Clinical Findings"
                icon={<CopyIcon />}
                // onClick={() => copyToClipboard(formatClinicalFindings(aiDischargeResponse?.clinical_findings))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Clinical Findings"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  clinicalFindings: "General Condition: \nVitals:\n- \nSystemic Exam:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.clinicalFindings}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                clinicalFindings: e.target.value
              }))}
              resize="none"
              placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
            />
          </Box>
          {/* )} */}

          {/* History */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.history == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">History</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy History"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHistory(aiDischargeResponse?.history))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear History"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  history: "Personal History:\n- \nPast Medical History:\n- \nPast Surgical History:\n- \nChronic Medications:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.history}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                history: e.target.value
              }))}
              resize="none"
              placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
            />
          </Box>
          {/* )} */}

          {/* Investigations */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.investigation == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Investigations</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Investigations"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInvestigations(aiDischargeResponse?.investigations))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Investigations"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  investigations: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.investigations}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                investigations: e.target.value
              }))}
              resize="none"
              placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
            />
          </Box>
          {/* )} */}

          {/* Procedures */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.procedure == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Procedures</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Procedures"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatProcedures(aiDischargeResponse?.procedures))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Procedures"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  procedures: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.procedures}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                procedures: e.target.value
              }))}
              resize="none"
              placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
            />
          </Box>
          {/* )} */}

          {/* Hospital Course */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.course == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Hospital Course</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Hospital Course"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatHospitalCourse(aiDischargeResponse?.hospital_course))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Hospital Course"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  hospitalCourse: "Summary: \nInterventions:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.hospitalCourse}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                hospitalCourse: e.target.value
              }))}
              resize="none"
              placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
            />
          </Box>
          {/* )} */}

          {/* Discharge Medications */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.medication == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Discharge Medications</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Discharge Medications"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatMedications(aiDischargeResponse?.medications_on_discharge))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Discharge Medications"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  dischargeMeds: ""
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.dischargeMeds}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                dischargeMeds: e.target.value
              }))}
              resize="none"
              placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
            />
          </Box>
          {/* )} */}

          {/* Instructions */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.instruction == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Instructions</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Instructions"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatInstructions(aiDischargeResponse?.instructions))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Instructions"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  instructions: "To Do:\n- \nNot To Do:\n- "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.instructions}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                instructions: e.target.value
              }))}
              resize="none"
              placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
            />
          </Box>
          {/* )} */}

          {/* Follow Up Plan */}
          {/* {dischargeDisplaySettings && dischargeDisplaySettings.followup == 1 && ( */}
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Follow Up Plan</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Follow Up Plan"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(formatFollowUpPlan(aiDischargeResponse?.follow_up_plan))}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Follow Up Plan"
                icon={<CgRemove />}
                onClick={() => setEditableSections(prev => ({
                  ...prev,
                  followUpPlan: "Follow up after:  days\nLocation: \nDoctor: \nContact: "
                }))}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={editableSections.followUpPlan}
              onChange={(e) => setEditableSections(prev => ({
                ...prev,
                followUpPlan: e.target.value
              }))}
              resize="none"
              placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
            />
          </Box>
          {/* )} */}

          {/* Dynamic Custom Attributes Section */}
{aiDischargeResponse?.custom_attributes && Object.keys(aiDischargeResponse.custom_attributes).length > 0 && (
  <Box mb={4}>
    <Heading as="h4" size="md" mb={4} color="gray.600">
      {/* Additional Information */}
      Dynamic Attributes
    </Heading>
    
    {Object.entries(aiDischargeResponse.custom_attributes).map(([key, value]) => {
      const formattedKey = formatAttributeKey(key);
      const formattedValue = formatValue(value);
      
      return (
        <Box key={key} mb={4}>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading as="h5" size="sm">{formattedKey}</Heading>
            <Spacer />
            <IconButton
              aria-label={`Copy ${formattedKey}`}
              icon={<CopyIcon />}
              onClick={() => copyToClipboard(formattedValue)}
              variant="ghost"
              size="sm"
            />
            <IconButton
              aria-label={`Clear ${formattedKey}`}
              icon={<CgRemove />}
              onClick={() => setEditableSections(prev => ({
                ...prev,
                [key]: ""
              }))}
              variant="ghost"
              size="sm"
            />
          </Flex>
          <Textarea
            value={editableSections[key] !== undefined ? editableSections[key] : formattedValue}
            onChange={(e) => setEditableSections(prev => ({
              ...prev,
              [key]: e.target.value
            }))}
            resize="none"
            h='100px'
            placeholder={`Enter ${formattedKey.toLowerCase()}...`}
          />
        </Box>
      );
    })}
  </Box>
)}

          <Text fontWeight="bold" color="black" fontSize="sm">
            AIRA strives to be as accurate as possible, but occasional
            errors may occur. Please verify its responses to ensure the
            information meets your needs.
          </Text>
        </TabPanel>

        {/* Share Details Tab */}
        <TabPanel p={{ base: "0" }}>
          <Box mb={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h4" size="md">Email Information</Heading>
              <Spacer />
              <IconButton
                aria-label="Copy Email"
                icon={<CopyIcon />}
                onClick={() => copyToClipboard(shareReportDoctorEmail)}
                variant="ghost"
              />
              <IconButton
                aria-label="Clear Email"
                icon={<CgRemove />}
                onClick={() => setShareReportDoctorEmail("")}
                variant="ghost"
              />
            </Flex>
            <Textarea
              value={shareReportDoctorEmail}
              onChange={(e) => setShareReportDoctorEmail(e.target.value)} 
              resize="none"
            />
            <Heading as="h4" size="md" mt={6}>Details:</Heading>
            <Stack spacing={2} mt={2}>
              <Checkbox
                isChecked={shareChatSummary}
                onChange={(e) => setShareChatSummary(e.target.checked)}
              >
                Share chat summary
              </Checkbox>
              <Checkbox
                isChecked={shareChatHistory}
                onChange={(e) => setShareChatHistory(e.target.checked)}
              >
                Share chat history
              </Checkbox>
              <Checkbox
                isChecked={shareDoctorNotes}
                onChange={(e) => setShareDoctorNotes(e.target.checked)}
              >
                Share Discharge Summary Notes
              </Checkbox>
            </Stack>
            <Button
              className="primary-button-icon" 
              onClick={shareNotesOnEmail}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mr:'1rem',
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Share</Text>
            </Button>
            <Button
              className="primary-button-icon" 
              // onClick={downloadSummary}
              onClick={() => downloadSummary(null, true)}
              sx={{
                h: "2.5rem",
                w: "8rem",
                p: "1rem",
                m: "0",
                mt: "48px",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            >
              <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
              </Box>
              <Text>Download</Text>
            </Button>
          </Box>
        </TabPanel>
      </TabPanels>

      {/* Save All Button */}
      {selectedTab === 'discharge' && (
        <Box mt={6} textAlign="end" pos='sticky' bottom='0' w='100%'>
          <PrimaryButton 
            btnStyle={{w: '25%', mr: '0.5rem'}} 
            buttonText='Save All' 
            onClick={handleSaveAll}  
          />
        </Box>
      )}
    </Tabs>
  </>
)}

          {dischargeFlow &&  (
            <>
            <Tabs>
            <TabList height={"3rem"} borderBottom={"1px solid gray"}>
              <Tab
                onClick={() => handleTabChange("discharge")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Discharge Summary
              </Tab>
              <Tab
                onClick={() => handleTabChange("share")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Share Details
              </Tab>
            </TabList>

            <TabPanels
              height="calc(77vh - 2.5rem)"
              overflowY="auto"
              mt="2rem"
              sx={{
                "::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar
                },
                msOverflowStyle: "none", // For Internet Explorer
                scrollbarWidth: "none", // For Firefox
              }}
            >
<TabPanel p={{ base: "0" }}>
            {/* <> */}
  {/* Patient Information */}
  {aiDischargeResponse?.patient_info && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Patient Information
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Patient Info"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.patientInfo)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Patient Info"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            patientInfo: formatPatientInfo({
              name: "",
              age: "",
              sex: "",
              uhid: "",
              consultant: ""
            })
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.patientInfo}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          patientInfo: e.target.value
        }))}
        resize="none"
        placeholder="Enter patient information..."
      />
    </Box>
  )}

  {/* Admission Details */}
  {aiDischargeResponse?.admission_details && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Admission Details
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Admission Details"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.admissionDetails)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Admission Details"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            admissionDetails: "Admitted: \nDischarged: "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        height='3rem'
        value={editableSections.admissionDetails}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          admissionDetails: e.target.value
        }))}
        resize="none"
        placeholder="Admitted: [date]\nDischarged: [date]"
      />
    </Box>
  )}

  {/* Diagnosis */}
  {aiDischargeResponse?.diagnosis?.final?.length > 0 && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Diagnosis
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Diagnosis"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.diagnosis)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Diagnosis"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            diagnosis: ""
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.diagnosis}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          diagnosis: e.target.value
        }))}
        resize="none"
        placeholder="Enter one diagnosis per line..."
      />
    </Box>
  )}

  {/* Presenting Complaints */}
  {aiDischargeResponse?.presenting_complaints?.length > 0 && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Presenting Complaints
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Presenting Complaints"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.presentingComplaints)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Presenting Complaints"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            presentingComplaints: ""
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.presentingComplaints}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          presentingComplaints: e.target.value
        }))}
        resize="none"
        placeholder="Description - Onset (one per line)"
      />
    </Box>
  )}

  {/* Clinical Findings */}
  {aiDischargeResponse?.clinical_findings && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Clinical Findings
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Clinical Findings"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.clinicalFindings)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Clinical Findings"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            clinicalFindings: "General Condition: \nVitals:\n- \nSystemic Exam:\n- "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.clinicalFindings}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          clinicalFindings: e.target.value
        }))}
        resize="none"
        placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
      />
    </Box>
  )}

  {/* History */}
  {aiDischargeResponse?.history && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          History
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy History"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.history)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear History"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            history: "Personal History:\n- \nPast Medical History:\n- \nPast Surgical History:\n- \nChronic Medications:\n- "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.history}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          history: e.target.value
        }))}
        resize="none"
        placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
      />
    </Box>
  )}

  {/* Investigations */}
  {aiDischargeResponse?.investigations?.length > 0 && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Investigations
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Investigations"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.investigations)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Investigations"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            investigations: ""
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.investigations}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          investigations: e.target.value
        }))}
        resize="none"
        placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
      />
    </Box>
  )}

  {/* Procedures */}
  {aiDischargeResponse?.procedures?.length > 0 && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Procedures
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Procedures"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.procedures)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Procedures"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            procedures: ""
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.procedures}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          procedures: e.target.value
        }))}
        resize="none"
        placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
      />
    </Box>
  )}

  {/* Hospital Course */}
  {aiDischargeResponse?.hospital_course && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Hospital Course
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Hospital Course"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.hospitalCourse)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Hospital Course"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            hospitalCourse: "Summary: \nInterventions:\n- "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.hospitalCourse}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          hospitalCourse: e.target.value
        }))}
        resize="none"
        placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
      />
    </Box>
  )}

  {/* Discharge Medications */}
  {aiDischargeResponse?.medications_on_discharge?.length > 0 && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Discharge Medications
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Discharge Medications"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.dischargeMeds)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Discharge Medications"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            dischargeMeds: ""
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.dischargeMeds}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          dischargeMeds: e.target.value
        }))}
        resize="none"
        placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
      />
    </Box>
  )}

  {/* Instructions */}
  {aiDischargeResponse?.instructions && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Instructions
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Instructions"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.instructions)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Instructions"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            instructions: "To Do:\n- \nNot To Do:\n- "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.instructions}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          instructions: e.target.value
        }))}
        resize="none"
        placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
      />
    </Box>
  )}

  {/* Follow Up Plan */}
  {aiDischargeResponse?.follow_up_plan && (
    <Box mb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading as="h4" size="md">
          Follow Up Plan
        </Heading>
        <Spacer />
        <IconButton
          aria-label="Copy Follow Up Plan"
          icon={<CopyIcon />}
          onClick={() => copyToClipboard(editableSections.followUpPlan)}
          variant="ghost"
        />
        <IconButton
          aria-label="Clear Follow Up Plan"
          icon={<CgRemove />}
          onClick={() => setEditableSections(prev => ({
            ...prev,
            followUpPlan: "Follow up after:  days\nLocation: \nDoctor: \nContact: "
          }))}
          variant="ghost"
        />
      </Flex>
      <Textarea
        value={editableSections.followUpPlan}
        onChange={(e) => setEditableSections(prev => ({
          ...prev,
          followUpPlan: e.target.value
        }))}
        resize="none"
        placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
      />
    </Box>
  )}

  <Text fontWeight="bold" color="black" fontSize="sm">
    AIRA strives to be as accurate as possible, but occasional
    errors may occur. Please verify its responses to ensure the
    information meets your needs.
  </Text>
  {/* </> */}
</TabPanel>

              <TabPanel p={{ base: "0" }}>
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">
                      Email Information
                    </Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Email"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(shareReportDoctorEmail)}
                      variant="ghost"
                    />
                    <IconButton
                      aria-label="Clear Email"
                      icon={<CgRemove />}
                      onClick={() => setShareReportDoctorEmail("")}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={shareReportDoctorEmail}
                    onChange={(e) => setShareReportDoctorEmail(e.target.value)} 
                    resize="none"
                  />
                  <Heading as="h4" size="md" mt={6}>
                    Details:
                  </Heading>
                  <Stack spacing={2} mt={2}>
                    <Checkbox
                      isChecked={shareChatSummary}
                      onChange={(e) => setShareChatSummary(e.target.checked)}
                    >
                      Share chat summary
                    </Checkbox>
                    <Checkbox
                      isChecked={shareChatHistory}
                      onChange={(e) => setShareChatHistory(e.target.checked)}
                    >
                      Share chat history
                    </Checkbox>
                    <Checkbox
                      isChecked={shareDoctorNotes}
                      onChange={(e) => setShareDoctorNotes(e.target.checked)}
                    >
                      Share Discharge Summary Notes
                    </Checkbox>
                  </Stack>
                  <Button
                    isDisabled={false} 
                    className="primary-button-icon" 
                    onClick={shareNotesOnEmail}
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mr:'1rem',
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      {" "}
                      <Image
                        src="/assets/imgs/email-icon.png"
                        h={"24px"}
                        w={"24px"}
                      />
                    </Box>
                    <Text>Share</Text>
                  </Button>
                  <Button
                    isDisabled={false}
                    className="primary-button-icon" 
                    // onClick={downloadSummary}
                    onClick={() => downloadSummary(null, true)}
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      {" "}
                      <Image
                        src="/assets/imgs/email-icon.png"
                        h={"24px"}
                        w={"24px"}
                      />
                    </Box>
                    <Text>Download</Text>
                  </Button>
                </Box>
              </TabPanel>
            </TabPanels>

            {/* Save All Button */}
            {selectedTab == 'discharge' && (
  <Box mt={6} textAlign="end" pos='sticky' bottom='0' w='100%'>
  {/* <Box mt={6} display='flex' justifyContent='end' pos='sticky' bottom='0' w='100%'> */}
    <PrimaryButton btnStyle={{w: '25%', mr: '0.5rem'}} buttonText='Save All' onClick={handleSaveAll}  />
              </Box>

            )}

            </Tabs>
            </>

          )}

          {(!dischargeFlow && !isIPDDischarge) && (
          <Tabs>
            <TabList height={"3rem"} borderBottom={"1px solid gray"}>
              <Tab
                onClick={() => handleTabChange("doctor")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Doctor Notes
              </Tab>
              <Tab
                onClick={() => handleTabChange("patient")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Patient History
              </Tab>
              <Tab
                onClick={() => handleTabChange("share")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Share Details
              </Tab>
            </TabList>
            <TabPanels
              height="calc(77vh - 2.5rem)"
              overflowY="auto"
              mt="2rem"
              sx={{
                "::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar
                },
                msOverflowStyle: "none", // For Internet Explorer
                scrollbarWidth: "none", // For Firefox
              }}
            >
              <TabPanel p={{ base: "0" }}>
                {aiResponse && aiResponse?.chiefcomplaint && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Chief Complaint
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Chief Complaint"
                          icon={<FaRegSave />}
                          onClick={() => UpdateChiefComplaint(aiCc)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Chief Complaint"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiCc)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Chief Complaint"
                        icon={<CgRemove />}
                        onClick={() => setAiCc("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiCc}
                      onChange={(e) => setAiCc(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                {aiResponse?.hpi_text && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        History Of Present Illness
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save HPI Notes"
                          icon={<FaRegSave />}
                          onClick={() => UpdateHpiTextBox(aiHpiText)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy HPI Notes"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiHpiText)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear HPI Notes"
                        icon={<CgRemove />}
                        onClick={() => setAiHpiText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiHpiText}
                      onChange={(e) => setAiHpiText(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                {aiPatientResponse && aiPatientResponse?.patient_vitals && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Vitals
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Vitals"
                          icon={<FaRegSave />}
                          onClick={() => addVitals(aiPatientVitals)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Vitals"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPatientVitals)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Vitals"
                        icon={<CgRemove />}
                        onClick={() => setAiPatientVitals("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPatientVitals}
                      onChange={(e) => setAiPatientVitals(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                {aiResponse?.ros_text && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Review Of System
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save ROS"
                          icon={<FaRegSave />}
                          // onClick={() => fetchExtractRos(aiRosText)} // AI Call for categorization
                          onClick={() => UpdateROSTextBox(aiRosText)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy ROS"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiRosText)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear ROS"
                        icon={<CgRemove />}
                        onClick={() => setAiRosText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiRosText}
                      onChange={(e) => setAiRosText(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                {aiResponse?.physical_exam_text && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Physical Exam
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Physical Exam Notes"
                          icon={<FaRegSave />}
                          onClick={() =>
                            UpdatePhysicalExamTextBox(aiPhysicalExamText)
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Physical Exam Notes"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPhysicalExamText)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Physical Exam Notes"
                        icon={<CgRemove />}
                        onClick={() => setAiPhysicalExamText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPhysicalExamText}
                      onChange={(e) => setAiPhysicalExamText(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                {aiResponse?.assessment_plan && (
                  <Box mb={4}>
                    <Heading as="h4" size="md" mb={2}>
                      Assessment & Plan
                    </Heading>
                    {aiAssessmentPlanArray.map((item, index) => (
                      <Box key={index} mb={4}>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Heading as="h5" size="sm">
                            Plan {index + 1}
                          </Heading>
                          <Spacer />
                          {fromStartVisit && (
                            <IconButton
                              aria-label={`Save Assessment Plan ${index + 1}`}
                              icon={<FaRegSave />}
                              onClick={() => SaveIndividualAssessmentPlan(item)}
                              variant="ghost"
                            />
                          )}
                          <IconButton
                            aria-label={`Copy Assessment Plan ${index + 1}`}
                            icon={<CopyIcon />}
                            onClick={() =>
                              copyToClipboard(`${item.diagnosis}: ${item.plan}`)
                            }
                            variant="ghost"
                          />
                          <IconButton
                            aria-label={`Clear Assessment Plan ${index + 1}`}
                            icon={<CgRemove />}
                            onClick={() =>
                              setAiAssessmentPlanArray((prev) =>
                                prev.map((prevItem, i) =>
                                  i === index
                                    ? { ...prevItem, diagnosis: "", plan: "" }
                                    : prevItem
                                )
                              )
                            }
                            variant="ghost"
                          />
                        </Flex>
                        {/* <Textarea
                          value={`${item.diagnosis}`}
                          onChange={(e) =>
                            setAiAssessmentPlanArray((prev) =>
                              prev.map((prevItem, i) =>
                                i === index
                                  ? { ...prevItem, diagnosis: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          resize="none"
                        />
                        <Textarea
                          value={`${item.plan}`}
                          onChange={(e) =>
                            setAiAssessmentPlanArray((prev) =>
                              prev.map((prevItem, i) =>
                                i === index
                                  ? { ...prevItem, plan: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          resize="none"
                        /> */}
                        <PrimaryAssessmentInput
                          textAreaHeight={"50px"}
                          id={`${index},${item.diagnosis}`}
                          variant="defaultSide"
                          inputType="text"
                          inputPlace={"Diagnosis"}
                          // inputPlace={formInputs[index]?.diagnosis}
                          // defaultValue={`${item.diagnosis}`}
                          inputValue={`${item.diagnosis}`}
                          onChange={(e) =>
                            setAiAssessmentPlanArray((prev) =>
                              prev.map((prevItem, i) =>
                                i === index
                                  ? { ...prevItem, diagnosis: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          wrap={true}
                          // defaultHeight={"10px"}
                        />
                        <PrimaryAssessmentInput
                          textAreaHeight={"100px"}
                          id={`${index},${item.plan}`}
                          variant="downSide"
                          inputType="text"
                          inputPlace="Plan"
                          // defaultValue={`${item.plan}`}
                          inputValue={`${item.plan}`}
                          onChange={(e) =>
                            setAiAssessmentPlanArray((prev) =>
                              prev.map((prevItem, i) =>
                                i === index
                                  ? { ...prevItem, plan: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          wrap={true}
                          // defaultHeight={"24px"}
                        />
                      </Box>
                    ))}
                  </Box>
                )}

                {aiResponse?.prescribed_medicines && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Prescribed Medicines
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Prescribed Medicines"
                          icon={<FaRegSave />}
                          onClick={() =>
                            fetchExtractRecommendedMedicines(
                              aiPrescribedMedicinesText
                            )
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Prescribed Medicines"
                        icon={<CopyIcon />}
                        onClick={() =>
                          copyToClipboard(aiPrescribedMedicinesText)
                        }
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Prescribed Medicines"
                        icon={<CgRemove />}
                        onClick={() => setAiPrescribedMedicinesText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPrescribedMedicinesText}
                      onChange={(e) =>
                        setAiPrescribedMedicinesText(e.target.value)
                      } // Update state on change
                      resize="none"
                    />
                  </Box>
                )}
                {aiResponse?.prescribed_procedures && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Prescribed Procedures
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Prescribed Procedures"
                          icon={<FaRegSave />}
                          onClick={() =>
                            fetchExtractRecommendedOrders(
                              aiPrescribedProceduresText,
                              "procedure"
                            )
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Prescribed Procedures"
                        icon={<CopyIcon />}
                        onClick={() =>
                          copyToClipboard(aiPrescribedProceduresText)
                        }
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Prescribed Procedures"
                        icon={<CgRemove />}
                        onClick={() => setAiPrescribedProceduresText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPrescribedProceduresText}
                      onChange={(e) =>
                        setAiPrescribedProceduresText(e.target.value)
                      } // Update state on change
                      resize="none"
                    />
                  </Box>
                )}
                {aiResponse?.prescribed_labs && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Prescribed Lab Tests
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Prescribed Lab Tests"
                          icon={<FaRegSave />}
                          onClick={() =>
                            fetchExtractRecommendedOrders(
                              aiPrescribedLabsText,
                              "lab"
                            )
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Prescribed Lab Tests"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPrescribedLabsText)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Prescribed Lab Tests"
                        icon={<CgRemove />}
                        onClick={() => setAiPrescribedLabsText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPrescribedLabsText}
                      onChange={(e) => setAiPrescribedLabsText(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}
                {aiResponse?.prescribed_imaging && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Prescribed Imaging Tests
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Prescribed Imaging Tests"
                          icon={<FaRegSave />}
                          onClick={() =>
                            fetchExtractRecommendedOrders(
                              aiPrescribedImagingText,
                              "imaging"
                            )
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Imaging Tests"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPrescribedImagingText)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Imaging Tests"
                        icon={<CgRemove />}
                        onClick={() => setAiPrescribedImagingText("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPrescribedImagingText}
                      onChange={(e) =>
                        setAiPrescribedImagingText(e.target.value)
                      } // Update state on change
                      resize="none"
                    />
                  </Box>
                )}

                <Text fontWeight="bold" color="black" fontSize="sm">
                  AIRA strives to be as accurate as possible, but occasional
                  errors may occur. Please verify its responses to ensure the
                  information meets your needs. Occasionally, it may provide
                  incorrect information or recommend something if required. Your
                  discretion will ensure the best experience.
                </Text>
              </TabPanel>
              <TabPanel p={{ base: "0" }}>
                {aiPatientResponse &&
                  aiPatientResponse?.patient_medical_conditions && (
                    <Box mb={4}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Heading as="h4" size="md">
                          Medical Conditions
                        </Heading>
                        <Spacer />
                        {fromStartVisit && (
                          <IconButton
                            aria-label="Save Medical Conditions"
                            icon={<FaRegSave />}
                            onClick={() =>
                              addMedicalCondition(aiPatientMedicalConditions)
                            }
                            variant="ghost"
                          />
                        )}
                        <IconButton
                          aria-label="Copy Medical Conditions"
                          icon={<CopyIcon />}
                          onClick={() =>
                            copyToClipboard(aiPatientMedicalConditions)
                          }
                          variant="ghost"
                        />
                        <IconButton
                          aria-label="Clear Medical Conditions"
                          icon={<CgRemove />}
                          onClick={() => setAiPatientMedicalConditions("")}
                          variant="ghost"
                        />
                      </Flex>
                      <Textarea
                        value={aiPatientMedicalConditions}
                        onChange={(e) =>
                          setAiPatientMedicalConditions(e.target.value)
                        } // Update state on change
                        resize="none"
                      />
                    </Box>
                  )}
                {aiPatientResponse &&
                  aiPatientResponse?.patient_medications && (
                    <Box mb={4}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Heading as="h4" size="md">
                          Medications
                        </Heading>
                        <Spacer />
                        {fromStartVisit && (
                          <IconButton
                            aria-label="Save Medications"
                            icon={<FaRegSave />}
                            // onClick={() => addMedicalCondition(aiPatientMedicalConditions)}
                            variant="ghost"
                          />
                        )}
                        <IconButton
                          aria-label="Copy Medications"
                          icon={<CopyIcon />}
                          onClick={() => copyToClipboard(aiPatientMedications)}
                          variant="ghost"
                        />
                        <IconButton
                          aria-label="Clear Medications"
                          icon={<CgRemove />}
                          onClick={() => setAiPatientMedications("")}
                          variant="ghost"
                        />
                      </Flex>
                      <Textarea
                        value={aiPatientMedications}
                        onChange={(e) =>
                          setAiPatientMedications(e.target.value)
                        } // Update state on change
                        resize="none"
                      />
                    </Box>
                  )}
                {aiPatientResponse && aiPatientResponse?.patient_surgeries && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Surgeries
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Surgeries"
                          icon={<FaRegSave />}
                          onClick={() => addProcedures(aiPatientSurgeries)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Surgeries"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPatientSurgeries)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Surgeries"
                        icon={<CgRemove />}
                        onClick={() => setAiPatientSurgeries("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPatientSurgeries}
                      onChange={(e) => setAiPatientSurgeries(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}
                {/* {aiPatientResponse && aiPatientResponse?.patient_vitals && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Vitals
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Vitals"
                          icon={<FaRegSave />}
                          onClick={() => addVitals(aiPatientVitals)}
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Vitals"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPatientVitals)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Vitals"
                        icon={<CgRemove />}
                        onClick={() => setAiPatientVitals("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPatientVitals}
                      onChange={(e) => setAiPatientVitals(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )} */}
                {aiPatientResponse && aiPatientResponse?.patient_allergies && (
                  <Box mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">
                        Allergies
                      </Heading>
                      <Spacer />
                      {fromStartVisit && (
                        <IconButton
                          aria-label="Save Allergies"
                          icon={<FaRegSave />}
                          onClick={() =>
                            addAllergicConditions(aiPatientAllergies)
                          }
                          variant="ghost"
                        />
                      )}
                      <IconButton
                        aria-label="Copy Allergies"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(aiPatientAllergies)}
                        variant="ghost"
                      />
                      <IconButton
                        aria-label="Clear Allergies"
                        icon={<CgRemove />}
                        onClick={() => setAiPatientAllergies("")}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={aiPatientAllergies}
                      onChange={(e) => setAiPatientAllergies(e.target.value)} // Update state on change
                      resize="none"
                    />
                  </Box>
                )}
                {aiPatientResponse &&
                  aiPatientResponse?.patient_vaccinations && (
                    <Box mb={4}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Heading as="h4" size="md">
                          Vaccinations
                        </Heading>
                        <Spacer />
                        {fromStartVisit && (
                          <IconButton
                            aria-label="Save Vaccinations"
                            icon={<FaRegSave />}
                            onClick={() =>
                              addVaccinations(aiPatientVaccinations)
                            }
                            variant="ghost"
                          />
                        )}
                        <IconButton
                          aria-label="Copy Vaccinations"
                          icon={<CopyIcon />}
                          onClick={() => copyToClipboard(aiPatientVaccinations)}
                          variant="ghost"
                        />
                        <IconButton
                          aria-label="Clear Vaccinations"
                          icon={<CgRemove />}
                          onClick={() => setAiPatientVaccinations("")}
                          variant="ghost"
                        />
                      </Flex>
                      <Textarea
                        value={aiPatientVaccinations}
                        onChange={(e) =>
                          setAiPatientVaccinations(e.target.value)
                        } // Update state on change
                        resize="none"
                      />
                    </Box>
                  )}
                {aiPatientResponse &&
                  aiPatientResponse?.patient_social_history && (
                    <Box mb={4}>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Heading as="h4" size="md">
                          Social History
                        </Heading>
                        <Spacer />
                        {fromStartVisit && (
                          <IconButton
                            aria-label="Save Vaccinations"
                            icon={<FaRegSave />}
                            // onClick={() => addVaccinations(aiPatientVaccinations)}
                            variant="ghost"
                          />
                        )}
                        <IconButton
                          aria-label="Copy Social History"
                          icon={<CopyIcon />}
                          onClick={() =>
                            copyToClipboard(aiPatientSocialHistory)
                          }
                          variant="ghost"
                        />
                        <IconButton
                          aria-label="Clear Social History"
                          icon={<CgRemove />}
                          onClick={() => setAiPatientSocialHistory("")}
                          variant="ghost"
                        />
                      </Flex>
                      <Textarea
                        value={aiPatientSocialHistory}
                        onChange={(e) =>
                          setAiPatientSocialHistory(e.target.value)
                        } // Update state on change
                        resize="none"
                      />
                    </Box>
                  )}

                <Text fontWeight="bold" color="black" fontSize="sm">
                  AIRA strives to be as accurate as possible, but occasional
                  errors may occur. Please verify its responses to ensure the
                  information meets your needs. Occasionally, it may provide
                  incorrect information or recommend something if required. Your
                  discretion will ensure the best experience.
                </Text>
              </TabPanel>

              <TabPanel p={{ base: "0" }}>
                {/* Share record options available here */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">
                      Email Information
                    </Heading>
                    <Spacer />
                    {/* <IconButton
                          aria-label="Save Email"
                          icon={<FaRegSave />}
                          // onClick={() => addVaccinations(aiPatientVaccinations)}
                          variant="ghost"
                        /> */}
                    <IconButton
                      aria-label="Copy Email"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(shareReportDoctorEmail)}
                      variant="ghost"
                    />
                    <IconButton
                      aria-label="Clear Email"
                      icon={<CgRemove />}
                      onClick={() => setShareReportDoctorEmail("")}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={shareReportDoctorEmail}
                    onChange={(e) => setShareReportDoctorEmail(e.target.value)} // Update state on change
                    resize="none"
                  />
                  <Heading as="h4" size="md" mt={6}>
                    Details:
                  </Heading>
                  <Stack spacing={2} mt={2}>
                    <Checkbox
                      isChecked={shareChatSummary}
                      onChange={(e) => setShareChatSummary(e.target.checked)}
                    >
                      Share chat summary
                    </Checkbox>
                    <Checkbox
                      isChecked={shareChatHistory}
                      onChange={(e) => setShareChatHistory(e.target.checked)}
                    >
                      Share chat history
                    </Checkbox>
                    <Checkbox
                      isChecked={shareDoctorNotes}
                      onChange={(e) => setShareDoctorNotes(e.target.checked)}
                    >
                      Share Doctor Notes
                    </Checkbox>
                    <Checkbox
                      isChecked={sharePatientHistory}
                      onChange={(e) => setSharePatientHistory(e.target.checked)}
                    >
                      Share patient history
                    </Checkbox>
                  </Stack>
                  {/* <PrimaryButtonIcon
                  buttonText="Share"
                  iconSrc="/assets/imgs/email-icon.png"
                  btnStyle={{
                    h: "2.5rem",
                    w: "25%",
                    p: "1rem",
                    m: "0",
                    mt: "48px",
                    bg: COLORS.PRIMARY_GRADIENT,
                    color: COLORS.PRIMARY_WHITE,
                    _hover: { bg: COLORS.PRIMARY_COLOR },
                  }}
                  onClick={shareNotesOnEmail}
                /> */}
                  <Button
                    isDisabled={false} // Update with your `disabled` variable if needed
                    className="primary-button-icon" // Replace with your desired `btnClass`
                    onClick={shareNotesOnEmail}
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      {" "}
                      {/* Adjust `sx` as needed */}
                      <Image
                        src="/assets/imgs/email-icon.png"
                        h={"24px"}
                        w={"24px"}
                      />
                    </Box>
                    <Text>Share</Text>
                  </Button>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
          )}
        </Box>
      </Flex>

      {/* DynamicModal for Recommended Prescription */}
      <DynamicModalForTwo
        ref={aiRecommendMedicineRef}
        modalWidth="75%"
        modalHeader={`Aira - AI: Recommended Prescription`}
        modalBody={
          <>
            {recommendMedicinesAiResponse.map((medicine, index) => (
              <Box key={medicine.id}>
                <Box
                  p="10px"
                  border="1px solid gray"
                  borderRadius="10px"
                  mt="10px"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    // p="10px"
                    // border="1px solid gray"
                    // borderRadius="10px"
                    // mt="10px"
                  >
                    <Checkbox
                      isChecked={selectedRecommendedMedicinesAiResponses.includes(
                        index
                      )}
                      onChange={() =>
                        handleRecommendedMedicinesCheckboxChange(index)
                      }
                      mr={4}
                      alignSelf="center" // Vertically center the checkbox
                    ></Checkbox>
                    <Box width="42%">
                      <Box fontWeight={"semibold"}>
                        {medicine.medicinename}
                        <Box
                          display="inline-block"
                          verticalAlign="bottom"
                          fontSize="10px"
                          fontWeight="600"
                          bg="#E6E7E966"
                          border="1px solid #E6E7E9"
                          p="5px 10px"
                          borderRadius="full"
                          w="fit-content"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {medicine.medicinetype ? medicine.medicinetype : "-"}
                          {/* Tablet */}
                        </Box>
                      </Box>
                      <Box fontSize={"xs"}>
                        Composition: {medicine.composition}
                      </Box>
                    </Box>
                    <Box width="8%">
                      {medicine.morning}-{medicine.evening}-{medicine.night}
                      {/* 1-0-0 */}
                    </Box>
                    <Box width="35%">
                      {medicine.beforefood === 1 &&
                        medicine.afterfood === 1 && <>Before & After Food</>}
                      {medicine.beforefood === 1 &&
                        (medicine.afterfood === 0 ||
                          medicine.afterfood === null) && <>Before Food</>}
                      {(medicine.beforefood === 0 ||
                        medicine.beforefood === null) &&
                        medicine.afterfood === 1 && <>After Food</>}{" "}
                      {(medicine.beforefood === 1 ||
                        medicine.afterfood === 1) &&
                        medicine.frequency &&
                        "-"}
                      {medicine.frequency && `${medicine.frequency} x per day`}
                    </Box>

                    <Box>
                      {/* Buttons */}
                      <Box display="flex" justifyContent="space-between">
                        {/* <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() =>
                              fetchAiDoctorPrompts(medicine.medicinename)
                            }
                          >
                            <Image
                              w="26px"
                              src="/assets/svgs/ai-star-outline.svg"
                            />
                          </Box> */}
                        <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={() => handleEditMedicine(medicine)}
                        >
                          <Image w="13px" src="/assets/svgs/edit-gray.svg" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  {/* Reason Box */}
                  {/* <Box
                    as="p"
                    p="2px"
                    bg="#F9FAFB"
                    w="auto"
                    borderLeft="2px solid #14C585"
                    fontSize="0.875rem"
                    fontWeight="500"
                    mt="2px"
                    ml="3rem"
                  >
                    {medicine?.reason}{" "}
                  </Box> */}
                </Box>

                {editMedicine && editMedicine.id === medicine.id && (
                      <Box
                        p="20px"
                        border="1px solid gray"
                        borderRadius="10px"
                        mt="10px" // Add some margin-top to separate from the above row
                      >
                        <Stack spacing={4}>
                          <Flex
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box width="45%">
                              <Box w="100%" pos="relative" cursor="pointer">
                                <PrimaryInput
                                  variant="bothSide"
                                  inputPlace="Medicine name"
                                  inputValue={editMedicine.medicinename}
                                  onChange={(e) => {
                                    handleEditMedicineChange(
                                      "medicinename",
                                      e.target.value
                                    );
                                    filterMedicineNames(e.target.value);
                                    setShowMedicineNamesDropdown(0);
                                    setBoolValForSuggestions(
                                      !boolValForSuggestions
                                    );
                                  }}
                                  inputIdProp={"MedicineNameInAdd" + 0}
                                  boolProp={boolValForSuggestions}
                                  onKeyDown={(e) => handleEditKeyDown(e, 0)}
                                  autoFocus={showMedicineNamesDropdown === 0}
                                  autocomplete="off"
                                />
                                <Image
                                  top="33%"
                                  right="6.5%"
                                  w="15px"
                                  pos="absolute"
                                  src="/assets/imgs/double-arrow.png"
                                />
                              </Box>
                              {showMedicineNamesDropdown === 0 &&
                                suggestions.length > 0 && (
                                  <Menu isOpen={true}>
                                    <MenuButton
                                      as={Box}
                                      w="100%"
                                      display="block"
                                      pos="relative"
                                      zIndex="999"
                                    >
                                      <Box
                                        pos="absolute"
                                        top="100%"
                                        left="0"
                                        w="100%"
                                        bg="white"
                                        borderTop="none"
                                        border="1px solid #E6E7E9"
                                        borderRadius="0 0 12px 12px"
                                      />
                                    </MenuButton>
                                    <MenuList
                                      w="100%"
                                      borderRadius="0 0 12px 12px"
                                      zIndex="999"
                                      bg="white"
                                      maxH="150px"
                                      overflow="hidden auto"
                                      ref={suggestionsMenuRef}
                                    >
                                      {suggestions.map((suggestion, sIndex) => (
                                        <MenuItem
                                          key={sIndex}
                                          onClick={() =>
                                            handleEditSelect(suggestion, 0)
                                          }
                                          cursor="pointer"
                                          p="1rem"
                                          py="0.5rem"
                                          borderBottom="1px solid #E6E7E9"
                                          bg={
                                            focusedItemIndex === sIndex
                                              ? "#f0f0f0"
                                              : "white"
                                          }
                                        >
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="500"
                                          >
                                            {suggestion.productname +
                                              " (" +
                                              suggestion.remainingquantity +
                                              " Qty)"}
                                          </Text>
                                        </MenuItem>
                                      ))}
                                    </MenuList>
                                  </Menu>
                                )}
                            </Box>
                            <Box width="45%">
                              <PrimaryInput
                                key={compositionEditKey}
                                type="text"
                                variant="bothSide"
                                inputPlace="Medicine Composition"
                                defaultValue={editMedicine.composition}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "composition",
                                    e.target.value
                                  )
                                }
                              />{" "}
                            </Box>
                            <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                            {/* <Box width="10%">
                              <PrimaryButton
                                buttonText="Fetch"
                                verticalAlign="bottom"
                                variant="grayBtn"
                                btnStyle={{
                                  w: "100%",
                                  color: COLORS.PRIMARY_COLOR,
                                  verticalAlign: "bottom",
                                  ml: "4px",
                                  mb: "0px",
                                  h: "2.8rem",
                                  opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                                }}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                // onClick={() =>
                                //   fetchCompositionForEdit(
                                //     editMedicine.medicinename
                                //   )
                                // }
                                // isDisabled={false}
                              />
                            </Box> */}
                          </Flex>
                          <RadioGroup
//                             defaultValue={editMedicine.medicinetype}

// onChange={(value) => {
//     handleEditMedicineChange("medicinetype", value);

//     // Set default dosage units based on medicine type
//     if (value === "Syrup" || value === "Drops" || value === "Suspension" || 
//         value === "Respules" || value === "Gargle" || value === "Shampoo" || 
//         value === "Topical Cleanser") {
//       handleEditMedicineChange("dosageunit", "ml");
//     } else if (value === "Tablet" || value === "Capsule" || value === "Suppository" || 
//                value === "Powder") {
//       handleEditMedicineChange("dosageunit", "mg");
//     } else if (value === "Injection" || value === "Nebulization" || value === "IVFluids") {
//       handleEditMedicineChange("dosageunit", "ml");
//     } else if (value === "Ointment" || value === "Cream" || value === "Gel" || 
//                value === "Foam" || value === "Lotion" || value === "Tube" || 
//                value === "Soap") {
//       handleEditMedicineChange("dosageunit", "grms");
//     } else if (value === "Inhaler" || value === "Spray" || value === "Aerosol") {
//       handleEditMedicineChange("dosageunit", "puffs");
//     } else if (value === "EA" || value === "Device" || value === "Box") {
//       handleEditMedicineChange("dosageunit", "each");
//     } else if (value === "Sachet") {
//       handleEditMedicineChange("dosageunit", "mg"); // or 'g' as default
//     } else if (value === "Custom") {
//       handleEditMedicineChange("dosageunit", ""); // No default for custom
//     }
//   }}

value={additionalMedicineTypes.includes(editMedicine.medicinetype) ? "" : editMedicine.medicinetype}
  onChange={(value) => handleEditTypeChange(value)}
                            // existing function
                            // onChange={(value) => {
                            //   handleEditMedicineChange("medicinetype", value);

                            //   if (value === "Syrup" || value === "Drops") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Tablet") {
                            //     handleEditMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Capsule") {
                            //     handleEditMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Injection") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Ointment") {
                            //     handleEditMedicineChange("dosageunit", "grms");
                            //   } else if (value === "Nebulization") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "IVFluids") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Inhaler") {
                            //     handleEditMedicineChange("dosageunit", "puffs")
                            //   }
                            // }}
                          >
                            <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">

<Radio colorScheme="green" value="Tablet">Tablet</Radio>
                                    <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                                    <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                                    <Radio colorScheme="green" value="Drops">Drops</Radio>
                                    <Radio colorScheme="green" value="Injection">Injection</Radio>
                                    <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                                    <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                                    <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                                    <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                                    <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                                    <Radio colorScheme="green" value="Cream">Cream</Radio>
                                    <Radio colorScheme="green" value="Gel">Gel</Radio>
                              {/* <Radio value="Tablet">Tablet</Radio>
                              <Radio value="Syrup">Syrup</Radio>
                              <Radio value="Drops">Drops</Radio>
                              <Radio value="Capsule">Capsule</Radio>
                              <Radio value="Injection">Injection</Radio>
                              <Radio value="Ointment">
                                Ointments / Creams / Gels
                              </Radio>
                              <Radio value="Nebulization">Nebulization</Radio>
                              <Radio value="IVFluids">IV Fluids</Radio>
                              <Radio value="Inhaler">Inhaler</Radio> */}
                            <Text>-Or-</Text>
                            <Box mx='1rem'>

                            <DropdownInput
                                variant="bothSide"
                                dropDownPlace="More Medicine Types"
                                options={additionalMedicineTypes}
                                onClick={(value) => handleEditTypeChange(value)}
                                value={dropdownMedType}
                                defaultOption={dropdownMedType || "Select more types"}
                              />
                            </Box>
                            </Stack>
                          </RadioGroup>
                          <Divider />
                          <Box>
                            <Box display="flex" flexDir="row">
                              {/* <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "mg", value: "mg" },
                                  { label: "ml", value: "ml" },
                                  { label: "grms", value: "grms" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  editMedicine.medicinetype == "Syrup" ||
                                  editMedicine.medicinetype == "Drops" ||
                                  editMedicine.medicinetype == "Injection" ||
                                  editMedicine.medicinetype == "Nebulization" ||
                                  editMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Dosage"
                                }
                                defaultValue={editMedicine.dosage}
                                defaultOptionProp={editMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleEditMedicineChange(
                                    "dosageunit",
                                    value.label
                                  )
                                }
                                // changes here
                                handleInputChange={(event) =>
                                  handleEditMedicineChange(
                                    "dosage",
                                    // event.target.value
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                inputVal={editMedicine.dosage}
                                maxLength="6"
                              /> */}

{editMedicine.medicinetype === "Tablet" || 
 editMedicine.medicinetype === "Capsule" || 
 editMedicine.medicinetype === "Suppository" || 
 editMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Inhaler" || 
    editMedicine.medicinetype === "Spray" || 
    editMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Syrup" ||
    editMedicine.medicinetype === "Drops" ||
    editMedicine.medicinetype === "Injection" ||
    editMedicine.medicinetype === "Nebulization" ||
    editMedicine.medicinetype === "IVFluids" ||
    editMedicine.medicinetype === "Suspension" ||
    editMedicine.medicinetype === "Respules" ||
    editMedicine.medicinetype === "Gargle" ||
    editMedicine.medicinetype === "Shampoo" ||
    editMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Ointment" ||
    editMedicine.medicinetype === "Cream" ||
    editMedicine.medicinetype === "Gel" ||
    editMedicine.medicinetype === "Foam" ||
    editMedicine.medicinetype === "Lotion" ||
    editMedicine.medicinetype === "Tube" ||
    editMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight/Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "EA" || 
    editMedicine.medicinetype === "Device" || 
    editMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={editMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
)}
{/* latest exsiting */}
{/* {editMedicine.medicinetype == "Tablet" || editMedicine.medicinetype == "Capsule" ?
                        (
                          <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "mg", value: "mg" },
                                  { label: "mcg", value: "mcg" },
                                  { label: "g", value: "g" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  editMedicine.medicinetype == "Syrup" ||
                                  editMedicine.medicinetype == "Drops" ||
                                  editMedicine.medicinetype == "Injection" ||
                                  editMedicine.medicinetype == "Nebulization" ||
                                  editMedicine.medicinetype == "Inhaler" ||
                                  editMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={editMedicine.dosage}
                                defaultOptionProp={editMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleEditMedicineChange(
                                    "dosageunit",
                                    value.label
                                  )
                                }
                                // changes here
                                handleInputChange={(event) =>
                                  handleEditMedicineChange(
                                    "dosage",
                                    // event.target.value
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                inputVal={editMedicine.dosage}
                                maxLength="6"
                              />
                        ): editMedicine.medicinetype === "Inhaler" ? (
                          <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "puffs", value: "puffs" },
                                  { label: "ml", value: "ml" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  editMedicine.medicinetype == "Syrup" ||
                                  editMedicine.medicinetype == "Drops" ||
                                  editMedicine.medicinetype == "Injection" ||
                                  editMedicine.medicinetype == "Nebulization" ||
                                  editMedicine.medicinetype == "Inhaler" ||
                                  editMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={editMedicine.dosage}
                                defaultOptionProp={editMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleEditMedicineChange(
                                    "dosageunit",
                                    value.label
                                  )
                                }
                                // changes here
                                handleInputChange={(event) =>
                                  handleEditMedicineChange(
                                    "dosage",
                                    // event.target.value
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                inputVal={editMedicine.dosage}
                                maxLength="6"
                              />
                        ) : editMedicine.medicinetype === "Ointment" ? (
                          <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "mg", value: "mg" },
                                  { label: "ml", value: "ml" },
                                  { label: "grms", value: "grms" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  editMedicine.medicinetype == "Syrup" ||
                                  editMedicine.medicinetype == "Drops" ||
                                  editMedicine.medicinetype == "Injection" ||
                                  editMedicine.medicinetype == "Nebulization" ||
                                  editMedicine.medicinetype == "Inhaler" ||
                                  editMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={editMedicine.dosage}
                                defaultOptionProp={editMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleEditMedicineChange(
                                    "dosageunit",
                                    value.label
                                  )
                                }
                                // changes here
                                handleInputChange={(event) =>
                                  handleEditMedicineChange(
                                    "dosage",
                                    // event.target.value
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                inputVal={editMedicine.dosage}
                                maxLength="6"
                              />
                        ) : (
                          <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "ml", value: "ml" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  editMedicine.medicinetype == "Syrup" ||
                                  editMedicine.medicinetype == "Drops" ||
                                  editMedicine.medicinetype == "Injection" ||
                                  editMedicine.medicinetype == "Nebulization" ||
                                  editMedicine.medicinetype == "Inhaler" ||
                                  editMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={editMedicine.dosage}
                                defaultOptionProp={editMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleEditMedicineChange(
                                    "dosageunit",
                                    value.label
                                  )
                                }
                                // changes here
                                handleInputChange={(event) =>
                                  handleEditMedicineChange(
                                    "dosage",
                                    // event.target.value
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                inputVal={editMedicine.dosage}
                                maxLength="6"
                              />
                        )} */}


                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Qty"
                                options={["0.5", "1", "2", "3", "4"]}
                                onClick={(value) =>
                                  handleEditMedicineChange("frequency", value)
                                }
                                defaultOption={editMedicine.frequency}
                                value={editMedicine.frequency}
                              />

                              <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : editMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  onClick={handleIntervalChange} // Handle changes with setIntervalOption
                                  // defaultOption={intervalOption}
                                  defaultOption={editMedicine.durationunit}
                                  value={editMedicine.durationunit}
                                />

                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  defaultValue={editMedicine.durationvalue}
                                  // defaultValue={intervalValue}
                                  onChange={handleIntervalValueChange}
                                  
                                  inputPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />

                                <DatePicker
                                  dateWidth="50%"
                                  defaultDate={editMedicine.medicationstartdate}
                                  // minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationstartdate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"Start Date"}
                                  calendarStlye={{
                                    left: "-18px",
                                    right: "unset",
                                  }}
                                />
                                <DatePicker
                                  dateWidth="50%"
                                  key={editMedicine.medicationenddate}
                                  defaultDate={editMedicine.medicationenddate}
                                  disableDatePicker={true}
                                  // minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationenddate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"End Date"}
                                  calendarStlye={{
                                    transform: "scale(0.9)",
                                    right: "-22px",
                                    top: "30px",
                                    pointerEvents: "none", // Disable interaction
                                    opacity: 0.5, // Visually indicate disabled state
                                  }}
                                />

                            </Box>
                            {/* <Flex
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                            >
                              <Box width="45%">
                                <Select
                                  value={intervalOption}
                                  onChange={handleIntervalChange}
                                  placeholder="Select Interval"
                                >
                                  <option value="Days">Days</option>
                                  <option value="Weeks">Weeks</option>
                                  <option value="Months">Months</option>
                                  <option value="Years">Years</option>
                                </Select>
                              </Box>
                              <Box width="45%">
                                <RadioGroup
                                  value={radioValue}
                                  onChange={handleRadioChange}
                                >
                                  <Stack direction="row" spacing={4}>
                                    <Radio value="1">1</Radio>
                                    <Radio value="2">2</Radio>
                                    <Radio value="3">3</Radio>
                                    <Radio value="4">4</Radio>
                                    <Radio value="5">5</Radio>
                                    <Radio value="6">6</Radio>
                                  </Stack>
                                </RadioGroup>
                              </Box>
                            </Flex> */}

                            {/* <Box display="flex" flexDir="row">
                            <Box width="25%"
                            >
                                <Select
                                  value={intervalOption}
                                  onChange={handleIntervalChange}
                                  placeholder="Select Interval"
                                >
                                  <option value="Days">Days</option>
                                  <option value="Weeks">Weeks</option>
                                  <option value="Months">Months</option>
                                  <option value="Years">Years</option>
                                </Select>
                              </Box>
                              <DatePicker
                                // disableFutureDates={true}
                                defaultDate={editMedicine.medicationstartdate}
                                minDate={newMedicine.medicationstartdate}
                                onDateChange={(selectedDateValue) =>
                                  handleEditMedicineChange(
                                    "medicationstartdate",
                                    selectedDateValue
                                  )
                                }
                                placeholderProp={"Start Date"}
                                calendarStlye={{
                                  left: "-18px",
                                  right: "unset",
                                }}
                              />
                              <DatePicker
                                key={editMedicine.medicationenddate} 
                                defaultDate={editMedicine.medicationenddate}
                                minDate={newMedicine.medicationstartdate}
                                onDateChange={(selectedDateValue) =>
                                  handleEditMedicineChange(
                                    "medicationenddate",
                                    selectedDateValue
                                  )
                                }
                                placeholderProp={"End Date"}
                                calendarStlye={{
                                  transform: "scale(0.9)",
                                  right: "-22px",
                                  top: "30px",
                                }}
                              />
                            </Box> */}

{/* --------------------------------------- code commented dont delete */}
                            {/* <Box display="flex" flexDir="row">
                              <Box width="25%">
                                <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : editMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  onClick={handleIntervalChange} // Handle changes with setIntervalOption
                                  defaultOption={intervalOption}
                                />
                              </Box>
                              <Box width="25%">
                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  defaultValue={intervalValue}
                                  onChange={handleIntervalValueChange}
                                  inputPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />
                              </Box>
                              <Box width={"50%"} display="flex" flexDir="row">
                                <DatePicker
                                  dateWidth="50%"
                                  defaultDate={editMedicine.medicationstartdate}
                                  // minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationstartdate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"Start Date"}
                                  calendarStlye={{
                                    left: "-18px",
                                    right: "unset",
                                  }}
                                />
                                <DatePicker
                                  dateWidth="50%"
                                  key={editMedicine.medicationenddate}
                                  defaultDate={editMedicine.medicationenddate}
                                  disableDatePicker={true}
                                  // minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleEditMedicineChange(
                                      "medicationenddate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"End Date"}
                                  calendarStlye={{
                                    transform: "scale(0.9)",
                                    right: "-22px",
                                    top: "30px",
                                    pointerEvents: "none", // Disable interaction
                                    opacity: 0.5, // Visually indicate disabled state
                                  }}
                                />
                              </Box>
                            </Box> */}
{/* --------------------------------------- code commented dont delete */}

                            <Box display="flex" flexDir="row">
                              {editMedicine.medicinetype == "Injection" && (
                                <>
                                  <Box width={"50%"}>
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Route of Administration"
                                      options={[
                                        "Intravenous (IV)",
                                        "Intramuscular (IM)",
                                        "Subcutaneous (SC)",
                                      ]}
                                      onClick={(value) =>
                                        handleEditMedicineChange(
                                          "routeofadministration",
                                          value
                                        )
                                      }
                                      defaultOption={
                                        editMedicine.routeofadministration
                                      }
                                    />
                                  </Box>
                                  <Box width={"50%"}>
                                    <PrimaryInput
                                      variant={"bothSide"}
                                      onChange={(e) =>
                                        handleEditMedicineChange(
                                          "timingofinjection",
                                          e.target.value
                                        )
                                      }
                                      inputPlace="Timing"
                                      defaultValue={
                                        editMedicine.timingofinjection
                                      }
                                    />
                                  </Box>
                                </>
                              )}
                              {editMedicine.medicinetype == "Ointment" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Quantity"
                                    options={[
                                      "Pea-sized",
                                      "Thin layer",
                                      "Fingertip unit (FTU)",
                                      "Half a fingertip",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange(
                                        "quantitytobeapplied",
                                        value
                                      )
                                    }
                                    defaultOption={
                                      editMedicine.quantitytobeapplied
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditMedicineChange(
                                        "areaofapplication",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Area of Application"
                                    defaultValue={
                                      editMedicine.areaofapplication
                                    }
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "Nebulization" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Diluent"
                                    options={[
                                      "Normal saline",
                                      "Distilled water",
                                      "3% saline",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange("diluent", value)
                                    }
                                    defaultOption={editMedicine.diluent}
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "IVFluids" && (
                                <>
                                  <MiniDropdownInput
                                    variant="bothside"
                                    options={[
                                      { label: "ml/hr", value: "ml/hr" },
                                      { label: "ml/min", value: "ml/min" },
                                      // { label: "mg/hr", value: "mg/hr" },
                                      // { label: "grms/hr", value: "grms/hr" },
                                    ]}
                                    handleInputChange={(e) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionvalue",
                                        validationOfNumberWithOnly1Decimal(
                                          e.target.value
                                        )
                                      )
                                    }
                                    placeholderProp={"Rate of Infusion"}
                                    onSelect={(selectedOption) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionunit",
                                        selectedOption.label
                                      )
                                    }
                                    maxLength="6"
                                    defaultOptionProp={
                                      editMedicine.rateofinfusionunit
                                    }
                                    defaultValue={
                                      editMedicine.rateofinfusionvalue
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditMedicineChange(
                                        "additives",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Additives"
                                    defaultValue={editMedicine.additives}
                                  />
                                </>
                              )}
                            </Box>

                            <CheckboxGroup colorScheme="green">
  <Stack spacing={2} alignItems='center' pt="20px" direction="row" flexWrap="wrap">
    {/* Time checkboxes */}
    <Checkbox
      isChecked={editMedicine.morning === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (editMedicine.morning !== 1) {
          handleEditMedicineChange("frequencytime", "");
          handleEditMedicineChange("frequencyvalue", "");
        }
        handleEditMedicineChange(
          "morning",
          editMedicine.morning === 1 ? 0 : 1
        );
      }}
    >
      Morning
    </Checkbox>
    
    <Checkbox
      isChecked={editMedicine.afternoon === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (editMedicine.afternoon !== 1) {
          handleEditMedicineChange("frequencytime", "");
          handleEditMedicineChange("frequencyvalue", "");
        }
        handleEditMedicineChange(
          "afternoon",
          editMedicine.afternoon === 1 ? 0 : 1
        );
      }}
    >
      Afternoon
    </Checkbox>
    
    <Checkbox
      isChecked={editMedicine.night === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (editMedicine.night !== 1) {
          handleEditMedicineChange("frequencytime", "");
          handleEditMedicineChange("frequencyvalue", "");
        }
        handleEditMedicineChange(
          "night",
          editMedicine.night === 1 ? 0 : 1
        );
      }}
    >
      Night
    </Checkbox>

    <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>

    {/* Frequency inputs */}
    <Box width='130px'>
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Frequency"
        options={["Hours", "Daily", "Weekly"]}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting frequency
          if (value) {
            handleEditMedicineChange("morning", 0);
            handleEditMedicineChange("afternoon", 0);
            handleEditMedicineChange("night", 0);
          }
          handleEditMedicineChange("frequencytime", value || 0);
        }}
        // defaultOption={"Hours"}
        value={editMedicine.frequencytime}
      />
    </Box>

    <Box width='80px'>

      {/* <DropdownInputForVitals
                              variant="fullSide"
                              dropDownPlace="Referral Doctor"
                              options={referralUsersList}
                              onClick={handleUsersChange}
                              onChange={usersChange}
                              readOnly=""
                              inputStyleCss={{w: "100%"}}
                              inputValueProp={referralDoctor}
                              menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                              // maxLength={2}
                            /> */}
      <DropdownInputForVitals
        variant="bothSide"
        dropDownPlace="Value"
        options={["1", "2", "3", "4", "8"]}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting value
          if (value) {
            handleEditMedicineChange("morning", 0);
            handleEditMedicineChange("afternoon", 0);
            handleEditMedicineChange("night", 0);
            handleEditMedicineChange("frequencyvalue", value);
          }
        }}
        onChange={(e) => {
          // Handle manual text input for value
          const value = e.target.value;
          if (value) {
            handleEditMedicineChange("morning", 0);
            handleEditMedicineChange("afternoon", 0);
            handleEditMedicineChange("night", 0);
          }
          handleEditMedicineChange("frequencyvalue", value);
        }}
        // value={editMedicine.frequencyvalue}
  inputValueProp={editMedicine.frequencyvalue || ""}
      />
      {/* <DropdownInput
        variant="bothSide"
        dropDownPlace="Value"
        options={["1", "2", "3", "4", "8"]}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting value
          if (value) {
            handleEditMedicineChange("morning", 0);
            handleEditMedicineChange("afternoon", 0);
            handleEditMedicineChange("night", 0);
          }
          handleEditMedicineChange("frequencyvalue", value || "");
        }}
        onChange={(e) => {
          // Handle manual text input for value
          const value = e.target.value;
          if (value) {
            handleEditMedicineChange("morning", 0);
            handleEditMedicineChange("afternoon", 0);
            handleEditMedicineChange("night", 0);
          }
          handleEditMedicineChange("frequencyvalue", value || "");
        }}
        value={editMedicine.frequencyvalue}
      /> */}
    </Box>

<Spacer />
    {/* Food timing radio buttons */}
    <RadioGroup
      value={editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
      onChange={(value) => {
        if (value === "beforefood") {
          handleEditMedicineChange("beforefood", 1);
          handleEditMedicineChange("afterfood", 0);
        } else if (value === "afterfood") {
          handleEditMedicineChange("beforefood", 0);
          handleEditMedicineChange("afterfood", 1);
        }
      }}
    >
      <Radio value="beforefood" colorScheme="green">Before Food</Radio>
      <Radio value="afterfood" ml='0.5rem' colorScheme="green">After Food</Radio>
    </RadioGroup>
  </Stack>
</CheckboxGroup>

                            <Divider my="10px" />

{/* <PrimaryInput
  variant={"bothSide"}
  onChange={(e) => handleEditMedicineChange("sos", e.target.value )}
  // defaultValue={editMedicine.sos}
  inputPlace="SOS"
  inputValue={editMedicine.sos}
  
/> */}
<Textarea
  borderRadius='0'
  placeholder="Instructions"
  defaultValue={editMedicine.instructions}
  // defaultValue={editMedicine.custommessage}
  // onChange={handleCustomMessage}
  onChange={(e) => handleEditMedicineChange("instructions", e.target.value )}
  inputValue={editMedicine.instructions}
/>

<Divider my="10px" />
                          </Box>
                          <Divider />
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap="10px"
                          >
                            {/* <Button onClick={() => setEditMedicine(null)}>
                            Cancel
                          </Button> */}
                            <PrimaryButton
                              buttonText="Cancel"
                              variant="grayBtn"
                              btnStyle={{
                                w: "15%",
                                color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                              onClick={() => setEditMedicine(null)}
                              isDisabled={false}
                            />
                            {/* <Button
                            colorScheme="blue"
                            onClick={handleSaveEditMedicine}
                          >
                            Save
                          </Button> */}
                            <PrimaryButton
                              buttonText="Save"
                              onClick={handleSaveEditMedicine}
                              isDisabled={false}
                              btnStyle={{
                                w: "25%",
                                //   color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                            />
                          </Box>
                        </Stack>
                      </Box>
                    )}
              </Box>
            ))}
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Discard"
              btnStyle={{
                w: "48%",
                h: "2.5rem",
              }}
              onClick={() => {
                setEditMedicine(null);
                aiRecommendMedicineRef.current.closeModal();
              }}
            />

            <Spacer />

            <PrimaryButton
              buttonText="Save selected items"
              variant="grayBtn"
              btnStyle={{
                w: "48%",
                color: COLORS.PRIMARY_COLOR,
                h: "2.5rem",
              }}
              isDisabled={!(selectedRecommendedMedicinesAiResponses.length > 0)}
              onClick={() => {
                setEditMedicine(null);
                saveSelectedRecommendedMedicinesToOrder();
                aiRecommendMedicineRef.current.closeModal();
              }}
            />
          </>
        }
      />

      <DynamicModalForTwo
        ref={aiROSReviewRef}
        hasFooter={false}
        modalWidth="75%"
        modalHeader={`Aira - AI: Review Of System`}
        modalBody={
          <>
            <Box width={"75%"} mx="auto" mt="1rem">
              {aiRosResponse && aiRosResponse?.ros && (
                <AiROSCard
                  patientId={patientId}
                  doctorId={doctorId}
                  appointmentId={appointmentId}
                  showSuccessToast={showSuccessToast}
                  showErrorToast={showErrorToast}
                  aiResponseROS={aiResponse?.ros}
                />
              )}
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Close"
              btnStyle={{
                w: "48%",
                h: "2.5rem",
              }}
              onClick={() => {
                aiROSReviewRef.current.closeModal();
              }}
            />
          </>
        }
      />

      <DynamicModalForTwo
        ref={aiVitalsReviewRef}
        hasFooter={false}
        modalWidth="50%"
        // modalHeader={`Aira - AI: Review Of System`}
        modalHeader={`Aira - AI: Vitals`}
        modalBody={
          <>
            <Box width={"75%"} mx="auto" mt="1rem">
              {aiPatientResponse && aiPatientResponse?.patient_vitals && (
                <AIRAVitalsForm
                  patientId={patientId}
                  doctorId={doctorId}
                  appointmentId={appointmentId}
                  showSuccessToast={showSuccessToast}
                  showErrorToast={showErrorToast}
                  AiVitals={transformVitals(aiVitalsResponse?.vitals || [])}
                  // Pass the modal close function
            onCloseModal={() => aiVitalsReviewRef.current?.closeModal?.()}
                />
              )}
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Close"
              btnStyle={{
                w: "48%",
                h: "2.5rem",
              }}
              onClick={() => {
                aiVitalsReviewRef.current.closeModal();
              }}
            />
          </>
        }
      />
    </>
  );
};

export default TranscriptNotesCard;
